import { z } from 'zod'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  ISO8601DateTime: { input: any; output: any }
}

export enum AdvisorSortEnum {
  Clients = 'CLIENTS',
  JobsAdded = 'JOBS_ADDED',
  JobsShared = 'JOBS_SHARED',
}

export type AdvisorUsers = {
  __typename?: 'AdvisorUsers'
  id: Scalars['ID']['output']
  jobsAdded: Array<UsersJobs>
  jobsShared: Array<UsersJobs>
  user: Users
}

export type AdvisoryOrganization = {
  __typename?: 'AdvisoryOrganization'
  brand: AdvisoryOrganizationBrand
  id: Scalars['ID']['output']
  members: Array<Users>
  name: Scalars['String']['output']
  subscriptionStatus: AdvisoryOrganizationSubscriptionStatusEnum
}

export type AdvisoryOrganizationBrand = {
  __typename?: 'AdvisoryOrganizationBrand'
  logoUrl: Scalars['String']['output']
}

export enum AdvisoryOrganizationSubscriptionStatusEnum {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  PastDue = 'PAST_DUE',
  Trial = 'TRIAL',
}

export type AmIaGoodFit = {
  __typename?: 'AmIAGoodFit'
  overallMatch?: Maybe<UsersJobsMatchEnum>
  overallSummary?: Maybe<Scalars['String']['output']>
  relevantEducation?: Maybe<Scalars['String']['output']>
  relevantEducationMatch?: Maybe<Scalars['Boolean']['output']>
  relevantExperience?: Maybe<Scalars['String']['output']>
  relevantExperienceMatch?: Maybe<Scalars['Boolean']['output']>
  relevantSkills?: Maybe<Scalars['String']['output']>
  relevantSkillsMatch?: Maybe<Scalars['Boolean']['output']>
}

export enum AuthProviderTypeEnum {
  Google = 'GOOGLE',
}

export type AuthResponse = {
  __typename?: 'AuthResponse'
  isNewUser?: Maybe<Scalars['Boolean']['output']>
  token?: Maybe<Scalars['ID']['output']>
  user?: Maybe<Users>
}

export type CachedStreamingType = {
  __typename?: 'CachedStreamingType'
  isSync: Scalars['Boolean']['output']
  result: Scalars['String']['output']
}

export type CareerPathsPostType = {
  __typename?: 'CareerPathsPostType'
  category?: Maybe<Scalars['String']['output']>
  exampleImageUrl?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  nameSlug?: Maybe<Scalars['String']['output']>
}

export type ClientGroup = {
  __typename?: 'ClientGroup'
  clients: Array<ClientUsers>
  createdAt: Scalars['ISO8601DateTime']['output']
  createdByUser: Users
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ClientUsers = {
  __typename?: 'ClientUsers'
  addedJobs: Array<UsersJobs>
  allJobs: Array<UsersJobs>
  appliedJobs: Array<UsersJobs>
  id: Scalars['ID']['output']
  interviewedJobs: Array<UsersJobs>
  numAddedJobs: Scalars['Int']['output']
  numAllJobs: Scalars['Int']['output']
  numAppliedJobs: Scalars['Int']['output']
  numInterviewedJobs: Scalars['Int']['output']
  numOfferedJobs: Scalars['Int']['output']
  numRejectedJobs: Scalars['Int']['output']
  offeredJobs: Array<UsersJobs>
  rejectedJobs: Array<UsersJobs>
  user: Users
}

export type CompanyAboutInfo = {
  __typename?: 'CompanyAboutInfo'
  companyLogo?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  foundedYear?: Maybe<Scalars['Int']['output']>
  industry?: Maybe<Scalars['String']['output']>
  linkedinCompanyUrl?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  numberOfEmployeeRangeMax?: Maybe<Scalars['Int']['output']>
  numberOfEmployeeRangeMin?: Maybe<Scalars['Int']['output']>
  websiteUrl?: Maybe<Scalars['String']['output']>
}

export type CompanyLatestInfo = {
  __typename?: 'CompanyLatestInfo'
  accomplishmentsAndAnnouncementsAndProductReleases?: Maybe<Array<CompanyLatestInfoSource>>
  companyCultureAndPractices?: Maybe<Scalars['String']['output']>
  competitors?: Maybe<Array<CompanyLatestInfoCompetitors>>
  expectedSalaryMessage?: Maybe<Scalars['String']['output']>
  fundingsRounds?: Maybe<Array<CompanyLatestInfoSource>>
  growthFinancialNumbers?: Maybe<Array<CompanyLatestInfoSource>>
  maximumSalary?: Maybe<Scalars['Int']['output']>
  minimumSalary?: Maybe<Scalars['Int']['output']>
  missionAndVisionOfCompany?: Maybe<Scalars['String']['output']>
}

export type CompanyLatestInfoCompetitors = {
  __typename?: 'CompanyLatestInfoCompetitors'
  name: Scalars['String']['output']
  website: Scalars['String']['output']
}

export type CompanyLatestInfoSource = {
  __typename?: 'CompanyLatestInfoSource'
  description: Scalars['String']['output']
  source: Scalars['String']['output']
}

export type Contacts = {
  __typename?: 'Contacts'
  email?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
}

export type ContactsInputObject = {
  email: Scalars['String']['input']
  name: Scalars['String']['input']
}

export enum CoverLetterLengthEnum {
  Long = 'LONG',
  Medium = 'MEDIUM',
  Short = 'SHORT',
}

export enum CoverLetterToneEnum {
  Casual = 'CASUAL',
  Excited = 'EXCITED',
  Formal = 'FORMAL',
  Informational = 'INFORMATIONAL',
}

export enum FakeJobConcernLevelEnum {
  High = 'HIGH',
  None = 'NONE',
  Some = 'SOME',
}

export type FakeJobInfo = {
  __typename?: 'FakeJobInfo'
  fakeJobConcernLevel: FakeJobConcernLevelEnum
  glassdoorRating?: Maybe<Scalars['Float']['output']>
  glassdoorRatingConcernLevel: FakeJobConcernLevelEnum
  jobPostingDateConcernLevel: FakeJobConcernLevelEnum
  overallConcernLevel: FakeJobConcernLevelEnum
}

export type FieldMessageType = {
  __typename?: 'FieldMessageType'
  errorMessage?: Maybe<Scalars['String']['output']>
  field: Scalars['String']['output']
}

/** Autogenerated return type of FormFieldsMapping. */
export type FormFieldsMappingPayload = {
  __typename?: 'FormFieldsMappingPayload'
  content: Scalars['String']['output']
  final: Scalars['Boolean']['output']
  i?: Maybe<Scalars['Int']['output']>
  initial: Scalars['Boolean']['output']
  requestId: Scalars['String']['output']
}

export type FormFieldsValueMapping = {
  __typename?: 'FormFieldsValueMapping'
  htmlSelector?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

/** Autogenerated return type of GlassdoorResults. */
export type GlassdoorResultsPayload = {
  __typename?: 'GlassdoorResultsPayload'
  initial: Scalars['Boolean']['output']
  rating?: Maybe<Scalars['Float']['output']>
  requestId: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
  usersJobId: Scalars['ID']['output']
  whatConsUsersAreSaying?: Maybe<Scalars['String']['output']>
  whatConsUsersAreSayingAboutPosition?: Maybe<Scalars['String']['output']>
  whatProsUsersAreSaying?: Maybe<Scalars['String']['output']>
  whatProsUsersAreSayingAboutPosition?: Maybe<Scalars['String']['output']>
}

export type HeadshotRequest = {
  __typename?: 'HeadshotRequest'
  attire: HeadshotRequestsAttireEnum
  background: HeadshotRequestsBackgroundEnum
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  picturesUrl: Array<Scalars['String']['output']>
  status: HeadshotRequestsStatusEnum
}

export enum HeadshotRequestsAttireEnum {
  BusinessCasual = 'BUSINESS_CASUAL',
  BusinessProfessional = 'BUSINESS_PROFESSIONAL',
  SmartCasual = 'SMART_CASUAL',
}

export enum HeadshotRequestsBackgroundEnum {
  City = 'CITY',
  Nature = 'NATURE',
  Office = 'OFFICE',
  Studio = 'STUDIO',
}

export enum HeadshotRequestsStatusEnum {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
}

export type Interview = {
  __typename?: 'Interview'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  interviewType: InterviewsTypeEnum
  jobTitle: Scalars['String']['output']
  messages: Array<InterviewsMessage>
  score?: Maybe<Scalars['Int']['output']>
  status: InterviewsStatusEnum
}

export type InterviewQuestionsPostType = {
  __typename?: 'InterviewQuestionsPostType'
  category?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  nameSlug?: Maybe<Scalars['String']['output']>
}

export type InterviewsMessage = {
  __typename?: 'InterviewsMessage'
  fromUser: Scalars['Boolean']['output']
  message: Scalars['String']['output']
}

export enum InterviewsStatusEnum {
  Cancelled = 'CANCELLED',
  Finished = 'FINISHED',
  Started = 'STARTED',
}

export enum InterviewsTypeEnum {
  IntroRecruiterScreen = 'INTRO_RECRUITER_SCREEN',
  JobInterviewBehavioralTechnical = 'JOB_INTERVIEW_BEHAVIORAL_TECHNICAL',
}

export enum JobListingDatePostedEnum {
  Last_1Day = 'LAST_1_DAY',
  Last_7Days = 'LAST_7_DAYS',
  Last_14Days = 'LAST_14_DAYS',
  Last_30Days = 'LAST_30_DAYS',
}

export enum JobListingEducationLevelEnum {
  AssociateDegree = 'ASSOCIATE_DEGREE',
  BachelorDegree = 'BACHELOR_DEGREE',
  HighSchool = 'HIGH_SCHOOL',
  PostgraduateDegree = 'POSTGRADUATE_DEGREE',
  ProfessionalCertificate = 'PROFESSIONAL_CERTIFICATE',
}

export enum JobListingEmploymentTypeEnum {
  Contractor = 'CONTRACTOR',
  FullTime = 'FULL_TIME',
  Intern = 'INTERN',
  Other = 'OTHER',
  PartTime = 'PART_TIME',
  PerDiem = 'PER_DIEM',
  Temporary = 'TEMPORARY',
  Volunteer = 'VOLUNTEER',
}

export enum JobListingExperienceLevelEnum {
  DirectorLevel = 'DIRECTOR_LEVEL',
  EntryLevel = 'ENTRY_LEVEL',
  ExecutiveLevel = 'EXECUTIVE_LEVEL',
  InternshipLevel = 'INTERNSHIP_LEVEL',
  MidLevel = 'MID_LEVEL',
  SeniorLevel = 'SENIOR_LEVEL',
}

export enum JobListingFoundedDateEnum {
  Last_1Year = 'LAST_1_YEAR',
  Last_3Months = 'LAST_3_MONTHS',
  Last_3Years = 'LAST_3_YEARS',
  Last_5Years = 'LAST_5_YEARS',
  Last_6Months = 'LAST_6_MONTHS',
  Last_10Years = 'LAST_10_YEARS',
}

export enum JobListingPayPeriodEnum {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
}

export type JobListingSavedSearch = {
  __typename?: 'JobListingSavedSearch'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  searchFilters: JobListingsFilter
}

export enum JobListingWorkArrangementEnum {
  Hybrid = 'HYBRID',
  OnSite = 'ON_SITE',
  RemoteOk = 'REMOTE_OK',
  RemoteSolely = 'REMOTE_SOLELY',
}

export type JobListings = {
  __typename?: 'JobListings'
  aiCoreResponsibilities?: Maybe<Scalars['String']['output']>
  aiEducationRequirements?: Maybe<Array<JobListingEducationLevelEnum>>
  aiKeywords?: Maybe<Array<Scalars['String']['output']>>
  aiRequirementsSummary?: Maybe<Scalars['String']['output']>
  aiTaxonomiesA?: Maybe<Array<Scalars['String']['output']>>
  aiWorkArrangement?: Maybe<JobListingWorkArrangementEnum>
  benefits: Array<Scalars['String']['output']>
  companyDescription?: Maybe<Scalars['String']['output']>
  companyDomain?: Maybe<Scalars['String']['output']>
  companyIndustry?: Maybe<Scalars['String']['output']>
  companyLinkedinUrl?: Maybe<Scalars['String']['output']>
  companyLogoUrl?: Maybe<Scalars['String']['output']>
  companyName: Scalars['String']['output']
  companyNumEmployees?: Maybe<Scalars['Int']['output']>
  companySpecialties: Array<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  datePosted: Scalars['ISO8601DateTime']['output']
  employmentType?: Maybe<JobListingEmploymentTypeEnum>
  employmentTypes: Array<JobListingEmploymentTypeEnum>
  experienceLevelMax?: Maybe<Scalars['Int']['output']>
  experienceLevelMin?: Maybe<Scalars['Int']['output']>
  experienceLevelString?: Maybe<Scalars['String']['output']>
  expired: Scalars['Boolean']['output']
  externalApplyUrl?: Maybe<Scalars['String']['output']>
  hiringManagerEmail?: Maybe<Scalars['String']['output']>
  hiringManagerName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isRemote?: Maybe<Scalars['Boolean']['output']>
  jobDetails?: Maybe<Scalars['String']['output']>
  keySkills: Array<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  payPeriod?: Maybe<JobListingPayPeriodEnum>
  position: Scalars['String']['output']
  salaryCurrency?: Maybe<Scalars['String']['output']>
  salaryMax?: Maybe<Scalars['Int']['output']>
  salaryMin?: Maybe<Scalars['Int']['output']>
  url?: Maybe<Scalars['String']['output']>
  visaSponsorship: Scalars['Boolean']['output']
  workingHours?: Maybe<Scalars['Int']['output']>
}

export type JobListingsFilter = {
  __typename?: 'JobListingsFilter'
  companyName?: Maybe<Scalars['String']['output']>
  companyNumEmployeesMax?: Maybe<Scalars['Int']['output']>
  companyNumEmployeesMin?: Maybe<Scalars['Int']['output']>
  datePosted?: Maybe<JobListingDatePostedEnum>
  datePostedMax?: Maybe<Scalars['ISO8601DateTime']['output']>
  datePostedMin?: Maybe<Scalars['ISO8601DateTime']['output']>
  educationRequirements?: Maybe<Array<JobListingEducationLevelEnum>>
  employmentTypes?: Maybe<Array<JobListingEmploymentTypeEnum>>
  experienceLevelMax?: Maybe<Scalars['Int']['output']>
  experienceLevelMin?: Maybe<Scalars['Int']['output']>
  experienceLevels?: Maybe<Array<JobListingExperienceLevelEnum>>
  foundedDate?: Maybe<JobListingFoundedDateEnum>
  keywordOr?: Maybe<Scalars['Boolean']['output']>
  keywords?: Maybe<Array<Scalars['String']['output']>>
  locations?: Maybe<Array<JobListingsLocation>>
  payPeriod?: Maybe<JobListingPayPeriodEnum>
  positions?: Maybe<Array<Scalars['String']['output']>>
  salaryMin?: Maybe<Scalars['Int']['output']>
  skills?: Maybe<Array<Scalars['String']['output']>>
  taxonomies?: Maybe<Array<Scalars['String']['output']>>
  visaSponsorship?: Maybe<Scalars['Boolean']['output']>
  workArrangements?: Maybe<Array<JobListingWorkArrangementEnum>>
}

export type JobListingsFilterInputObject = {
  companyName?: InputMaybe<Scalars['String']['input']>
  companyNumEmployeesMax?: InputMaybe<Scalars['Int']['input']>
  companyNumEmployeesMin?: InputMaybe<Scalars['Int']['input']>
  datePosted?: InputMaybe<JobListingDatePostedEnum>
  datePostedMax?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  datePostedMin?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  educationRequirements?: InputMaybe<Array<JobListingEducationLevelEnum>>
  employmentTypes?: InputMaybe<Array<JobListingEmploymentTypeEnum>>
  experienceLevelMax?: InputMaybe<Scalars['Int']['input']>
  experienceLevelMin?: InputMaybe<Scalars['Int']['input']>
  experienceLevels?: InputMaybe<Array<JobListingExperienceLevelEnum>>
  foundedDate?: InputMaybe<JobListingFoundedDateEnum>
  keywordOr?: InputMaybe<Scalars['Boolean']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  locations?: InputMaybe<Array<JobListingsLocationInputObject>>
  payPeriod?: InputMaybe<JobListingPayPeriodEnum>
  positions?: InputMaybe<Array<Scalars['String']['input']>>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  skills?: InputMaybe<Array<Scalars['String']['input']>>
  taxonomies?: InputMaybe<Array<Scalars['String']['input']>>
  visaSponsorship?: InputMaybe<Scalars['Boolean']['input']>
  workArrangements?: InputMaybe<Array<JobListingWorkArrangementEnum>>
}

export type JobListingsLocation = {
  __typename?: 'JobListingsLocation'
  location: Scalars['String']['output']
  radius?: Maybe<Scalars['Int']['output']>
  useCityStateForLocation?: Maybe<Scalars['Boolean']['output']>
}

export type JobListingsLocationInputObject = {
  location: Scalars['String']['input']
  radius?: InputMaybe<Scalars['Int']['input']>
  useCityStateForLocation?: InputMaybe<Scalars['Boolean']['input']>
}

export enum JobListingsSortEnum {
  DatePosted = 'DATE_POSTED',
}

export enum JobPostingSortEnum {
  ClientsApplied = 'CLIENTS_APPLIED',
  ClientsSharedWith = 'CLIENTS_SHARED_WITH',
}

export type JobSearchPreference = {
  __typename?: 'JobSearchPreference'
  companyNumEmployeesMax?: Maybe<Scalars['Int']['output']>
  companyNumEmployeesMin?: Maybe<Scalars['Int']['output']>
  datePosted?: Maybe<JobListingDatePostedEnum>
  educationRequirement?: Maybe<JobListingEducationLevelEnum>
  employmentTypes?: Maybe<Array<JobListingEmploymentTypeEnum>>
  experienceLevels?: Maybe<Array<JobListingExperienceLevelEnum>>
  keywords?: Maybe<Array<Scalars['String']['output']>>
  locations?: Maybe<Array<Scalars['String']['output']>>
  payPeriod?: Maybe<JobListingPayPeriodEnum>
  positions?: Maybe<Array<Scalars['String']['output']>>
  salaryMin?: Maybe<Scalars['Int']['output']>
  visaSponsorship?: Maybe<Scalars['Boolean']['output']>
  workArrangements?: Maybe<Array<JobListingWorkArrangementEnum>>
}

export type JobSearchPreferenceInputObject = {
  companyNumEmployeesMax?: InputMaybe<Scalars['Int']['input']>
  companyNumEmployeesMin?: InputMaybe<Scalars['Int']['input']>
  datePosted?: InputMaybe<JobListingDatePostedEnum>
  educationRequirement?: InputMaybe<JobListingEducationLevelEnum>
  employmentTypes?: InputMaybe<Array<JobListingEmploymentTypeEnum>>
  experienceLevels?: InputMaybe<Array<JobListingExperienceLevelEnum>>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  locations?: InputMaybe<Array<Scalars['String']['input']>>
  payPeriod?: InputMaybe<JobListingPayPeriodEnum>
  positions?: InputMaybe<Array<Scalars['String']['input']>>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  visaSponsorship?: InputMaybe<Scalars['Boolean']['input']>
  workArrangements?: InputMaybe<Array<JobListingWorkArrangementEnum>>
}

/** Autogenerated return type of LearnSkills. */
export type LearnSkillsPayload = {
  __typename?: 'LearnSkillsPayload'
  content: Scalars['String']['output']
  i?: Maybe<Scalars['Int']['output']>
  initial: Scalars['Boolean']['output']
  requestId: Scalars['String']['output']
  usersJobId: Scalars['ID']['output']
}

export type LinkedinCompany = {
  __typename?: 'LinkedinCompany'
  name: Scalars['String']['output']
  profilePicUrl?: Maybe<Scalars['String']['output']>
  website?: Maybe<Scalars['String']['output']>
}

export enum MessagesContactType {
  HiringManager = 'HIRING_MANAGER',
  Recruiter = 'RECRUITER',
  SimilarTitle = 'SIMILAR_TITLE',
}

export enum MessagesMessageType {
  FollowUpEmail = 'FOLLOW_UP_EMAIL',
  JobOutreach = 'JOB_OUTREACH',
  Networking = 'NETWORKING',
  ReferralRequest = 'REFERRAL_REQUEST',
  ThankYouPostInterview = 'THANK_YOU_POST_INTERVIEW',
}

export type Mutation = {
  __typename?: 'Mutation'
  addContactToUsersJob: UsersJobs
  addUsersToClientGroup: ClientGroup
  amIAGoodFit?: Maybe<AmIaGoodFit>
  assignClientToAdvisor: Scalars['String']['output']
  authPasswordResetRequest: Scalars['String']['output']
  authProviderAuthenticate: AuthResponse
  authResetPassword: Scalars['String']['output']
  authSignIn: AuthResponse
  authSignUp: AuthResponse
  billingPortalUrl: Scalars['String']['output']
  bookmarkJob: UsersJobs
  coverLetterBodyPrefillApplication: Scalars['String']['output']
  coverLetterUpsert: UsersJobsCoverLetterType
  createClientGroup: ClientGroup
  createFeedback: Scalars['String']['output']
  createHeadshotRequest: HeadshotRequest
  createResume: Resumes
  createResumeFromLinkedinUrl: Resumes
  createResumeUnauthenticated: Resumes
  createSearchFilter: JobListingSavedSearch
  createUsersJob: UsersJobs
  createWritingSample: Scalars['String']['output']
  downloadPdfResume: Resumes
  duplicateResume: Resumes
  duplicateResumeFromResumeExample: Resumes
  editClientGroup: ClientGroup
  exportUsersJobToCsv: Scalars['String']['output']
  fakeJobMutation: FakeJobInfo
  fetchJobKeywords: Array<Scalars['String']['output']>
  fetchMissingSkillsOfJobResume: Array<Scalars['String']['output']>
  fixFromRelevanceAnalysis: Resumes
  generateCompanyDomain: UsersJobs
  generateCoverLetter: UsersJobsCoverLetterType
  generateDraftEmailForSimilarProfile: SimilarProfilesMessage
  generateJobAchievement: Array<Scalars['String']['output']>
  generateJobAchievementFromString: Array<Scalars['String']['output']>
  generateMessageForContact: SimilarProfilesMessage
  generateOneJobAchievement: Scalars['String']['output']
  generateProfessionalSummary: Scalars['String']['output']
  interviewAddMessage: Interview
  interviewStartMock: Interview
  inviteAdvisor?: Maybe<Users>
  inviteClient?: Maybe<Users>
  jobsFormFieldsMapping: Array<FormFieldsValueMapping>
  jobsFormFieldsMappingV2: Scalars['String']['output']
  learnSkills: CachedStreamingType
  manuallyReportGhostJob: Scalars['String']['output']
  markJobListingAsApplied: UsersJobs
  matchScore: UsersJobsMatch
  optimizeResumeForJob: Resumes
  optimizeResumeForJobV2: Resumes
  previewAuthResume: Scalars['String']['output']
  previewResume: Scalars['String']['output']
  questionPrefillApplication: Scalars['String']['output']
  requestResumeReview: Scalars['String']['output']
  resumeRecentUploaded?: Maybe<Resumes>
  resumeRelevanceAnalysis: ResumesResumeRelevanceAnalysis
  roastResume: Scalars['String']['output']
  salaryInsights: Scalars['String']['output']
  sampleInterviewQuestions: CachedStreamingType
  scoreResume: ResumesScoreType
  shareJobWithClients: UsersJobs
  subscriptionsRedeemLtdPromoCode: Users
  subscriptionsRequestResumeSuccess: Scalars['String']['output']
  subscriptionsSessionCreate: Scalars['String']['output']
  subscriptionsSessionFetch: Scalars['String']['output']
  unbookmarkJob: UsersJobs
  updateAdvisoryOrganization: Users
  updateArchivedCoverLetter: UsersJobsCoverLetterType
  updateArchivedResume: Resumes
  updateLastPageLoadedAt: Users
  updatePdfBlob: Resumes
  updatePublicResume: Resumes
  updateResume: Resumes
  updateResumePreferences: Resumes
  updateResumeUnauthenticated: Resumes
  updateSearchFilter: JobListingSavedSearch
  updateShowOriginalDocumentResume: Resumes
  updateTemplateResume: Resumes
  updateUser: Users
  updateUsersJob: UsersJobs
  updateWritingSample: WritingSample
  uploadResume: Resumes
  uploadResumeWebsocket: Scalars['String']['output']
  usedChromeExtension: Scalars['String']['output']
  userEmailVerify: AuthResponse
  userStoreLocation: Users
  userUpdateWritingStyle: Users
  userUploadProfilePicture: Users
  userUpsertJobSearchPreference: JobSearchPreference
}

export type MutationAddContactToUsersJobArgs = {
  contact: ContactsInputObject
  id: Scalars['ID']['input']
}

export type MutationAddUsersToClientGroupArgs = {
  clientGroupId: Scalars['ID']['input']
  userIds: Array<Scalars['ID']['input']>
}

export type MutationAmIaGoodFitArgs = {
  jobDescription?: InputMaybe<Scalars['String']['input']>
  jobListingId?: InputMaybe<Scalars['ID']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  resumeId?: InputMaybe<Scalars['ID']['input']>
  usersJobId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationAssignClientToAdvisorArgs = {
  advisorId: Scalars['ID']['input']
  clientIds: Array<Scalars['ID']['input']>
}

export type MutationAuthPasswordResetRequestArgs = {
  email: Scalars['String']['input']
}

export type MutationAuthProviderAuthenticateArgs = {
  data: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  provider: AuthProviderTypeEnum
  referredByUserUniqueId?: InputMaybe<Scalars['ID']['input']>
  resumeNameSlug?: InputMaybe<Scalars['String']['input']>
  resumeUniqueId?: InputMaybe<Scalars['ID']['input']>
  utmSource?: InputMaybe<Scalars['String']['input']>
}

export type MutationAuthResetPasswordArgs = {
  newPassword: Scalars['String']['input']
  resetPasswordToken: Scalars['String']['input']
}

export type MutationAuthSignInArgs = {
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type MutationAuthSignUpArgs = {
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  referredByUserUniqueId?: InputMaybe<Scalars['ID']['input']>
  resumeNameSlug?: InputMaybe<Scalars['String']['input']>
  resumeUniqueId?: InputMaybe<Scalars['ID']['input']>
  utmSource?: InputMaybe<Scalars['String']['input']>
}

export type MutationBookmarkJobArgs = {
  jobListingId: Scalars['ID']['input']
  status: UsersJobsStatusEnum
}

export type MutationCoverLetterBodyPrefillApplicationArgs = {
  resumeId: Scalars['ID']['input']
  usersJobId: Scalars['ID']['input']
}

export type MutationCoverLetterUpsertArgs = {
  attributes: UsersJobsCoverLetterInputObject
  usersJobId: Scalars['ID']['input']
}

export type MutationCreateClientGroupArgs = {
  name: Scalars['String']['input']
}

export type MutationCreateFeedbackArgs = {
  feedback: Scalars['String']['input']
  subject?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateHeadshotRequestArgs = {
  attire: HeadshotRequestsAttireEnum
  background: HeadshotRequestsBackgroundEnum
  uploadSignedId: Array<Scalars['ID']['input']>
}

export type MutationCreateResumeArgs = {
  name: Scalars['String']['input']
}

export type MutationCreateResumeFromLinkedinUrlArgs = {
  linkedinProfileUrl: Scalars['String']['input']
}

export type MutationCreateResumeUnauthenticatedArgs = {
  attributes?: InputMaybe<ResumesInputObject>
}

export type MutationCreateSearchFilterArgs = {
  name: Scalars['String']['input']
  searchFilters: JobListingsFilterInputObject
}

export type MutationCreateUsersJobArgs = {
  applicationInstructions?: InputMaybe<Scalars['String']['input']>
  companyDomain?: InputMaybe<Scalars['String']['input']>
  companyName: Scalars['String']['input']
  contact?: InputMaybe<ContactsInputObject>
  interviewStep?: InputMaybe<UsersJobsInterviewStepEnum>
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobDetails?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  payPeriod?: InputMaybe<UsersJobsPayPeriodEnum>
  position: Scalars['String']['input']
  rejectedStage?: InputMaybe<UsersJobsRejectedStageEnum>
  resumeId?: InputMaybe<Scalars['ID']['input']>
  salaryMax?: InputMaybe<Scalars['Int']['input']>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<UsersJobsStatusEnum>
  uniqueUrl?: InputMaybe<Scalars['Boolean']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateWritingSampleArgs = {
  answer: Scalars['String']['input']
  question: Scalars['String']['input']
}

export type MutationDownloadPdfResumeArgs = {
  id: Scalars['ID']['input']
}

export type MutationDuplicateResumeArgs = {
  id: Scalars['ID']['input']
}

export type MutationDuplicateResumeFromResumeExampleArgs = {
  id: Scalars['ID']['input']
}

export type MutationEditClientGroupArgs = {
  clientGroupId: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationFakeJobMutationArgs = {
  companyName: Scalars['String']['input']
  datePosted?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type MutationFetchJobKeywordsArgs = {
  jobListingId?: InputMaybe<Scalars['ID']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  usersJobId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationFetchMissingSkillsOfJobResumeArgs = {
  jobListingId?: InputMaybe<Scalars['ID']['input']>
  resumeId: Scalars['ID']['input']
  usersJobId: Scalars['ID']['input']
}

export type MutationFixFromRelevanceAnalysisArgs = {
  achievementsToUpdate?: InputMaybe<Array<ResumesRelevantAchievementInputObject>>
  id: Scalars['ID']['input']
  skillsToAdd?: InputMaybe<Array<Scalars['String']['input']>>
  skillsToRemove?: InputMaybe<Array<ResumesAnalysisSkillTypeInputObject>>
  summary?: InputMaybe<Scalars['String']['input']>
}

export type MutationGenerateCompanyDomainArgs = {
  id: Scalars['ID']['input']
}

export type MutationGenerateCoverLetterArgs = {
  coverLetterLength?: InputMaybe<CoverLetterLengthEnum>
  coverLetterTone?: InputMaybe<CoverLetterToneEnum>
  customPrompt?: InputMaybe<Scalars['String']['input']>
  resumeId: Scalars['ID']['input']
  usersJobId: Scalars['ID']['input']
}

export type MutationGenerateDraftEmailForSimilarProfileArgs = {
  forHiringManager?: InputMaybe<Scalars['Boolean']['input']>
  forRecruiter?: InputMaybe<Scalars['Boolean']['input']>
  resumeId: Scalars['ID']['input']
  similarProfile: SimilarProfilesInputObject
  usersJobId: Scalars['ID']['input']
}

export type MutationGenerateJobAchievementArgs = {
  indices: Array<Scalars['Int']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  workPositionId: Scalars['ID']['input']
}

export type MutationGenerateJobAchievementFromStringArgs = {
  achievementStrings: Array<Scalars['String']['input']>
  customPrompt?: InputMaybe<Scalars['String']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
}

export type MutationGenerateMessageForContactArgs = {
  companyName: Scalars['String']['input']
  contactName: Scalars['String']['input']
  contactRelationship: MessagesContactType
  jobTitle: Scalars['String']['input']
  messageType: MessagesMessageType
}

export type MutationGenerateOneJobAchievementArgs = {
  customPrompt?: InputMaybe<Scalars['String']['input']>
  index: Scalars['Int']['input']
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  workPositionId: Scalars['ID']['input']
}

export type MutationGenerateProfessionalSummaryArgs = {
  customPrompt?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  useExisting: Scalars['Boolean']['input']
}

export type MutationInterviewAddMessageArgs = {
  interviewId: Scalars['String']['input']
  message: Scalars['String']['input']
}

export type MutationInterviewStartMockArgs = {
  interviewType: InterviewsTypeEnum
  jobDescription?: InputMaybe<Scalars['String']['input']>
  jobTitle: Scalars['String']['input']
  resumeId?: InputMaybe<Scalars['ID']['input']>
  usersJobId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationInviteAdvisorArgs = {
  email: Scalars['String']['input']
  role: UsersRoleEnum
}

export type MutationInviteClientArgs = {
  email: Scalars['String']['input']
}

export type MutationJobsFormFieldsMappingArgs = {
  extraDataSource?: InputMaybe<Scalars['String']['input']>
  htmlString: Scalars['String']['input']
  resumeId: Scalars['ID']['input']
}

export type MutationJobsFormFieldsMappingV2Args = {
  extraDataSource?: InputMaybe<Scalars['String']['input']>
  htmlString: Scalars['String']['input']
  resumeId: Scalars['ID']['input']
}

export type MutationLearnSkillsArgs = {
  usersJobId: Scalars['ID']['input']
}

export type MutationManuallyReportGhostJobArgs = {
  companyName: Scalars['String']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}

export type MutationMarkJobListingAsAppliedArgs = {
  jobListingId: Scalars['ID']['input']
}

export type MutationMatchScoreArgs = {
  resumeId: Scalars['ID']['input']
  usersJobId: Scalars['ID']['input']
}

export type MutationOptimizeResumeForJobArgs = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  resumeId: Scalars['ID']['input']
  skills?: InputMaybe<Array<Scalars['String']['input']>>
  usersJobId: Scalars['ID']['input']
}

export type MutationOptimizeResumeForJobV2Args = {
  jobListingId?: InputMaybe<Scalars['ID']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  resumeId: Scalars['ID']['input']
  skills?: InputMaybe<Array<Scalars['String']['input']>>
  usersJobId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationPreviewAuthResumeArgs = {
  id: Scalars['ID']['input']
  template: ResumesTemplateEnum
}

export type MutationPreviewResumeArgs = {
  attributes: ResumesInputObject
  template: ResumesTemplateEnum
}

export type MutationQuestionPrefillApplicationArgs = {
  question: Scalars['String']['input']
  resumeId: Scalars['ID']['input']
}

export type MutationRequestResumeReviewArgs = {
  id: Scalars['ID']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}

export type MutationResumeRelevanceAnalysisArgs = {
  id: Scalars['ID']['input']
  jobTitle: Scalars['String']['input']
}

export type MutationRoastResumeArgs = {
  jobTitle: Scalars['String']['input']
  roleType: RoastRoleTypeEnum
  token: Scalars['String']['input']
  toneLevel: RoastToneLevelEnum
  uploadSignedId: Scalars['ID']['input']
}

export type MutationSalaryInsightsArgs = {
  usersJobId: Scalars['ID']['input']
}

export type MutationSampleInterviewQuestionsArgs = {
  usersJobId: Scalars['ID']['input']
}

export type MutationScoreResumeArgs = {
  id: Scalars['ID']['input']
}

export type MutationShareJobWithClientsArgs = {
  clientGroupIds: Array<Scalars['ID']['input']>
  userIds: Array<Scalars['ID']['input']>
  usersJobId: Scalars['ID']['input']
}

export type MutationSubscriptionsRedeemLtdPromoCodeArgs = {
  promoCode: Scalars['String']['input']
}

export type MutationSubscriptionsRequestResumeSuccessArgs = {
  id: Scalars['ID']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  sessionId: Scalars['ID']['input']
}

export type MutationSubscriptionsSessionCreateArgs = {
  coupon?: InputMaybe<Scalars['String']['input']>
  isOnboarding?: InputMaybe<Scalars['Boolean']['input']>
  plan: SubscriptionPlanEnum
}

export type MutationSubscriptionsSessionFetchArgs = {
  sessionId: Scalars['ID']['input']
}

export type MutationUnbookmarkJobArgs = {
  jobListingId: Scalars['ID']['input']
}

export type MutationUpdateAdvisoryOrganizationArgs = {
  name: Scalars['String']['input']
  uploadSignedId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationUpdateArchivedCoverLetterArgs = {
  archived: Scalars['Boolean']['input']
  coverLetterId: Scalars['ID']['input']
}

export type MutationUpdateArchivedResumeArgs = {
  archived: Scalars['Boolean']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdatePdfBlobArgs = {
  id: Scalars['ID']['input']
  pdfBlob: Array<Scalars['Int']['input']>
}

export type MutationUpdatePublicResumeArgs = {
  id: Scalars['ID']['input']
  isPublic: Scalars['Boolean']['input']
}

export type MutationUpdateResumeArgs = {
  attributes: ResumesInputObject
  id: Scalars['ID']['input']
}

export type MutationUpdateResumePreferencesArgs = {
  attributes: ResumePreferencesInputObject
  id: Scalars['ID']['input']
}

export type MutationUpdateResumeUnauthenticatedArgs = {
  attributes: ResumesInputObject
  id: Scalars['ID']['input']
}

export type MutationUpdateSearchFilterArgs = {
  id: Scalars['ID']['input']
  searchFilters: JobListingsFilterInputObject
}

export type MutationUpdateShowOriginalDocumentResumeArgs = {
  id: Scalars['ID']['input']
  showOriginalDocument: Scalars['Boolean']['input']
}

export type MutationUpdateTemplateResumeArgs = {
  id: Scalars['ID']['input']
  template: ResumesTemplateEnum
  templateColorEnum?: InputMaybe<ResumesTemplateColorEnum>
}

export type MutationUpdateUserArgs = {
  attributes: UsersInputObject
}

export type MutationUpdateUsersJobArgs = {
  applicationInstructions?: InputMaybe<Scalars['String']['input']>
  appliedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  appliedChecklistCompleted?: InputMaybe<Array<UsersJobsChecklistEnum>>
  archived?: InputMaybe<Scalars['Boolean']['input']>
  companyDomain?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  interviewChecklistCompleted?: InputMaybe<Array<UsersJobsChecklistEnum>>
  interviewStep?: InputMaybe<UsersJobsInterviewStepEnum>
  interviewedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobDetails?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  payPeriod?: InputMaybe<UsersJobsPayPeriodEnum>
  position?: InputMaybe<Scalars['String']['input']>
  rejectedStage?: InputMaybe<UsersJobsRejectedStageEnum>
  resumeId?: InputMaybe<Scalars['ID']['input']>
  salaryMax?: InputMaybe<Scalars['Int']['input']>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<UsersJobsStatusEnum>
  url?: InputMaybe<Scalars['String']['input']>
  wishlistChecklistCompleted?: InputMaybe<Array<UsersJobsChecklistEnum>>
}

export type MutationUpdateWritingSampleArgs = {
  answer?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

export type MutationUploadResumeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
  uploadSignedId: Scalars['ID']['input']
}

export type MutationUploadResumeWebsocketArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
  uploadSignedId: Scalars['ID']['input']
}

export type MutationUserEmailVerifyArgs = {
  emailVerificationCode: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type MutationUserStoreLocationArgs = {
  city: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type MutationUserUpdateWritingStyleArgs = {
  writingStyleEnum: UsersWritingStyleEnum
}

export type MutationUserUploadProfilePictureArgs = {
  uploadSignedId: Scalars['ID']['input']
}

export type MutationUserUpsertJobSearchPreferenceArgs = {
  attributes?: InputMaybe<JobSearchPreferenceInputObject>
}

/** Autogenerated return type of OcrResume. */
export type OcrResumePayload = {
  __typename?: 'OcrResumePayload'
  resumeId: Scalars['ID']['output']
}

export type PaginatedAdvisorUsers = {
  __typename?: 'PaginatedAdvisorUsers'
  data: Array<AdvisorUsers>
  pagination: Pagination
}

export type PaginatedClientUsers = {
  __typename?: 'PaginatedClientUsers'
  data: Array<ClientUsers>
  pagination: Pagination
}

export type PaginatedJobListings = {
  __typename?: 'PaginatedJobListings'
  data: Array<JobListings>
  pagination: Pagination
}

export type PaginatedResumeExamples = {
  __typename?: 'PaginatedResumeExamples'
  data: Array<Resumes>
  pagination: Pagination
}

export type PaginatedUsersJobs = {
  __typename?: 'PaginatedUsersJobs'
  data: Array<UsersJobs>
  pagination: Pagination
}

export type Pagination = {
  __typename?: 'Pagination'
  page: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  totalCount: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type ProfileMatchSimilarProfile = {
  __typename?: 'ProfileMatchSimilarProfile'
  matchTypes: Array<SimilarProfilesMatchTypeEnum>
  profile: SimilarProfiles
}

export type Query = {
  __typename?: 'Query'
  advisors: PaginatedAdvisorUsers
  client: Users
  clientGroups: Array<ClientGroup>
  clientResumes: Array<Resumes>
  clientUsersJobs: Array<UsersJobs>
  clients: PaginatedClientUsers
  coverLetterExample?: Maybe<UsersJobsCoverLetterType>
  coverLetterExamples?: Maybe<Array<UsersJobsCoverLetterType>>
  coverLetters: Array<UsersJobsCoverLetterType>
  emailVerifyAllowed?: Maybe<Users>
  fakeJob: FakeJobInfo
  findUsersJobByInfo?: Maybe<UsersJobs>
  findUsersJobByUrl?: Maybe<UsersJobs>
  getAboutCompanyInfo?: Maybe<CompanyAboutInfo>
  getGlassdoorResults: Scalars['String']['output']
  getLatestCompanyInfo?: Maybe<CompanyLatestInfo>
  getLinkedinConnectionsUrl: Scalars['String']['output']
  getPossibleLinkedinCompany: LinkedinCompany
  hasAddedJobListing?: Maybe<UsersJobs>
  headshotRequests: Array<HeadshotRequest>
  hiringManagersFromUsersJob: Array<SimilarProfiles>
  interviews: Array<Interview>
  jobListing: JobListings
  jobSearchPreference: JobSearchPreference
  locationsTypeahead: Array<Scalars['String']['output']>
  networkingPeopleFromUsersJob: Array<ProfileMatchSimilarProfile>
  paginatedJobListings: PaginatedJobListings
  paginatedResumeExamples: PaginatedResumeExamples
  paginatedUsersJobs: PaginatedUsersJobs
  publicResume?: Maybe<Resumes>
  resetPasswordAllowed: Scalars['Boolean']['output']
  resumeExample?: Maybe<Resumes>
  resumeExampleCategories?: Maybe<Array<Scalars['String']['output']>>
  resumeExamples?: Maybe<Array<Resumes>>
  resumeScore: ResumesScoreType
  resumeSimpleAnalysis: Array<FieldMessageType>
  resumeUnauthenticated?: Maybe<Resumes>
  resumes: Array<Resumes>
  resumesPdfBlob: Scalars['String']['output']
  sameEducationProfilesFromUsersJob: Array<SimilarProfiles>
  similarCareerPaths?: Maybe<Array<CareerPathsPostType>>
  similarCoverLetterExamples?: Maybe<Array<UsersJobsCoverLetterType>>
  similarInterviewQuestions?: Maybe<Array<InterviewQuestionsPostType>>
  similarProfilesFromUsersJob: Array<SimilarProfiles>
  similarResumeExamples?: Maybe<Array<Resumes>>
  user: Users
  usersJobs: Array<UsersJobs>
  usersJobsDateRange: UsersJobsPerformanceDateRange
  writingSamples: Array<WritingSample>
}

export type QueryAdvisorsArgs = {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  role?: InputMaybe<UsersRoleEnum>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<AdvisorSortEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type QueryClientArgs = {
  clientId: Scalars['ID']['input']
}

export type QueryClientGroupsArgs = {
  clientGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryClientResumesArgs = {
  clientId: Scalars['ID']['input']
  resumeIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryClientUsersJobsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  clientId: Scalars['ID']['input']
  partnerCreated?: InputMaybe<Scalars['Boolean']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryClientsArgs = {
  advisorIds?: InputMaybe<Array<Scalars['ID']['input']>>
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type QueryCoverLetterExampleArgs = {
  nameSlug: Scalars['String']['input']
}

export type QueryCoverLettersArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  coverLetterIds?: InputMaybe<Array<Scalars['ID']['input']>>
  searchTerm?: InputMaybe<Scalars['String']['input']>
}

export type QueryEmailVerifyAllowedArgs = {
  emailVerificationCode: Scalars['String']['input']
}

export type QueryFakeJobArgs = {
  companyName: Scalars['String']['input']
  datePosted?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type QueryFindUsersJobByInfoArgs = {
  companyName: Scalars['String']['input']
  location?: InputMaybe<Scalars['String']['input']>
  position: Scalars['String']['input']
  url?: InputMaybe<Scalars['String']['input']>
}

export type QueryFindUsersJobByUrlArgs = {
  url: Scalars['String']['input']
}

export type QueryGetAboutCompanyInfoArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryGetGlassdoorResultsArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryGetLatestCompanyInfoArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryGetLinkedinConnectionsUrlArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryGetPossibleLinkedinCompanyArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryHasAddedJobListingArgs = {
  jobListingId: Scalars['ID']['input']
}

export type QueryHeadshotRequestsArgs = {
  headshotRequestIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryHiringManagersFromUsersJobArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryInterviewsArgs = {
  interviewIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryJobListingArgs = {
  jobListingId: Scalars['ID']['input']
}

export type QueryLocationsTypeaheadArgs = {
  location: Scalars['String']['input']
}

export type QueryNetworkingPeopleFromUsersJobArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QueryPaginatedJobListingsArgs = {
  attributes?: InputMaybe<JobListingsFilterInputObject>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<JobListingsSortEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
}

export type QueryPaginatedResumeExamplesArgs = {
  category?: InputMaybe<Scalars['String']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
}

export type QueryPaginatedUsersJobsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<JobPostingSortEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
}

export type QueryPublicResumeArgs = {
  publicId: Scalars['ID']['input']
}

export type QueryResetPasswordAllowedArgs = {
  resetPasswordToken: Scalars['String']['input']
}

export type QueryResumeExampleArgs = {
  nameSlug: Scalars['String']['input']
}

export type QueryResumeScoreArgs = {
  id: Scalars['ID']['input']
}

export type QueryResumeSimpleAnalysisArgs = {
  id: Scalars['ID']['input']
}

export type QueryResumeUnauthenticatedArgs = {
  id: Scalars['ID']['input']
}

export type QueryResumesArgs = {
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>
  aiGeneratedForJobTitle?: InputMaybe<Scalars['Boolean']['input']>
  archived?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  resumeIds?: InputMaybe<Array<Scalars['ID']['input']>>
  searchTerm?: InputMaybe<Scalars['String']['input']>
}

export type QueryResumesPdfBlobArgs = {
  resumeId?: InputMaybe<Scalars['ID']['input']>
}

export type QuerySameEducationProfilesFromUsersJobArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QuerySimilarCareerPathsArgs = {
  nameSlug: Scalars['String']['input']
}

export type QuerySimilarCoverLetterExamplesArgs = {
  nameSlug: Scalars['String']['input']
}

export type QuerySimilarInterviewQuestionsArgs = {
  nameSlug: Scalars['String']['input']
}

export type QuerySimilarProfilesFromUsersJobArgs = {
  usersJobId: Scalars['ID']['input']
}

export type QuerySimilarResumeExamplesArgs = {
  nameSlug: Scalars['String']['input']
}

export type QueryUsersJobsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  partnerCreated?: InputMaybe<Scalars['Boolean']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryUsersJobsDateRangeArgs = {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export enum ResumeDocumentType {
  Doc = 'DOC',
  Pdf = 'PDF',
}

export type ResumePreferencesInputObject = {
  dateFormat?: InputMaybe<ResumesDateFormatEnum>
  fontFamily?: InputMaybe<ResumesFontFamilyEnum>
  fontSize?: InputMaybe<ResumesFontSizeEnum>
  hideCertifications?: InputMaybe<Scalars['Boolean']['input']>
  hideCourseworks?: InputMaybe<Scalars['Boolean']['input']>
  hideEducations?: InputMaybe<Scalars['Boolean']['input']>
  hideInvolvements?: InputMaybe<Scalars['Boolean']['input']>
  hideProjects?: InputMaybe<Scalars['Boolean']['input']>
  hideSkills?: InputMaybe<Scalars['Boolean']['input']>
  hideSummary?: InputMaybe<Scalars['Boolean']['input']>
  hideTargetTitle?: InputMaybe<Scalars['Boolean']['input']>
  hideWorkExperiences?: InputMaybe<Scalars['Boolean']['input']>
  horizontalMargin?: InputMaybe<ResumesHorizontalMarginEnum>
  lineHeight?: InputMaybe<ResumesLineHeightEnum>
  pageSize?: InputMaybe<ResumesPageSizeEnum>
  sectionTitleCasing?: InputMaybe<ResumesSectionTitleCasingEnum>
  sectionsOrder?: InputMaybe<Array<ResumeSortableSections>>
  sectionsOrderWithCustomSections?: InputMaybe<Array<Scalars['String']['input']>>
  template?: InputMaybe<ResumesTemplateEnum>
  templateColorEnum?: InputMaybe<ResumesTemplateColorEnum>
  verticalMargin?: InputMaybe<ResumesVerticalMarginEnum>
}

export enum ResumeScoreSectionType {
  ContentLength = 'CONTENT_LENGTH',
  ContentQuality = 'CONTENT_QUALITY',
  FieldCompletion = 'FIELD_COMPLETION',
}

export enum ResumeSortableSections {
  Certifications = 'CERTIFICATIONS',
  Courseworks = 'COURSEWORKS',
  Educations = 'EDUCATIONS',
  Involvements = 'INVOLVEMENTS',
  Projects = 'PROJECTS',
  Skills = 'SKILLS',
  WorkExperiences = 'WORK_EXPERIENCES',
}

export type Resumes = {
  __typename?: 'Resumes'
  aiGenerated: Scalars['Boolean']['output']
  archived: Scalars['Boolean']['output']
  category?: Maybe<Scalars['String']['output']>
  certifications: Array<ResumesCertification>
  courseworks: Array<ResumesCoursework>
  createdAt: Scalars['ISO8601DateTime']['output']
  customSections: Array<ResumesCustomSection>
  documentType?: Maybe<ResumeDocumentType>
  documentUrl?: Maybe<Scalars['String']['output']>
  educations: Array<ResumesEducation>
  email?: Maybe<Scalars['String']['output']>
  exampleImageUrl?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  groupedSkills: Array<ResumesGroupedSkill>
  hideCertifications: Scalars['Boolean']['output']
  hideCourseworks: Scalars['Boolean']['output']
  hideEducations: Scalars['Boolean']['output']
  hideInvolvements: Scalars['Boolean']['output']
  hideProjects: Scalars['Boolean']['output']
  hideSkills: Scalars['Boolean']['output']
  hideSummary: Scalars['Boolean']['output']
  hideTargetTitle: Scalars['Boolean']['output']
  hideWorkExperiences: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  interviewRate?: Maybe<Scalars['Int']['output']>
  involvements: Array<ResumesInvolvement>
  isPublic: Scalars['Boolean']['output']
  lastAnalyzedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  linkedinUrl?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  mostRecentEmployer?: Maybe<Scalars['String']['output']>
  mostRecentJobTitle?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  nameSlug?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  preferences: ResumesPreferences
  professionalSummary?: Maybe<Scalars['String']['output']>
  projects: Array<ResumesProject>
  publicId: Scalars['ID']['output']
  sectionsOrder: Array<ResumeSortableSections>
  showOriginalDocument: Scalars['Boolean']['output']
  simpleAnalysis: Array<FieldMessageType>
  suggestedSkills: Array<Scalars['String']['output']>
  targetTitle?: Maybe<Scalars['String']['output']>
  template: ResumesTemplateEnum
  templateColorEnum?: Maybe<ResumesTemplateColorEnum>
  tokenResumeAnalysis: Scalars['Int']['output']
  uniqueId?: Maybe<Scalars['ID']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  website?: Maybe<Scalars['String']['output']>
  workExperiences: Array<ResumesWorkExperience>
}

export type ResumesAnalysisSkillType = {
  __typename?: 'ResumesAnalysisSkillType'
  category?: Maybe<Scalars['String']['output']>
  skill: Scalars['String']['output']
}

export type ResumesAnalysisSkillTypeInputObject = {
  category: Scalars['String']['input']
  skill: Scalars['String']['input']
}

export type ResumesAvatarPreferences = {
  __typename?: 'ResumesAvatarPreferences'
  profilePictureEnabled: Scalars['Boolean']['output']
  profilePictureShape?: Maybe<ResumesProfilePictureShapeEnum>
}

export type ResumesCertification = {
  __typename?: 'ResumesCertification'
  completionDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  provider?: Maybe<Scalars['String']['output']>
  showYearOnlyCompletionDate: Scalars['Boolean']['output']
}

export type ResumesCertificationInputObject = {
  completionDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
  provider?: InputMaybe<Scalars['String']['input']>
  showYearOnlyCompletionDate?: InputMaybe<Scalars['Boolean']['input']>
}

export type ResumesCoursework = {
  __typename?: 'ResumesCoursework'
  achievements: Array<Scalars['String']['output']>
  currentlyWorkingOnCourse: Scalars['Boolean']['output']
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  institutionName?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  showYearOnlyEndDate: Scalars['Boolean']['output']
}

export type ResumesCourseworkInputObject = {
  achievements: Array<Scalars['String']['input']>
  currentlyWorkingOnCourse?: InputMaybe<Scalars['Boolean']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  institutionName?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  showYearOnlyEndDate?: InputMaybe<Scalars['Boolean']['input']>
}

export type ResumesCustomSection = {
  __typename?: 'ResumesCustomSection'
  customSectionExperiences: Array<ResumesCustomSectionExperience>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ResumesCustomSectionExperience = {
  __typename?: 'ResumesCustomSectionExperience'
  achievements: Scalars['String']['output']
  companyName?: Maybe<Scalars['String']['output']>
  currentlyInExperience: Scalars['Boolean']['output']
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  location?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  showYearOnlyEndDate: Scalars['Boolean']['output']
  showYearOnlyStartDate: Scalars['Boolean']['output']
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type ResumesCustomSectionExperienceInputObject = {
  achievements: Scalars['String']['input']
  companyName?: InputMaybe<Scalars['String']['input']>
  currentlyInExperience?: InputMaybe<Scalars['Boolean']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  showYearOnlyEndDate?: InputMaybe<Scalars['Boolean']['input']>
  showYearOnlyStartDate?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type ResumesCustomSectionInputObject = {
  customSectionExperiencesAttributes: Array<ResumesCustomSectionExperienceInputObject>
  id?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
}

export enum ResumesDateFormatEnum {
  LongName = 'LONG_NAME',
  Numbers = 'NUMBERS',
  ShortName = 'SHORT_NAME',
}

export type ResumesEducation = {
  __typename?: 'ResumesEducation'
  achievements: Array<Scalars['String']['output']>
  additionalInformation?: Maybe<Scalars['String']['output']>
  currentlyInEducation: Scalars['Boolean']['output']
  degree?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  gpa?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  institutionName: Scalars['String']['output']
  location?: Maybe<Scalars['String']['output']>
  showYearOnlyEndDate: Scalars['Boolean']['output']
  showYearOnlyStartDate: Scalars['Boolean']['output']
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type ResumesEducationInputObject = {
  achievements?: InputMaybe<Array<Scalars['String']['input']>>
  additionalInformation?: InputMaybe<Scalars['String']['input']>
  currentlyInEducation?: InputMaybe<Scalars['Boolean']['input']>
  degree?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  gpa?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  institutionName: Scalars['String']['input']
  location?: InputMaybe<Scalars['String']['input']>
  showYearOnlyEndDate?: InputMaybe<Scalars['Boolean']['input']>
  showYearOnlyStartDate?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export enum ResumesFontFamilyEnum {
  Crimson = 'CRIMSON',
  Garamond = 'GARAMOND',
  Helvetica = 'HELVETICA',
  OpenSans = 'OPEN_SANS',
}

export enum ResumesFontSizeEnum {
  Small = 'SMALL',
  Standard = 'STANDARD',
}

export type ResumesGroupedSkill = {
  __typename?: 'ResumesGroupedSkill'
  category?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  skills: Array<Scalars['String']['output']>
}

export type ResumesGroupedSkillInputObject = {
  category?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  skills: Array<Scalars['String']['input']>
}

export enum ResumesHorizontalMarginEnum {
  Compact = 'COMPACT',
  Standard = 'STANDARD',
}

export type ResumesInputObject = {
  certificationsAttributes: Array<ResumesCertificationInputObject>
  courseworksAttributes: Array<ResumesCourseworkInputObject>
  customSectionsAttributes?: InputMaybe<Array<ResumesCustomSectionInputObject>>
  educationsAttributes: Array<ResumesEducationInputObject>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  groupedSkillsAttributes: Array<ResumesGroupedSkillInputObject>
  hideCertifications?: InputMaybe<Scalars['Boolean']['input']>
  hideCourseworks?: InputMaybe<Scalars['Boolean']['input']>
  hideEducations?: InputMaybe<Scalars['Boolean']['input']>
  hideInvolvements?: InputMaybe<Scalars['Boolean']['input']>
  hideProjects?: InputMaybe<Scalars['Boolean']['input']>
  hideSkills?: InputMaybe<Scalars['Boolean']['input']>
  hideSummary?: InputMaybe<Scalars['Boolean']['input']>
  hideTargetTitle?: InputMaybe<Scalars['Boolean']['input']>
  hideWorkExperiences?: InputMaybe<Scalars['Boolean']['input']>
  involvementsAttributes: Array<ResumesInvolvementInputObject>
  lastName?: InputMaybe<Scalars['String']['input']>
  linkedinUrl?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  professionalSummary?: InputMaybe<Scalars['String']['input']>
  profilePictureEnabled?: InputMaybe<Scalars['Boolean']['input']>
  profilePictureShape?: InputMaybe<ResumesProfilePictureShapeEnum>
  projectsAttributes: Array<ResumesProjectInputObject>
  sectionsOrder?: InputMaybe<Array<ResumeSortableSections>>
  targetTitle?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  workExperiencesAttributes: Array<ResumesWorkExperienceInputObject>
}

export type ResumesInvolvement = {
  __typename?: 'ResumesInvolvement'
  achievements: Array<Scalars['String']['output']>
  currentlyWorkingOnInvolvement: Scalars['Boolean']['output']
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  organizationName?: Maybe<Scalars['String']['output']>
  showYearOnlyEndDate: Scalars['Boolean']['output']
  showYearOnlyStartDate: Scalars['Boolean']['output']
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type ResumesInvolvementInputObject = {
  achievements: Array<Scalars['String']['input']>
  currentlyWorkingOnInvolvement?: InputMaybe<Scalars['Boolean']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  organizationName?: InputMaybe<Scalars['String']['input']>
  showYearOnlyEndDate?: InputMaybe<Scalars['Boolean']['input']>
  showYearOnlyStartDate?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type ResumesIrrelevantAchievementType = {
  __typename?: 'ResumesIrrelevantAchievementType'
  achievementIndex: Scalars['Int']['output']
  achievementType: ResumesResumeAchievementTypeEnum
  achievementTypeId: Scalars['Int']['output']
  companyName?: Maybe<Scalars['String']['output']>
  irrelevantAchievementForJobTitle: Scalars['String']['output']
  position?: Maybe<Scalars['String']['output']>
  relevantAchievementForJobTitle: Scalars['String']['output']
}

export enum ResumesLineHeightEnum {
  Compact = 'COMPACT',
  Relaxed = 'RELAXED',
  Standard = 'STANDARD',
}

export enum ResumesPageSizeEnum {
  A4 = 'A4',
  Letter = 'LETTER',
}

export type ResumesPreferences = {
  __typename?: 'ResumesPreferences'
  avatar: ResumesAvatarPreferences
  dateFormat: ResumesDateFormatEnum
  fontFamily: ResumesFontFamilyEnum
  fontSize: ResumesFontSizeEnum
  hideCertifications: Scalars['Boolean']['output']
  hideCourseworks: Scalars['Boolean']['output']
  hideEducations: Scalars['Boolean']['output']
  hideInvolvements: Scalars['Boolean']['output']
  hideProjects: Scalars['Boolean']['output']
  hideSkills: Scalars['Boolean']['output']
  hideSummary: Scalars['Boolean']['output']
  hideTargetTitle: Scalars['Boolean']['output']
  hideWorkExperiences: Scalars['Boolean']['output']
  horizontalMargin: ResumesHorizontalMarginEnum
  lineHeight: ResumesLineHeightEnum
  pageSize: ResumesPageSizeEnum
  sectionTitleCasing: ResumesSectionTitleCasingEnum
  sectionsOrder: Array<ResumeSortableSections>
  sectionsOrderWithCustomSections: Array<Scalars['String']['output']>
  template: ResumesTemplateEnum
  templateColorEnum?: Maybe<ResumesTemplateColorEnum>
  verticalMargin: ResumesVerticalMarginEnum
}

export enum ResumesProfilePictureShapeEnum {
  Round = 'ROUND',
  Square = 'SQUARE',
}

export type ResumesProject = {
  __typename?: 'ResumesProject'
  achievements: Array<Scalars['String']['output']>
  currentlyWorkingOnProject: Scalars['Boolean']['output']
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  linkUrl?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  showYearOnlyEndDate: Scalars['Boolean']['output']
  showYearOnlyStartDate: Scalars['Boolean']['output']
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type ResumesProjectInputObject = {
  achievements: Array<Scalars['String']['input']>
  currentlyWorkingOnProject?: InputMaybe<Scalars['Boolean']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  linkUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  showYearOnlyEndDate?: InputMaybe<Scalars['Boolean']['input']>
  showYearOnlyStartDate?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type ResumesRelevantAchievementInputObject = {
  achievementIndex: Scalars['Int']['input']
  achievementType: ResumesResumeAchievementTypeEnum
  achievementTypeId: Scalars['ID']['input']
  relevantAchievementForJobTitle: Scalars['String']['input']
}

export enum ResumesResumeAchievementTypeEnum {
  WorkPosition = 'WORK_POSITION',
}

export type ResumesResumeRelevanceAnalysis = {
  __typename?: 'ResumesResumeRelevanceAnalysis'
  irrelevantAchievementsForJobTitle: Array<ResumesIrrelevantAchievementType>
  irrelevantSkillsForJobTitle: Array<ResumesAnalysisSkillType>
  isSummaryRelevantForJobTitle: Scalars['Boolean']['output']
  originalSummary?: Maybe<Scalars['String']['output']>
  relevantSummaryForJobTitle?: Maybe<Scalars['String']['output']>
  suggestedSkillsForJobTitle: Array<Scalars['String']['output']>
}

export type ResumesScoreFieldTagType = {
  __typename?: 'ResumesScoreFieldTagType'
  tagLink: Scalars['String']['output']
  tagName: Scalars['String']['output']
}

export type ResumesScoreFieldType = {
  __typename?: 'ResumesScoreFieldType'
  didPass: Scalars['Boolean']['output']
  errorMessage?: Maybe<Scalars['String']['output']>
  header: Scalars['String']['output']
  sectionType: ResumeScoreSectionType
  tags?: Maybe<Array<ResumesScoreFieldTagType>>
}

export type ResumesScoreType = {
  __typename?: 'ResumesScoreType'
  failed: Scalars['Int']['output']
  passed: Scalars['Int']['output']
  score: Scalars['Int']['output']
  scoreFields: Array<ResumesScoreFieldType>
  total: Scalars['Int']['output']
}

export enum ResumesSectionTitleCasingEnum {
  Capitalized = 'CAPITALIZED',
  Uppercase = 'UPPERCASE',
}

export enum ResumesTemplateColorEnum {
  BauhausLight = 'BAUHAUS_LIGHT',
  HarvardLight = 'HARVARD_LIGHT',
  NeueCyan = 'NEUE_CYAN',
  NeueEmerald = 'NEUE_EMERALD',
  NeueIndigo = 'NEUE_INDIGO',
  NeueLight = 'NEUE_LIGHT',
  OxfordCyan = 'OXFORD_CYAN',
  OxfordEmerald = 'OXFORD_EMERALD',
  OxfordIndigo = 'OXFORD_INDIGO',
  OxfordLight = 'OXFORD_LIGHT',
}

export enum ResumesTemplateEnum {
  Bauhaus = 'BAUHAUS',
  Harvard = 'HARVARD',
  Neue = 'NEUE',
  Oxford = 'OXFORD',
}

export enum ResumesVerticalMarginEnum {
  Compact = 'COMPACT',
  Standard = 'STANDARD',
}

export type ResumesWorkExperience = {
  __typename?: 'ResumesWorkExperience'
  companyDescription?: Maybe<Scalars['String']['output']>
  companyName: Scalars['String']['output']
  id: Scalars['ID']['output']
  simpleAnalysis: Array<FieldMessageType>
  workPositions: Array<ResumesWorkPosition>
}

export type ResumesWorkExperienceInputObject = {
  companyDescription?: InputMaybe<Scalars['String']['input']>
  companyName: Scalars['String']['input']
  id?: InputMaybe<Scalars['ID']['input']>
  workPositionsAttributes: Array<ResumesWorkPositionInputObject>
}

export type ResumesWorkPosition = {
  __typename?: 'ResumesWorkPosition'
  achievements: Array<Scalars['String']['output']>
  currentlyInPosition: Scalars['Boolean']['output']
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  location?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  showYearOnlyEndDate: Scalars['Boolean']['output']
  showYearOnlyStartDate: Scalars['Boolean']['output']
  simpleAnalysis: Array<FieldMessageType>
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type ResumesWorkPositionInputObject = {
  achievements: Array<Scalars['String']['input']>
  currentlyInPosition?: InputMaybe<Scalars['Boolean']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  showYearOnlyEndDate?: InputMaybe<Scalars['Boolean']['input']>
  showYearOnlyStartDate?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

/** Autogenerated return type of Roast. */
export type RoastPayload = {
  __typename?: 'RoastPayload'
  content: Scalars['String']['output']
  i?: Maybe<Scalars['Int']['output']>
  initial: Scalars['Boolean']['output']
  requestId: Scalars['String']['output']
}

export enum RoastRoleTypeEnum {
  Boss = 'BOSS',
  Colleague = 'COLLEAGUE',
  Comedian = 'COMEDIAN',
  Family = 'FAMILY',
  Friendly = 'FRIENDLY',
  Interviewer = 'INTERVIEWER',
  Mentor = 'MENTOR',
  Recruiter = 'RECRUITER',
  Spouse = 'SPOUSE',
}

export enum RoastToneLevelEnum {
  Dark = 'DARK',
  Direct = 'DIRECT',
  Friendly = 'FRIENDLY',
  Humorous = 'HUMOROUS',
  Informative = 'INFORMATIVE',
  Inspirational = 'INSPIRATIONAL',
}

/** Autogenerated return type of SampleInterviewQuestions. */
export type SampleInterviewQuestionsPayload = {
  __typename?: 'SampleInterviewQuestionsPayload'
  content: Scalars['String']['output']
  i?: Maybe<Scalars['Int']['output']>
  initial: Scalars['Boolean']['output']
  requestId: Scalars['String']['output']
  usersJobId: Scalars['ID']['output']
}

export type SimilarProfiles = {
  __typename?: 'SimilarProfiles'
  education: Array<SimilarProfilesEducation>
  emails?: Maybe<Array<Scalars['String']['output']>>
  experience: Array<SimilarProfilesExperience>
  fullName: Scalars['String']['output']
  linkedinProfilePictureUrl?: Maybe<Scalars['String']['output']>
  linkedinUrl: Scalars['String']['output']
  occupation?: Maybe<Scalars['String']['output']>
}

export type SimilarProfilesEducation = {
  __typename?: 'SimilarProfilesEducation'
  degreeName?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  fieldOfStudy?: Maybe<Scalars['String']['output']>
  school: Scalars['String']['output']
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type SimilarProfilesEducationInputObject = {
  degree?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>
  school: Scalars['String']['input']
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type SimilarProfilesExperience = {
  __typename?: 'SimilarProfilesExperience'
  company: Scalars['String']['output']
  companyLinkedinProfileUrl?: Maybe<Scalars['String']['output']>
  companyLogoUrl?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  location?: Maybe<Scalars['String']['output']>
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  title: Scalars['String']['output']
}

export type SimilarProfilesExperienceInputObject = {
  company: Scalars['String']['input']
  companyLinkedinProfileUrl?: InputMaybe<Scalars['String']['input']>
  companyLogoUrl?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
}

export type SimilarProfilesInputObject = {
  education: Array<SimilarProfilesEducationInputObject>
  experience: Array<SimilarProfilesExperienceInputObject>
  fullName: Scalars['String']['input']
  linkedinProfilePictureUrl?: InputMaybe<Scalars['String']['input']>
  linkedinUrl: Scalars['String']['input']
  occupation: Scalars['String']['input']
}

export enum SimilarProfilesMatchTypeEnum {
  Company = 'COMPANY',
  Education = 'EDUCATION',
  HiringManager = 'HIRING_MANAGER',
  Recruiter = 'RECRUITER',
  SimilarRole = 'SIMILAR_ROLE',
}

export type SimilarProfilesMessage = {
  __typename?: 'SimilarProfilesMessage'
  body: Scalars['String']['output']
  subject: Scalars['String']['output']
}

export enum SortByDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** The subscription root for the GraphQL schema */
export type Subscription = {
  __typename?: 'Subscription'
  formFieldsMapping: FormFieldsMappingPayload
  glassdoor: GlassdoorResultsPayload
  learnSkills: LearnSkillsPayload
  ocrResume: OcrResumePayload
  roast: RoastPayload
  sampleInterviewQuestions: SampleInterviewQuestionsPayload
}

export enum SubscriptionPlanEnum {
  Free = 'FREE',
  Gold = 'GOLD',
  GoldQuarterly = 'GOLD_QUARTERLY',
  Pro = 'PRO',
  ProQuarterly = 'PRO_QUARTERLY',
}

export type Users = {
  __typename?: 'Users'
  activeResumes?: Maybe<Array<Resumes>>
  activeResumesCount: Scalars['Int']['output']
  advisor?: Maybe<Users>
  advisoryOrganization?: Maybe<AdvisoryOrganization>
  certifications: Array<ResumesCertification>
  completedAllChecklistItems: Scalars['Boolean']['output']
  courseworks: Array<ResumesCoursework>
  coverLetterCustomPrompt?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  educations: Array<ResumesEducation>
  email: Scalars['String']['output']
  enableJobNotifications: Scalars['Boolean']['output']
  enableJobRecommendationsNotifications: Scalars['Boolean']['output']
  firstName?: Maybe<Scalars['String']['output']>
  groupedSkills: Array<ResumesGroupedSkill>
  hasCompletedOnboarding: Scalars['Boolean']['output']
  hasCompletedResumeTour: Scalars['Boolean']['output']
  hasSeenGoldOnboarding: Scalars['Boolean']['output']
  hasSubscription: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  involvements: Array<ResumesInvolvement>
  isAdvisoryClient: Scalars['Boolean']['output']
  isAdvisoryOrgAccount: Scalars['Boolean']['output']
  jobExperienceLevel?: Maybe<JobListingExperienceLevelEnum>
  jobListingSavedSearches: Array<JobListingSavedSearch>
  jobsAddedThisWeek: Scalars['Int']['output']
  jobsToFollowUp: Array<UsersJobs>
  lastActiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastJobUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  latestCity?: Maybe<Scalars['String']['output']>
  latestState?: Maybe<Scalars['String']['output']>
  linkedinUrl?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  numClients: Scalars['Int']['output']
  numJobs: Scalars['Int']['output']
  numOwnClients: Scalars['Int']['output']
  numStartedInterviews: Scalars['Int']['output']
  numUploadedResumes: Scalars['Int']['output']
  phoneNumber?: Maybe<Scalars['String']['output']>
  plan: SubscriptionPlanEnum
  profilePictureUrl?: Maybe<Scalars['String']['output']>
  projects: Array<ResumesProject>
  referralTokens: Scalars['Int']['output']
  resumeJobAchievementCustomPrompt?: Maybe<Scalars['String']['output']>
  resumeSummaryCustomPrompt?: Maybe<Scalars['String']['output']>
  role: UsersRoleEnum
  targetJobTitle?: Maybe<Scalars['String']['output']>
  thankYouJobs: Array<UsersJobs>
  tokenAchievements: Scalars['Int']['output']
  tokenCoverLetter: Scalars['Int']['output']
  tokenDownloadPdfs: Scalars['Int']['output']
  tokenInterview: Scalars['Int']['output']
  tokenInterviewQuestions: Scalars['Int']['output']
  tokenJobMatch: Scalars['Int']['output']
  tokenLearnSkills: Scalars['Int']['output']
  tokenOptimizeResume: Scalars['Int']['output']
  tokenProfessionalSummary: Scalars['Int']['output']
  tokenSalaryInsights: Scalars['Int']['output']
  tokenWriter: Scalars['Int']['output']
  uniqueId: Scalars['String']['output']
  usedChromeExtension: Scalars['Boolean']['output']
  usedJobAiFeature: Scalars['Boolean']['output']
  usedResumeAiFeature: Scalars['Boolean']['output']
  usersJobs: Array<UsersJobs>
  verified: Scalars['Boolean']['output']
  website?: Maybe<Scalars['String']['output']>
  workExperiences: Array<ResumesWorkExperience>
  writingStyleEnum?: Maybe<UsersWritingStyleEnum>
}

export type UsersInputObject = {
  certificationsAttributes?: InputMaybe<Array<ResumesCertificationInputObject>>
  courseworksAttributes?: InputMaybe<Array<ResumesCourseworkInputObject>>
  educationsAttributes?: InputMaybe<Array<ResumesEducationInputObject>>
  enableJobNotifications?: InputMaybe<Scalars['Boolean']['input']>
  enableJobRecommendationsNotifications?: InputMaybe<Scalars['Boolean']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  groupedSkillsAttributes?: InputMaybe<Array<ResumesGroupedSkillInputObject>>
  hasCompletedOnboarding?: InputMaybe<Scalars['Boolean']['input']>
  hasCompletedResumeTour?: InputMaybe<Scalars['Boolean']['input']>
  hasSeenGoldOnboarding?: InputMaybe<Scalars['Boolean']['input']>
  involvementsAttributes?: InputMaybe<Array<ResumesInvolvementInputObject>>
  jobExperienceLevel?: InputMaybe<JobListingExperienceLevelEnum>
  lastName?: InputMaybe<Scalars['String']['input']>
  linkedinUrl?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  projectsAttributes?: InputMaybe<Array<ResumesProjectInputObject>>
  targetJobTitle?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  workExperiencesAttributes?: InputMaybe<Array<ResumesWorkExperienceInputObject>>
}

export type UsersJobActivity = {
  __typename?: 'UsersJobActivity'
  activityDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  activityType?: Maybe<UsersJobsActivityTypeEnum>
  id: Scalars['ID']['output']
  payload?: Maybe<Scalars['String']['output']>
}

export type UsersJobs = {
  __typename?: 'UsersJobs'
  applicationInstructions?: Maybe<Scalars['String']['output']>
  appliedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  appliedChecklist: Array<UsersJobsAppliedChecklistItem>
  archived: Scalars['Boolean']['output']
  checklist: Array<UsersJobsChecklistItem>
  clientsShared: Array<Users>
  companyDomain?: Maybe<Scalars['String']['output']>
  companyName: Scalars['String']['output']
  contacts?: Maybe<Array<Contacts>>
  coverLetter?: Maybe<UsersJobsCoverLetterType>
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  interviewChecklist: Array<UsersJobsInterviewChecklistItem>
  interviewStep?: Maybe<UsersJobsInterviewStepEnum>
  interviewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  isRemote?: Maybe<Scalars['Boolean']['output']>
  jobDetails?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  matchLevel?: Maybe<UsersJobsMatchEnum>
  notes?: Maybe<Scalars['String']['output']>
  numClientsApplied: Scalars['Int']['output']
  numClientsShared: Scalars['Int']['output']
  offerAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  partnerArchived: Scalars['Boolean']['output']
  partnerCreatedByUser?: Maybe<Users>
  payPeriod: UsersJobsPayPeriodEnum
  position: Scalars['String']['output']
  rejectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  rejectedStage?: Maybe<UsersJobsRejectedStageEnum>
  resume?: Maybe<Resumes>
  salaryMax?: Maybe<Scalars['Int']['output']>
  salaryMin?: Maybe<Scalars['Int']['output']>
  status: UsersJobsStatusEnum
  updatedAt: Scalars['ISO8601DateTime']['output']
  url?: Maybe<Scalars['String']['output']>
  usersJobActivities: Array<UsersJobActivity>
  wishlistChecklist: Array<UsersJobsWishlistChecklistItem>
}

export enum UsersJobsActivityTypeEnum {
  ResumeOptimized = 'RESUME_OPTIMIZED',
  StatusApplied = 'STATUS_APPLIED',
  StatusInterview = 'STATUS_INTERVIEW',
  StatusOffer = 'STATUS_OFFER',
  StatusRejected = 'STATUS_REJECTED',
  StatusWishlist = 'STATUS_WISHLIST',
  UsersJobCreated = 'USERS_JOB_CREATED',
}

export enum UsersJobsAppliedChecklistEnum {
  FollowUp_1Week = 'FOLLOW_UP_1_WEEK',
  FollowUp_2Weeks = 'FOLLOW_UP_2_WEEKS',
  FollowUp_3Weeks = 'FOLLOW_UP_3_WEEKS',
}

export type UsersJobsAppliedChecklistItem = {
  __typename?: 'UsersJobsAppliedChecklistItem'
  appliedChecklistEnum: UsersJobsAppliedChecklistEnum
  completed: Scalars['Boolean']['output']
}

export enum UsersJobsChecklistEnum {
  CheckMatchLevel = 'CHECK_MATCH_LEVEL',
  FollowUp_1Week = 'FOLLOW_UP_1_WEEK',
  FollowUp_2Weeks = 'FOLLOW_UP_2_WEEKS',
  FollowUp_3Weeks = 'FOLLOW_UP_3_WEEKS',
  MessagePeople = 'MESSAGE_PEOPLE',
  MockInterview = 'MOCK_INTERVIEW',
  ResearchCompanyInterview = 'RESEARCH_COMPANY_INTERVIEW',
  ResearchCompanyWishlist = 'RESEARCH_COMPANY_WISHLIST',
  ThankYouEmail = 'THANK_YOU_EMAIL',
}

export type UsersJobsChecklistItem = {
  __typename?: 'UsersJobsChecklistItem'
  checklistEnum: UsersJobsChecklistEnum
  completed: Scalars['Boolean']['output']
}

export type UsersJobsCoverLetterInputObject = {
  body?: InputMaybe<Scalars['String']['input']>
  candidateAddress?: InputMaybe<Scalars['String']['input']>
  companyLocation?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  footer?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
}

export type UsersJobsCoverLetterType = {
  __typename?: 'UsersJobsCoverLetterType'
  archived: Scalars['Boolean']['output']
  body?: Maybe<Scalars['String']['output']>
  candidateAddress?: Maybe<Scalars['String']['output']>
  category?: Maybe<Scalars['String']['output']>
  companyLocation?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  email?: Maybe<Scalars['String']['output']>
  exampleImageUrl?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  footer?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastName?: Maybe<Scalars['String']['output']>
  mostRecentUsedResumeForGenerate?: Maybe<Resumes>
  name?: Maybe<Scalars['String']['output']>
  nameSlug?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  usersJob: UsersJobs
}

export enum UsersJobsInterviewChecklistEnum {
  MockInterview = 'MOCK_INTERVIEW',
  ResearchCompanyInterview = 'RESEARCH_COMPANY_INTERVIEW',
  ThankYouEmail = 'THANK_YOU_EMAIL',
}

export type UsersJobsInterviewChecklistItem = {
  __typename?: 'UsersJobsInterviewChecklistItem'
  completed: Scalars['Boolean']['output']
  interviewChecklistEnum: UsersJobsInterviewChecklistEnum
}

export enum UsersJobsInterviewStepEnum {
  IntroScreen = 'INTRO_SCREEN',
  Onsite = 'ONSITE',
  PhoneScreen = 'PHONE_SCREEN',
}

export type UsersJobsMatch = {
  __typename?: 'UsersJobsMatch'
  hardSkills: Array<Scalars['String']['output']>
  matchLevel: UsersJobsMatchEnum
  matches: Array<FieldMessageType>
}

export enum UsersJobsMatchEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export enum UsersJobsPayPeriodEnum {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY',
}

export type UsersJobsPerformanceDateRange = {
  __typename?: 'UsersJobsPerformanceDateRange'
  allJobs: Array<UsersJobs>
  appliedJobs: Array<UsersJobs>
  interviewedJobs: Array<UsersJobs>
  numAllJobs: Scalars['Int']['output']
  numAppliedJobs: Scalars['Int']['output']
  numInterviewedJobs: Scalars['Int']['output']
  numOfferedJobs: Scalars['Int']['output']
  numRejectedJobs: Scalars['Int']['output']
  offeredJobs: Array<UsersJobs>
  rejectedJobs: Array<UsersJobs>
}

export enum UsersJobsRejectedStageEnum {
  Application = 'APPLICATION',
  Interview = 'INTERVIEW',
  Reference = 'REFERENCE',
}

export enum UsersJobsStatusEnum {
  Applied = 'APPLIED',
  Interview = 'INTERVIEW',
  Offer = 'OFFER',
  Rejected = 'REJECTED',
  Wishlist = 'WISHLIST',
}

export enum UsersJobsWishlistChecklistEnum {
  CheckMatchLevel = 'CHECK_MATCH_LEVEL',
  MessagePeople = 'MESSAGE_PEOPLE',
  ResearchCompanyWishlist = 'RESEARCH_COMPANY_WISHLIST',
}

export type UsersJobsWishlistChecklistItem = {
  __typename?: 'UsersJobsWishlistChecklistItem'
  completed: Scalars['Boolean']['output']
  wishlistChecklistEnum: UsersJobsWishlistChecklistEnum
}

export enum UsersRoleEnum {
  AccountManager = 'ACCOUNT_MANAGER',
  Admin = 'ADMIN',
  Advisor = 'ADVISOR',
  Jobseeker = 'JOBSEEKER',
}

export enum UsersWritingStyleEnum {
  BalancedProfessional = 'BALANCED_PROFESSIONAL',
  CreativeSpirit = 'CREATIVE_SPIRIT',
  StrategicProfessional = 'STRATEGIC_PROFESSIONAL',
  TechnicalAuthority = 'TECHNICAL_AUTHORITY',
}

export type WritingSample = {
  __typename?: 'WritingSample'
  answer: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  question: Scalars['String']['output']
}

export type AdvisorsList_AdvisorsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  role?: InputMaybe<UsersRoleEnum>
  sortBy?: InputMaybe<AdvisorSortEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
}>

export type AdvisorsList_AdvisorsQuery = {
  __typename?: 'Query'
  advisors: {
    __typename?: 'PaginatedAdvisorUsers'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'AdvisorUsers'
      id: string
      jobsShared: Array<{
        __typename?: 'UsersJobs'
        id: string
        applicationInstructions?: string | null
        createdAt: any
        companyName: string
        isRemote?: boolean | null
        jobDetails?: string | null
        location?: string | null
        notes?: string | null
        payPeriod: UsersJobsPayPeriodEnum
        position: string
        salaryMax?: number | null
        salaryMin?: number | null
        status: UsersJobsStatusEnum
        updatedAt: any
        url?: string | null
        archived: boolean
        rejectedStage?: UsersJobsRejectedStageEnum | null
        interviewStep?: UsersJobsInterviewStepEnum | null
        numClientsApplied: number
        numClientsShared: number
        partnerArchived: boolean
        checklist: Array<{
          __typename?: 'UsersJobsChecklistItem'
          checklistEnum: UsersJobsChecklistEnum
          completed: boolean
        }>
        partnerCreatedByUser?: {
          __typename?: 'Users'
          id: string
          firstName?: string | null
          lastName?: string | null
        } | null
        contacts?: Array<{
          __typename?: 'Contacts'
          id: string
          email?: string | null
          name?: string | null
        }> | null
        resume?: { __typename?: 'Resumes'; id: string; name: string } | null
      }>
      jobsAdded: Array<{
        __typename?: 'UsersJobs'
        id: string
        applicationInstructions?: string | null
        createdAt: any
        companyName: string
        isRemote?: boolean | null
        jobDetails?: string | null
        location?: string | null
        notes?: string | null
        payPeriod: UsersJobsPayPeriodEnum
        position: string
        salaryMax?: number | null
        salaryMin?: number | null
        status: UsersJobsStatusEnum
        updatedAt: any
        url?: string | null
        archived: boolean
        rejectedStage?: UsersJobsRejectedStageEnum | null
        interviewStep?: UsersJobsInterviewStepEnum | null
        numClientsApplied: number
        numClientsShared: number
        partnerArchived: boolean
        checklist: Array<{
          __typename?: 'UsersJobsChecklistItem'
          checklistEnum: UsersJobsChecklistEnum
          completed: boolean
        }>
        partnerCreatedByUser?: {
          __typename?: 'Users'
          id: string
          firstName?: string | null
          lastName?: string | null
        } | null
        contacts?: Array<{
          __typename?: 'Contacts'
          id: string
          email?: string | null
          name?: string | null
        }> | null
        resume?: { __typename?: 'Resumes'; id: string; name: string } | null
      }>
      user: {
        __typename?: 'Users'
        id: string
        numOwnClients: number
        uniqueId: string
        role: UsersRoleEnum
        email: string
        firstName?: string | null
        lastName?: string | null
        plan: SubscriptionPlanEnum
        activeResumesCount: number
        coverLetterCustomPrompt?: string | null
        hasCompletedResumeTour: boolean
        resumeSummaryCustomPrompt?: string | null
        resumeJobAchievementCustomPrompt?: string | null
        tokenCoverLetter: number
        tokenDownloadPdfs: number
        tokenInterviewQuestions: number
        tokenJobMatch: number
        tokenProfessionalSummary: number
        tokenSalaryInsights: number
        tokenLearnSkills: number
        tokenAchievements: number
        tokenInterview: number
        tokenWriter: number
        tokenOptimizeResume: number
        usedChromeExtension: boolean
        numUploadedResumes: number
        numStartedInterviews: number
        referralTokens: number
        hasSubscription: boolean
        isAdvisoryClient: boolean
        isAdvisoryOrgAccount: boolean
        profilePictureUrl?: string | null
        writingStyleEnum?: UsersWritingStyleEnum | null
        hasSeenGoldOnboarding: boolean
        hasCompletedOnboarding: boolean
        jobExperienceLevel?: JobListingExperienceLevelEnum | null
        targetJobTitle?: string | null
        createdAt: any
        location?: string | null
      }
    }>
  }
}

export type ClientGroupClientContent_ClientGroupsQueryVariables = Exact<{
  clientGroupId: Scalars['ID']['input']
}>

export type ClientGroupClientContent_ClientGroupsQuery = {
  __typename?: 'Query'
  clientGroups: Array<{ __typename?: 'ClientGroup'; id: string; name: string }>
}

export type ClientGroupClientList_ClientGroupsQueryVariables = Exact<{
  clientGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type ClientGroupClientList_ClientGroupsQuery = {
  __typename?: 'Query'
  clientGroups: Array<{
    __typename?: 'ClientGroup'
    id: string
    name: string
    clients: Array<{
      __typename?: 'ClientUsers'
      id: string
      numAllJobs: number
      numInterviewedJobs: number
      numOfferedJobs: number
      numRejectedJobs: number
      numAppliedJobs: number
      user: {
        __typename?: 'Users'
        firstName?: string | null
        lastName?: string | null
        lastActiveAt?: any | null
        advisor?: {
          __typename?: 'Users'
          firstName?: string | null
          lastName?: string | null
        } | null
      }
    }>
  }>
}

export type ClientBoard_ClientUsersJobsQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
  clientId: Scalars['ID']['input']
}>

export type ClientBoard_ClientUsersJobsQuery = {
  __typename?: 'Query'
  clientUsersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    applicationInstructions?: string | null
    createdAt: any
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }>
}

export type ClientContent_ClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input']
}>

export type ClientContent_ClientQuery = {
  __typename?: 'Query'
  client: {
    __typename?: 'Users'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    lastActiveAt?: any | null
    usersJobs: Array<{ __typename?: 'UsersJobs'; id: string; archived: boolean }>
    activeResumes?: Array<{ __typename?: 'Resumes'; id: string }> | null
  }
}

export type ClientResumes_ClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input']
}>

export type ClientResumes_ClientQuery = {
  __typename?: 'Query'
  client: {
    __typename?: 'Users'
    id: string
    activeResumes?: Array<{
      __typename?: 'Resumes'
      id: string
      name: string
      createdAt: any
      updatedAt: any
    }> | null
  }
}

export type ClientsList_ClientsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  advisorIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ClientsList_ClientsQuery = {
  __typename?: 'Query'
  clients: {
    __typename?: 'PaginatedClientUsers'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'ClientUsers'
      id: string
      numAllJobs: number
      numAppliedJobs: number
      numInterviewedJobs: number
      numOfferedJobs: number
      numRejectedJobs: number
      user: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
        lastActiveAt?: any | null
        advisor?: {
          __typename?: 'Users'
          id: string
          firstName?: string | null
          lastName?: string | null
        } | null
      }
    }>
  }
}

export type JobPostingsList_JobPostingsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  archived?: InputMaybe<Scalars['Boolean']['input']>
  sortBy?: InputMaybe<JobPostingSortEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
}>

export type JobPostingsList_JobPostingsQuery = {
  __typename?: 'Query'
  paginatedUsersJobs: {
    __typename?: 'PaginatedUsersJobs'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'UsersJobs'
      id: string
      archived: boolean
      companyName: string
      createdAt: any
      numClientsApplied: number
      numClientsShared: number
      position: string
      location?: string | null
      isRemote?: boolean | null
      url?: string | null
      payPeriod: UsersJobsPayPeriodEnum
      salaryMin?: number | null
      salaryMax?: number | null
      clientsShared: Array<{
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      }>
    }>
  }
}

export type JobPostingsList_UpdateUsersJobArchivedMutationVariables = Exact<{
  id: Scalars['ID']['input']
  archived?: InputMaybe<Scalars['Boolean']['input']>
}>

export type JobPostingsList_UpdateUsersJobArchivedMutation = {
  __typename?: 'Mutation'
  updateUsersJob: { __typename?: 'UsersJobs'; id: string; archived: boolean }
}

export type ApplicationChartContent_UsersJobsFragment = {
  __typename?: 'UsersJobs'
  id: string
  companyName: string
  appliedAt?: any | null
  createdAt: any
  interviewedAt?: any | null
}

export type ApplicationChartContent_UsersJobsDateRangeQueryVariables = Exact<{
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}>

export type ApplicationChartContent_UsersJobsDateRangeQuery = {
  __typename?: 'Query'
  usersJobsDateRange: {
    __typename?: 'UsersJobsPerformanceDateRange'
    numAllJobs: number
    numAppliedJobs: number
    numInterviewedJobs: number
    numOfferedJobs: number
    numRejectedJobs: number
    allJobs: Array<{
      __typename?: 'UsersJobs'
      id: string
      companyName: string
      appliedAt?: any | null
      createdAt: any
      interviewedAt?: any | null
    }>
    appliedJobs: Array<{
      __typename?: 'UsersJobs'
      id: string
      companyName: string
      appliedAt?: any | null
      createdAt: any
      interviewedAt?: any | null
    }>
    interviewedJobs: Array<{
      __typename?: 'UsersJobs'
      id: string
      companyName: string
      appliedAt?: any | null
      createdAt: any
      interviewedAt?: any | null
    }>
  }
}

export type UserJobsActivityFragment = {
  __typename?: 'UsersJobs'
  id: string
  interviewStep?: UsersJobsInterviewStepEnum | null
  interviewedAt?: any | null
  createdAt: any
  appliedAt?: any | null
  offerAt?: any | null
  rejectedAt?: any | null
  rejectedStage?: UsersJobsRejectedStageEnum | null
}

export type ActivityTab_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ActivityTab_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    usersJobActivities: Array<{
      __typename?: 'UsersJobActivity'
      id: string
      activityType?: UsersJobsActivityTypeEnum | null
      activityDate?: any | null
      payload?: string | null
    }>
  }>
}

export type ApplicationDetailsPanel_UsersJobsFragment = {
  __typename?: 'UsersJobs'
  companyName: string
  companyDomain?: string | null
}

export type ApplicationDetailsPanel_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ApplicationDetailsPanel_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    companyName: string
    companyDomain?: string | null
  }>
}

export type ApplicationDetailsPanel_GenerateCompanyDomainMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ApplicationDetailsPanel_GenerateCompanyDomainMutation = {
  __typename?: 'Mutation'
  generateCompanyDomain: {
    __typename?: 'UsersJobs'
    companyName: string
    companyDomain?: string | null
  }
}

export type ApplicationNotes_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ApplicationNotes_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{ __typename?: 'UsersJobs'; id: string; notes?: string | null }>
}

export type ApplicationNotes_UpdateUsersJobMutationVariables = Exact<{
  id: Scalars['ID']['input']
  notes: Scalars['String']['input']
}>

export type ApplicationNotes_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: { __typename?: 'UsersJobs'; id: string; notes?: string | null }
}

export type ApplicationsOverview_UsersJobsQueryVariables = Exact<{
  applicationId: Scalars['ID']['input']
}>

export type ApplicationsOverview_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    position: string
    companyName: string
    status: UsersJobsStatusEnum
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
  }>
}

export type ApplicationsOverview_GenerateMessageForContactMutationVariables = Exact<{
  messageType: MessagesMessageType
  contactRelationship: MessagesContactType
  contactName: Scalars['String']['input']
  jobTitle: Scalars['String']['input']
  companyName: Scalars['String']['input']
}>

export type ApplicationsOverview_GenerateMessageForContactMutation = {
  __typename?: 'Mutation'
  generateMessageForContact: {
    __typename?: 'SimilarProfilesMessage'
    body: string
    subject: string
  }
}

export type CompanyActionBar_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type CompanyActionBar_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    companyName: string
    companyDomain?: string | null
    position: string
    createdAt: any
    updatedAt: any
    archived: boolean
    status: UsersJobsStatusEnum
    matchLevel?: UsersJobsMatchEnum | null
  }>
}

export type CompanyContactsOverview_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type CompanyContactsOverview_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{ __typename?: 'UsersJobs'; id: string; companyName: string }>
}

export type CompanyContactsOverview_GetLinkedinConnectionsUrlQueryVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type CompanyContactsOverview_GetLinkedinConnectionsUrlQuery = {
  __typename?: 'Query'
  getLinkedinConnectionsUrl: string
}

export type CompanyContactsOverview_NetworkingPeopleFromUsersJobQueryVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type CompanyContactsOverview_NetworkingPeopleFromUsersJobQuery = {
  __typename?: 'Query'
  networkingPeopleFromUsersJob: Array<{
    __typename?: 'ProfileMatchSimilarProfile'
    matchTypes: Array<SimilarProfilesMatchTypeEnum>
    profile: {
      __typename?: 'SimilarProfiles'
      fullName: string
      linkedinProfilePictureUrl?: string | null
      linkedinUrl: string
      occupation?: string | null
      emails?: Array<string> | null
      education: Array<{
        __typename?: 'SimilarProfilesEducation'
        school: string
        degreeName?: string | null
        fieldOfStudy?: string | null
        startDate?: any | null
        endDate?: any | null
      }>
      experience: Array<{
        __typename?: 'SimilarProfilesExperience'
        company: string
        companyLinkedinProfileUrl?: string | null
        companyLogoUrl?: string | null
        endDate?: any | null
        startDate?: any | null
        location?: string | null
        title: string
      }>
    }
  }>
}

export type CompanyDetails_UsersJobsFragment = {
  __typename?: 'UsersJobs'
  companyName: string
  companyDomain?: string | null
}

export type CompanyDetails_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type CompanyDetails_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    companyName: string
    companyDomain?: string | null
  }>
}

export type CompanyDetails_GenerateCompanyDomainMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CompanyDetails_GenerateCompanyDomainMutation = {
  __typename?: 'Mutation'
  generateCompanyDomain: {
    __typename?: 'UsersJobs'
    companyName: string
    companyDomain?: string | null
  }
}

export type CompanyDetails_UpdateUsersJobMutationVariables = Exact<{
  companyName?: InputMaybe<Scalars['String']['input']>
  companyDomain?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}>

export type CompanyDetails_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    companyName: string
    companyDomain?: string | null
  }
}

export type CompanyInsightsOverview_GetLatestCompanyInfoQueryVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type CompanyInsightsOverview_GetLatestCompanyInfoQuery = {
  __typename?: 'Query'
  getLatestCompanyInfo?: {
    __typename?: 'CompanyLatestInfo'
    companyCultureAndPractices?: string | null
    missionAndVisionOfCompany?: string | null
    maximumSalary?: number | null
    minimumSalary?: number | null
    expectedSalaryMessage?: string | null
    accomplishmentsAndAnnouncementsAndProductReleases?: Array<{
      __typename?: 'CompanyLatestInfoSource'
      description: string
      source: string
    }> | null
    competitors?: Array<{
      __typename?: 'CompanyLatestInfoCompetitors'
      name: string
      website: string
    }> | null
    fundingsRounds?: Array<{
      __typename?: 'CompanyLatestInfoSource'
      description: string
      source: string
    }> | null
    growthFinancialNumbers?: Array<{
      __typename?: 'CompanyLatestInfoSource'
      description: string
      source: string
    }> | null
  } | null
}

export type CompanyInsightsOverview_GetGlassdoorResultsQueryVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type CompanyInsightsOverview_GetGlassdoorResultsQuery = {
  __typename?: 'Query'
  getGlassdoorResults: string
}

export type GlassdoorResultsSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>

export type GlassdoorResultsSubscriptionSubscription = {
  __typename?: 'Subscription'
  glassdoor: {
    __typename?: 'GlassdoorResultsPayload'
    url?: string | null
    rating?: number | null
    whatProsUsersAreSaying?: string | null
    whatConsUsersAreSaying?: string | null
    whatConsUsersAreSayingAboutPosition?: string | null
    whatProsUsersAreSayingAboutPosition?: string | null
    usersJobId: string
    initial: boolean
    requestId: string
  }
}

export type CompanyOverview_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type CompanyOverview_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{ __typename?: 'UsersJobs'; id: string; companyName: string }>
}

export type CompanyOverview_GetAboutCompanyInfoQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CompanyOverview_GetAboutCompanyInfoQuery = {
  __typename?: 'Query'
  getAboutCompanyInfo?: {
    __typename?: 'CompanyAboutInfo'
    foundedYear?: number | null
    industry?: string | null
    linkedinCompanyUrl?: string | null
    location?: string | null
    numberOfEmployeeRangeMax?: number | null
    numberOfEmployeeRangeMin?: number | null
    websiteUrl?: string | null
    description?: string | null
  } | null
}

export type DocumentsTab_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type DocumentsTab_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
    coverLetter?: {
      __typename?: 'UsersJobsCoverLetterType'
      id: string
      name?: string | null
    } | null
  }>
}

export type InterviewingDetailsFragment = {
  __typename?: 'UsersJobs'
  status: UsersJobsStatusEnum
  interviewStep?: UsersJobsInterviewStepEnum | null
  rejectedStage?: UsersJobsRejectedStageEnum | null
  appliedAt?: any | null
  interviewedAt?: any | null
  resume?: { __typename?: 'Resumes'; id: string } | null
}

export type InterviewingDetails_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type InterviewingDetails_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    status: UsersJobsStatusEnum
    interviewStep?: UsersJobsInterviewStepEnum | null
    rejectedStage?: UsersJobsRejectedStageEnum | null
    appliedAt?: any | null
    interviewedAt?: any | null
    resume?: { __typename?: 'Resumes'; id: string } | null
  }>
}

export type InterviewingDetails_UpdateUsersJobMutationVariables = Exact<{
  id: Scalars['ID']['input']
  appliedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  interviewedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  interviewStep?: InputMaybe<UsersJobsInterviewStepEnum>
  rejectedStage?: InputMaybe<UsersJobsRejectedStageEnum>
  status?: InputMaybe<UsersJobsStatusEnum>
  resumeId?: InputMaybe<Scalars['ID']['input']>
}>

export type InterviewingDetails_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    status: UsersJobsStatusEnum
    interviewStep?: UsersJobsInterviewStepEnum | null
    rejectedStage?: UsersJobsRejectedStageEnum | null
    appliedAt?: any | null
    interviewedAt?: any | null
    resume?: { __typename?: 'Resumes'; id: string } | null
  }
}

export type LearnSkills_LearnSkillsMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type LearnSkills_LearnSkillsMutation = {
  __typename?: 'Mutation'
  learnSkills: { __typename?: 'CachedStreamingType'; result: string; isSync: boolean }
}

export type LearnSkillsSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>

export type LearnSkillsSubscriptionSubscription = {
  __typename?: 'Subscription'
  learnSkills: {
    __typename?: 'LearnSkillsPayload'
    content: string
    usersJobId: string
    initial: boolean
    requestId: string
    i?: number | null
  }
}

export type MatchScore_ResumesQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
}>

export type MatchScore_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    aiGenerated: boolean
    name: string
    groupedSkills: Array<{ __typename?: 'ResumesGroupedSkill'; skills: Array<string> }>
  }>
}

export type MatchScore_AmIaGoodFitMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
  resumeId: Scalars['ID']['input']
  position: Scalars['String']['input']
  jobDescription?: InputMaybe<Scalars['String']['input']>
}>

export type MatchScore_AmIaGoodFitMutation = {
  __typename?: 'Mutation'
  amIAGoodFit?: {
    __typename?: 'AmIAGoodFit'
    overallSummary?: string | null
    overallMatch?: UsersJobsMatchEnum | null
    relevantEducation?: string | null
    relevantEducationMatch?: boolean | null
    relevantExperience?: string | null
    relevantExperienceMatch?: boolean | null
    relevantSkills?: string | null
    relevantSkillsMatch?: boolean | null
  } | null
}

export type NextStepsChecklist_GetChecklistQueryVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type NextStepsChecklist_GetChecklistQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    status: UsersJobsStatusEnum
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
  }>
}

export type NextStepsChecklist_UpdateChecklistMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
  appliedChecklistCompleted?: InputMaybe<Array<UsersJobsChecklistEnum> | UsersJobsChecklistEnum>
  interviewChecklistCompleted?: InputMaybe<Array<UsersJobsChecklistEnum> | UsersJobsChecklistEnum>
  wishlistChecklistCompleted?: InputMaybe<Array<UsersJobsChecklistEnum> | UsersJobsChecklistEnum>
}>

export type NextStepsChecklist_UpdateChecklistMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
  }
}

export type PositionDetailsFragment = {
  __typename?: 'UsersJobs'
  interviewStep?: UsersJobsInterviewStepEnum | null
  isRemote?: boolean | null
  jobDetails?: string | null
  location?: string | null
  notes?: string | null
  payPeriod: UsersJobsPayPeriodEnum
  rejectedStage?: UsersJobsRejectedStageEnum | null
  position: string
  salaryMax?: number | null
  salaryMin?: number | null
  status: UsersJobsStatusEnum
  url?: string | null
  resume?: { __typename?: 'Resumes'; id: string } | null
}

export type PositionDetails_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type PositionDetails_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    interviewStep?: UsersJobsInterviewStepEnum | null
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    rejectedStage?: UsersJobsRejectedStageEnum | null
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    url?: string | null
    resume?: { __typename?: 'Resumes'; id: string } | null
  }>
}

export type PositionDetails_UpdateUsersJobMutationVariables = Exact<{
  id: Scalars['ID']['input']
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobDetails?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  payPeriod?: InputMaybe<UsersJobsPayPeriodEnum>
  salaryMax?: InputMaybe<Scalars['Int']['input']>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
}>

export type PositionDetails_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    interviewStep?: UsersJobsInterviewStepEnum | null
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    rejectedStage?: UsersJobsRejectedStageEnum | null
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    url?: string | null
    resume?: { __typename?: 'Resumes'; id: string } | null
  }
}

export type SalaryInsights_SalaryInsightsMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
}>

export type SalaryInsights_SalaryInsightsMutation = {
  __typename?: 'Mutation'
  salaryInsights: string
}

export type ApplicationContent_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ApplicationContent_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    interviewStep?: UsersJobsInterviewStepEnum | null
    interviewedAt?: any | null
    createdAt: any
    appliedAt?: any | null
    offerAt?: any | null
    rejectedAt?: any | null
    rejectedStage?: UsersJobsRejectedStageEnum | null
    applicationInstructions?: string | null
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }>
  user: {
    __typename?: 'Users'
    id: string
    tokenSalaryInsights: number
    tokenJobMatch: number
    tokenLearnSkills: number
    tokenAchievements: number
    plan: SubscriptionPlanEnum
  }
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string; aiGenerated: boolean }>
}

export type ApplicationContent_UpdateUsersJobMutationVariables = Exact<{
  applicationInstructions?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobDetails?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  payPeriod?: InputMaybe<UsersJobsPayPeriodEnum>
  position?: InputMaybe<Scalars['String']['input']>
  salaryMax?: InputMaybe<Scalars['Int']['input']>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<UsersJobsStatusEnum>
  rejectedStage?: InputMaybe<UsersJobsRejectedStageEnum>
  interviewStep?: InputMaybe<UsersJobsInterviewStepEnum>
  url?: InputMaybe<Scalars['String']['input']>
  resumeId?: InputMaybe<Scalars['ID']['input']>
}>

export type ApplicationContent_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    interviewStep?: UsersJobsInterviewStepEnum | null
    interviewedAt?: any | null
    createdAt: any
    appliedAt?: any | null
    offerAt?: any | null
    rejectedAt?: any | null
    rejectedStage?: UsersJobsRejectedStageEnum | null
    applicationInstructions?: string | null
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }
}

export type Applications_UsersJobsQueryVariables = Exact<{
  archived: Scalars['Boolean']['input']
  searchTerm?: InputMaybe<Scalars['String']['input']>
}>

export type Applications_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    applicationInstructions?: string | null
    createdAt: any
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }>
}

export type Applications_GetMatchLevelsQueryVariables = Exact<{
  archived: Scalars['Boolean']['input']
}>

export type Applications_GetMatchLevelsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    archived: boolean
    matchLevel?: UsersJobsMatchEnum | null
  }>
}

export type Applications_UpdateUsersJobStatusMutationVariables = Exact<{
  id: Scalars['ID']['input']
  status: UsersJobsStatusEnum
}>

export type Applications_UpdateUsersJobStatusMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename: 'UsersJobs'
    id: string
    applicationInstructions?: string | null
    createdAt: any
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }
}

export type Applications_UpdateUsersJobMutationVariables = Exact<{
  id: Scalars['ID']['input']
  archived?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<UsersJobsStatusEnum>
}>

export type Applications_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: {
    __typename: 'UsersJobs'
    id: string
    applicationInstructions?: string | null
    createdAt: any
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }
}

export type CoverLetterFragment = {
  __typename?: 'UsersJobsCoverLetterType'
  id: string
  updatedAt: any
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  candidateAddress?: string | null
  companyName?: string | null
  companyLocation?: string | null
  phoneNumber?: string | null
  body?: string | null
  footer?: string | null
  archived: boolean
  mostRecentUsedResumeForGenerate?: { __typename?: 'Resumes'; id: string } | null
}

export type CoverLetterContent_CoverLettersQueryVariables = Exact<{
  coverLetterId: Scalars['ID']['input']
}>

export type CoverLetterContent_CoverLettersQuery = {
  __typename?: 'Query'
  coverLetters: Array<{
    __typename?: 'UsersJobsCoverLetterType'
    id: string
    updatedAt: any
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    candidateAddress?: string | null
    companyName?: string | null
    companyLocation?: string | null
    phoneNumber?: string | null
    body?: string | null
    footer?: string | null
    archived: boolean
    usersJob: {
      __typename?: 'UsersJobs'
      id: string
      applicationInstructions?: string | null
      createdAt: any
      companyName: string
      isRemote?: boolean | null
      jobDetails?: string | null
      location?: string | null
      notes?: string | null
      payPeriod: UsersJobsPayPeriodEnum
      position: string
      salaryMax?: number | null
      salaryMin?: number | null
      status: UsersJobsStatusEnum
      updatedAt: any
      url?: string | null
      archived: boolean
      rejectedStage?: UsersJobsRejectedStageEnum | null
      interviewStep?: UsersJobsInterviewStepEnum | null
      numClientsApplied: number
      numClientsShared: number
      partnerArchived: boolean
      checklist: Array<{
        __typename?: 'UsersJobsChecklistItem'
        checklistEnum: UsersJobsChecklistEnum
        completed: boolean
      }>
      partnerCreatedByUser?: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      } | null
      contacts?: Array<{
        __typename?: 'Contacts'
        id: string
        email?: string | null
        name?: string | null
      }> | null
      resume?: { __typename?: 'Resumes'; id: string; name: string } | null
    }
    mostRecentUsedResumeForGenerate?: { __typename?: 'Resumes'; id: string } | null
  }>
}

export type CoverLettercontent_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type CoverLettercontent_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type CoverLetterContent_GenerateCoverLetterMutationVariables = Exact<{
  coverLetterLength?: InputMaybe<CoverLetterLengthEnum>
  coverLetterTone?: InputMaybe<CoverLetterToneEnum>
  customPrompt?: InputMaybe<Scalars['String']['input']>
  resumeId: Scalars['ID']['input']
  usersJobId: Scalars['ID']['input']
}>

export type CoverLetterContent_GenerateCoverLetterMutation = {
  __typename?: 'Mutation'
  generateCoverLetter: { __typename?: 'UsersJobsCoverLetterType'; id: string; body?: string | null }
}

export type CoverLetterContent_CoverLetterUpsertMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
  attributes: UsersJobsCoverLetterInputObject
}>

export type CoverLetterContent_CoverLetterUpsertMutation = {
  __typename?: 'Mutation'
  coverLetterUpsert: {
    __typename?: 'UsersJobsCoverLetterType'
    id: string
    updatedAt: any
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    candidateAddress?: string | null
    companyName?: string | null
    companyLocation?: string | null
    phoneNumber?: string | null
    body?: string | null
    footer?: string | null
    archived: boolean
    mostRecentUsedResumeForGenerate?: { __typename?: 'Resumes'; id: string } | null
  }
}

export type CoverLettersList_CoverLettersQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
}>

export type CoverLettersList_CoverLettersQuery = {
  __typename?: 'Query'
  coverLetters: Array<{
    __typename?: 'UsersJobsCoverLetterType'
    id: string
    body?: string | null
    createdAt: any
    usersJob: { __typename?: 'UsersJobs'; id: string; companyName: string; position: string }
  }>
}

export type ListEmpty_CreateResumeMutationVariables = Exact<{
  name: Scalars['String']['input']
}>

export type ListEmpty_CreateResumeMutation = {
  __typename?: 'Mutation'
  createResume: { __typename?: 'Resumes'; id: string; name: string }
}

export type HeadshotsList_AllHeadshotsQueryVariables = Exact<{ [key: string]: never }>

export type HeadshotsList_AllHeadshotsQuery = {
  __typename?: 'Query'
  headshotRequests: Array<{ __typename?: 'HeadshotRequest'; id: string; createdAt: any }>
}

export type Interview_GetInterviewQueryVariables = Exact<{
  interviewId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type Interview_GetInterviewQuery = {
  __typename?: 'Query'
  interviews: Array<{
    __typename?: 'Interview'
    id: string
    status: InterviewsStatusEnum
    interviewType: InterviewsTypeEnum
    score?: number | null
    jobTitle: string
    messages: Array<{ __typename?: 'InterviewsMessage'; fromUser: boolean; message: string }>
  }>
}

export type InterviewsSidebar_InterviewsQueryVariables = Exact<{ [key: string]: never }>

export type InterviewsSidebar_InterviewsQuery = {
  __typename?: 'Query'
  interviews: Array<{
    __typename?: 'Interview'
    id: string
    status: InterviewsStatusEnum
    interviewType: InterviewsTypeEnum
    score?: number | null
    jobTitle: string
  }>
}

export type Interviews_InterviewFragment = {
  __typename?: 'Interview'
  id: string
  status: InterviewsStatusEnum
  interviewType: InterviewsTypeEnum
  score?: number | null
  jobTitle: string
  messages: Array<{ __typename?: 'InterviewsMessage'; fromUser: boolean; message: string }>
}

export type Interviews_InterviewsQueryVariables = Exact<{ [key: string]: never }>

export type Interviews_InterviewsQuery = {
  __typename?: 'Query'
  interviews: Array<{
    __typename?: 'Interview'
    id: string
    status: InterviewsStatusEnum
    interviewType: InterviewsTypeEnum
    score?: number | null
    jobTitle: string
  }>
}

export type Interviews_InterviewAddMessageMutationVariables = Exact<{
  interviewId: Scalars['String']['input']
  message: Scalars['String']['input']
}>

export type Interviews_InterviewAddMessageMutation = {
  __typename?: 'Mutation'
  interviewAddMessage: {
    __typename?: 'Interview'
    id: string
    status: InterviewsStatusEnum
    interviewType: InterviewsTypeEnum
    score?: number | null
    jobTitle: string
    messages: Array<{ __typename?: 'InterviewsMessage'; fromUser: boolean; message: string }>
  }
}

export type JobSearchDetailsPage_GetJobListingQueryVariables = Exact<{
  jobListingId: Scalars['ID']['input']
}>

export type JobSearchDetailsPage_GetJobListingQuery = {
  __typename?: 'Query'
  jobListing: {
    __typename?: 'JobListings'
    id: string
    aiCoreResponsibilities?: string | null
    aiWorkArrangement?: JobListingWorkArrangementEnum | null
    aiEducationRequirements?: Array<JobListingEducationLevelEnum> | null
    aiRequirementsSummary?: string | null
    benefits: Array<string>
    companyDescription?: string | null
    companyDomain?: string | null
    companyIndustry?: string | null
    companyNumEmployees?: number | null
    companySpecialties: Array<string>
    companyLinkedinUrl?: string | null
    companyLogoUrl?: string | null
    employmentType?: JobListingEmploymentTypeEnum | null
    jobDetails?: string | null
    keySkills: Array<string>
    visaSponsorship: boolean
    workingHours?: number | null
    experienceLevelString?: string | null
    hiringManagerEmail?: string | null
    hiringManagerName?: string | null
    position: string
    companyName: string
    url?: string | null
    datePosted: any
    isRemote?: boolean | null
    location?: string | null
    salaryMax?: number | null
    salaryMin?: number | null
    salaryCurrency?: string | null
    payPeriod?: JobListingPayPeriodEnum | null
  }
  hasAddedJobListing?: { __typename?: 'UsersJobs'; id: string; status: UsersJobsStatusEnum } | null
}

export type JobSearchResultsPage_PaginatedJobListingsQueryVariables = Exact<{
  attributes?: InputMaybe<JobListingsFilterInputObject>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<JobListingsSortEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
}>

export type JobSearchResultsPage_PaginatedJobListingsQuery = {
  __typename?: 'Query'
  paginatedJobListings: {
    __typename?: 'PaginatedJobListings'
    data: Array<{
      __typename?: 'JobListings'
      id: string
      position: string
      companyName: string
      url?: string | null
      companyLogoUrl?: string | null
      companyIndustry?: string | null
      datePosted: any
      isRemote?: boolean | null
      location?: string | null
      salaryMax?: number | null
      salaryMin?: number | null
      salaryCurrency?: string | null
      employmentType?: JobListingEmploymentTypeEnum | null
      payPeriod?: JobListingPayPeriodEnum | null
    }>
    pagination: {
      __typename?: 'Pagination'
      page: number
      pageSize: number
      totalCount: number
      totalPages: number
    }
  }
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    url?: string | null
    status: UsersJobsStatusEnum
  }>
}

export type JobPage_GetJobListingQueryVariables = Exact<{
  jobListingId: Scalars['ID']['input']
}>

export type JobPage_GetJobListingQuery = {
  __typename?: 'Query'
  jobListing: { __typename?: 'JobListings'; id: string; companyName: string; position: string }
}

export type ResumePage_GetResumeQueryVariables = Exact<{
  resumeId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ResumePage_GetResumeQuery = {
  __typename?: 'Query'
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }>
}

export type ResumesList_ResumesFragment = {
  __typename?: 'Resumes'
  id: string
  name: string
  archived: boolean
  createdAt: any
  updatedAt: any
  aiGenerated: boolean
}

export type ResumesList_AllResumesQueryVariables = Exact<{ [key: string]: never }>

export type ResumesList_AllResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type ResumesList_ResumesQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>
  aiGeneratedForJobTitle?: InputMaybe<Scalars['Boolean']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
}>

export type ResumesList_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    name: string
    archived: boolean
    createdAt: any
    updatedAt: any
    aiGenerated: boolean
  }>
}

export type ResumeList_UpdateArchivedResumeMutationVariables = Exact<{
  id: Scalars['ID']['input']
  archived: Scalars['Boolean']['input']
}>

export type ResumeList_UpdateArchivedResumeMutation = {
  __typename?: 'Mutation'
  updateArchivedResume: {
    __typename?: 'Resumes'
    id: string
    name: string
    archived: boolean
    createdAt: any
    updatedAt: any
    aiGenerated: boolean
  }
}

export type ResumeList_DuplicateResumeMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ResumeList_DuplicateResumeMutation = {
  __typename?: 'Mutation'
  duplicateResume: {
    __typename?: 'Resumes'
    id: string
    name: string
    archived: boolean
    createdAt: any
    updatedAt: any
    aiGenerated: boolean
  }
}

export type RoastResume_RoastResumeMutationVariables = Exact<{
  uploadSignedId: Scalars['ID']['input']
  roleType: RoastRoleTypeEnum
  toneLevel: RoastToneLevelEnum
  token: Scalars['String']['input']
  jobTitle: Scalars['String']['input']
}>

export type RoastResume_RoastResumeMutation = { __typename?: 'Mutation'; roastResume: string }

export type RoastSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>

export type RoastSubscriptionSubscription = {
  __typename?: 'Subscription'
  roast: {
    __typename?: 'RoastPayload'
    content: string
    initial: boolean
    requestId: string
    i?: number | null
  }
}

export type ForgotPassword_AuthPasswordResetRequestMutationVariables = Exact<{
  email: Scalars['String']['input']
}>

export type ForgotPassword_AuthPasswordResetRequestMutation = {
  __typename?: 'Mutation'
  authPasswordResetRequest: string
}

export type ResetPassword_ResetPasswordAllowedQueryVariables = Exact<{
  resetPasswordToken: Scalars['String']['input']
}>

export type ResetPassword_ResetPasswordAllowedQuery = {
  __typename?: 'Query'
  resetPasswordAllowed: boolean
}

export type ResetPassword_ResetPasswordMutationVariables = Exact<{
  resetPasswordToken: Scalars['String']['input']
  newPassword: Scalars['String']['input']
}>

export type ResetPassword_ResetPasswordMutation = {
  __typename?: 'Mutation'
  authResetPassword: string
}

export type EmailVerify_EmailVerifyAllowedQueryVariables = Exact<{
  emailVerificationCode: Scalars['String']['input']
}>

export type EmailVerify_EmailVerifyAllowedQuery = {
  __typename?: 'Query'
  emailVerifyAllowed?: {
    __typename?: 'Users'
    firstName?: string | null
    lastName?: string | null
    email: string
  } | null
}

export type ExperienceLevelPage_UpdateUserMutationVariables = Exact<{
  jobExperienceLevel: JobListingExperienceLevelEnum
}>

export type ExperienceLevelPage_UpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser: {
    __typename?: 'Users'
    id: string
    jobExperienceLevel?: JobListingExperienceLevelEnum | null
  }
}

export type OnboardingFlow_CompleteOnboardingMutationVariables = Exact<{ [key: string]: never }>

export type OnboardingFlow_CompleteOnboardingMutation = {
  __typename?: 'Mutation'
  updateUser: { __typename?: 'Users'; id: string; hasCompletedOnboarding: boolean }
}

export type ResumePage_GetResumesQueryVariables = Exact<{ [key: string]: never }>

export type ResumePage_GetResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type WelcomePage_UpdateUserMutationVariables = Exact<{
  jobTitle: Scalars['String']['input']
}>

export type WelcomePage_UpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser: { __typename?: 'Users'; id: string; targetJobTitle?: string | null }
}

export type ApplicationSelect_UsersJobsFragment = {
  __typename?: 'UsersJobs'
  id: string
  companyName: string
  position: string
  jobDetails?: string | null
}

export type ApplicationSelect_UsersJobsQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ApplicationSelect_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    companyName: string
    position: string
    jobDetails?: string | null
  }>
}

export type Feedback_FeedbackCreateMutationVariables = Exact<{
  subject?: InputMaybe<Scalars['String']['input']>
  feedback: Scalars['String']['input']
}>

export type Feedback_FeedbackCreateMutation = { __typename?: 'Mutation'; createFeedback: string }

export type GoldOnboardingManager_CompleteOnboardingMutationVariables = Exact<{
  [key: string]: never
}>

export type GoldOnboardingManager_CompleteOnboardingMutation = {
  __typename?: 'Mutation'
  updateUser: { __typename?: 'Users'; id: string }
}

export type Navigation_GetTodoTasksQueryVariables = Exact<{ [key: string]: never }>

export type Navigation_GetTodoTasksQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    usedChromeExtension: boolean
    usedJobAiFeature: boolean
    usedResumeAiFeature: boolean
    numJobs: number
    jobsAddedThisWeek: number
    jobsToFollowUp: Array<{
      __typename?: 'UsersJobs'
      id: string
      position: string
      companyName: string
      appliedAt?: any | null
    }>
    thankYouJobs: Array<{
      __typename?: 'UsersJobs'
      id: string
      position: string
      companyName: string
      interviewedAt?: any | null
    }>
  }
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
      }>
    }>
  }>
}

export type Navigation_ClientGroupsQueryVariables = Exact<{ [key: string]: never }>

export type Navigation_ClientGroupsQuery = {
  __typename?: 'Query'
  clientGroups: Array<{ __typename?: 'ClientGroup'; id: string; name: string }>
}

export type ResumesSelect_ResumesQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ResumesSelect_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string; aiGenerated: boolean }>
}

export type TodoTaskUsersFragment = {
  __typename?: 'Users'
  id: string
  usedChromeExtension: boolean
  usedJobAiFeature: boolean
  usedResumeAiFeature: boolean
  numJobs: number
  jobsAddedThisWeek: number
  jobsToFollowUp: Array<{
    __typename?: 'UsersJobs'
    id: string
    position: string
    companyName: string
    appliedAt?: any | null
  }>
  thankYouJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    position: string
    companyName: string
    interviewedAt?: any | null
  }>
}

export type TodoTaskResumesFragment = {
  __typename?: 'Resumes'
  id: string
  simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
  workExperiences: Array<{
    __typename?: 'ResumesWorkExperience'
    simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
    workPositions: Array<{
      __typename?: 'ResumesWorkPosition'
      simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
    }>
  }>
}

export type TodoTasks_GetTodoTasksQueryVariables = Exact<{ [key: string]: never }>

export type TodoTasks_GetTodoTasksQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    usedChromeExtension: boolean
    usedJobAiFeature: boolean
    usedResumeAiFeature: boolean
    numJobs: number
    jobsAddedThisWeek: number
    jobsToFollowUp: Array<{
      __typename?: 'UsersJobs'
      id: string
      position: string
      companyName: string
      appliedAt?: any | null
    }>
    thankYouJobs: Array<{
      __typename?: 'UsersJobs'
      id: string
      position: string
      companyName: string
      interviewedAt?: any | null
    }>
  }
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        simpleAnalysis: Array<{ __typename?: 'FieldMessageType'; errorMessage?: string | null }>
      }>
    }>
  }>
}

export type UpdateLastPageLoaded_UpdateLastPageLoadedAtMutationVariables = Exact<{
  [key: string]: never
}>

export type UpdateLastPageLoaded_UpdateLastPageLoadedAtMutation = {
  __typename?: 'Mutation'
  updateLastPageLoadedAt: { __typename?: 'Users'; id: string }
}

export type UsersUpdateFragment = {
  __typename?: 'Users'
  id: string
  firstName?: string | null
  lastName?: string | null
  phoneNumber?: string | null
  location?: string | null
  website?: string | null
  linkedinUrl?: string | null
  profilePictureUrl?: string | null
  enableJobNotifications: boolean
  enableJobRecommendationsNotifications: boolean
}

export type AccountSettingsDialog_UserQueryVariables = Exact<{ [key: string]: never }>

export type AccountSettingsDialog_UserQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
    phoneNumber?: string | null
    location?: string | null
    website?: string | null
    linkedinUrl?: string | null
    profilePictureUrl?: string | null
    enableJobNotifications: boolean
    enableJobRecommendationsNotifications: boolean
  }
}

export type AccountSettingsDialog_UpdateUserMutationVariables = Exact<{
  attributes: UsersInputObject
}>

export type AccountSettingsDialog_UpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
    phoneNumber?: string | null
    location?: string | null
    website?: string | null
    linkedinUrl?: string | null
    profilePictureUrl?: string | null
    enableJobNotifications: boolean
    enableJobRecommendationsNotifications: boolean
  }
}

export type AccountSettingsDialog_UserUploadProfilePictureMutationVariables = Exact<{
  uploadSignedId: Scalars['ID']['input']
}>

export type AccountSettingsDialog_UserUploadProfilePictureMutation = {
  __typename?: 'Mutation'
  userUploadProfilePicture: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
    phoneNumber?: string | null
    location?: string | null
    website?: string | null
    linkedinUrl?: string | null
    profilePictureUrl?: string | null
    enableJobNotifications: boolean
    enableJobRecommendationsNotifications: boolean
  }
}

export type AccountSettingsDialog_JobSearchPreferenceFragment = {
  __typename?: 'JobSearchPreference'
  positions?: Array<string> | null
  locations?: Array<string> | null
  keywords?: Array<string> | null
  employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
  experienceLevels?: Array<JobListingExperienceLevelEnum> | null
  workArrangements?: Array<JobListingWorkArrangementEnum> | null
  datePosted?: JobListingDatePostedEnum | null
  educationRequirement?: JobListingEducationLevelEnum | null
  salaryMin?: number | null
  payPeriod?: JobListingPayPeriodEnum | null
  companyNumEmployeesMin?: number | null
  companyNumEmployeesMax?: number | null
  visaSponsorship?: boolean | null
}

export type AccountSettingsDialog_JobSearchPreferenceQueryVariables = Exact<{
  [key: string]: never
}>

export type AccountSettingsDialog_JobSearchPreferenceQuery = {
  __typename?: 'Query'
  jobSearchPreference: {
    __typename?: 'JobSearchPreference'
    positions?: Array<string> | null
    locations?: Array<string> | null
    keywords?: Array<string> | null
    employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
    experienceLevels?: Array<JobListingExperienceLevelEnum> | null
    workArrangements?: Array<JobListingWorkArrangementEnum> | null
    datePosted?: JobListingDatePostedEnum | null
    educationRequirement?: JobListingEducationLevelEnum | null
    salaryMin?: number | null
    payPeriod?: JobListingPayPeriodEnum | null
    companyNumEmployeesMin?: number | null
    companyNumEmployeesMax?: number | null
    visaSponsorship?: boolean | null
  }
}

export type AccountSettingsDialog_UpsertJobSearchPreferenceMutationVariables = Exact<{
  attributes: JobSearchPreferenceInputObject
}>

export type AccountSettingsDialog_UpsertJobSearchPreferenceMutation = {
  __typename?: 'Mutation'
  userUpsertJobSearchPreference: {
    __typename?: 'JobSearchPreference'
    positions?: Array<string> | null
    locations?: Array<string> | null
    keywords?: Array<string> | null
    employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
    experienceLevels?: Array<JobListingExperienceLevelEnum> | null
    workArrangements?: Array<JobListingWorkArrangementEnum> | null
    datePosted?: JobListingDatePostedEnum | null
    educationRequirement?: JobListingEducationLevelEnum | null
    salaryMin?: number | null
    payPeriod?: JobListingPayPeriodEnum | null
    companyNumEmployeesMin?: number | null
    companyNumEmployeesMax?: number | null
    visaSponsorship?: boolean | null
  }
}

export type CreateClientGroupDialog_ClientGroupFragment = {
  __typename?: 'ClientGroup'
  id: string
  clients: Array<{ __typename?: 'ClientUsers'; id: string }>
}

export type CreateClientGroupDialog_CreateClientGroupMutationVariables = Exact<{
  name: Scalars['String']['input']
}>

export type CreateClientGroupDialog_CreateClientGroupMutation = {
  __typename?: 'Mutation'
  createClientGroup: {
    __typename?: 'ClientGroup'
    id: string
    clients: Array<{ __typename?: 'ClientUsers'; id: string }>
  }
}

export type CreateClientGroupDialog_AddUsersToClientGroupMutationVariables = Exact<{
  clientGroupId: Scalars['ID']['input']
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type CreateClientGroupDialog_AddUsersToClientGroupMutation = {
  __typename?: 'Mutation'
  addUsersToClientGroup: {
    __typename?: 'ClientGroup'
    id: string
    clients: Array<{ __typename?: 'ClientUsers'; id: string }>
  }
}

export type CreateClientGroupDialog_ClientsQueryVariables = Exact<{ [key: string]: never }>

export type CreateClientGroupDialog_ClientsQuery = {
  __typename?: 'Query'
  clients: {
    __typename?: 'PaginatedClientUsers'
    data: Array<{
      __typename?: 'ClientUsers'
      id: string
      user: { __typename?: 'Users'; firstName?: string | null; lastName?: string | null }
    }>
  }
}

export type DidYouApplyJobListingDialog_ApplyJobListingMutationVariables = Exact<{
  jobListingId: Scalars['ID']['input']
}>

export type DidYouApplyJobListingDialog_ApplyJobListingMutation = {
  __typename?: 'Mutation'
  markJobListingAsApplied: { __typename?: 'UsersJobs'; id: string }
}

export type EditClientGroupDialog_ClientGroupsQueryVariables = Exact<{
  clientGroupId: Scalars['ID']['input']
}>

export type EditClientGroupDialog_ClientGroupsQuery = {
  __typename?: 'Query'
  clientGroups: Array<{
    __typename?: 'ClientGroup'
    id: string
    name: string
    clients: Array<{
      __typename?: 'ClientUsers'
      id: string
      user: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      }
    }>
  }>
}

export type EditClientGroupDialog_ClientsQueryVariables = Exact<{ [key: string]: never }>

export type EditClientGroupDialog_ClientsQuery = {
  __typename?: 'Query'
  clients: {
    __typename?: 'PaginatedClientUsers'
    pagination: { __typename?: 'Pagination'; page: number; pageSize: number }
    data: Array<{
      __typename?: 'ClientUsers'
      id: string
      user: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      }
    }>
  }
}

export type EditClientGroupDialog_EditClientGroupMutationVariables = Exact<{
  clientGroupId: Scalars['ID']['input']
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}>

export type EditClientGroupDialog_EditClientGroupMutation = {
  __typename?: 'Mutation'
  editClientGroup: { __typename?: 'ClientGroup'; id: string }
}

export type EnhanceAchievementDialog_GenerateOneJobAchievementMutationVariables = Exact<{
  workPositionId: Scalars['ID']['input']
  index: Scalars['Int']['input']
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  customPrompt?: InputMaybe<Scalars['String']['input']>
}>

export type EnhanceAchievementDialog_GenerateOneJobAchievementMutation = {
  __typename?: 'Mutation'
  generateOneJobAchievement: string
}

export type EnhanceSummaryDialog_GenerateProfessionalSummaryMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  useExisting: Scalars['Boolean']['input']
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  customPrompt?: InputMaybe<Scalars['String']['input']>
}>

export type EnhanceSummaryDialog_GenerateProfessionalSummaryMutation = {
  __typename?: 'Mutation'
  generateProfessionalSummary: string
}

export type FeedbackDialog_CreateFeedbackMutationVariables = Exact<{
  subject?: InputMaybe<Scalars['String']['input']>
  feedback: Scalars['String']['input']
}>

export type FeedbackDialog_CreateFeedbackMutation = {
  __typename?: 'Mutation'
  createFeedback: string
}

export type GenerateSimilarProfileMessageDialog_GenerateDraftEmailForSimilarProfileMutationVariables =
  Exact<{
    resumeId: Scalars['ID']['input']
    similarProfile: SimilarProfilesInputObject
    usersJobId: Scalars['ID']['input']
    forHiringManager?: InputMaybe<Scalars['Boolean']['input']>
    forRecruiter?: InputMaybe<Scalars['Boolean']['input']>
  }>

export type GenerateSimilarProfileMessageDialog_GenerateDraftEmailForSimilarProfileMutation = {
  __typename?: 'Mutation'
  generateDraftEmailForSimilarProfile: {
    __typename?: 'SimilarProfilesMessage'
    body: string
    subject: string
  }
}

export type GoldOnboardingDialog_UserUpdateWritingStyleMutationVariables = Exact<{
  writingStyle: UsersWritingStyleEnum
}>

export type GoldOnboardingDialog_UserUpdateWritingStyleMutation = {
  __typename?: 'Mutation'
  userUpdateWritingStyle: { __typename?: 'Users'; id: string }
}

export type ImportResumeFromLinkedinDialog_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type ImportResumeFromLinkedinDialog_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type ImportResumeFromLinkedinDialog_CreateResumeFromLinkedinUrlMutationVariables = Exact<{
  linkedinProfileUrl: Scalars['String']['input']
}>

export type ImportResumeFromLinkedinDialog_CreateResumeFromLinkedinUrlMutation = {
  __typename?: 'Mutation'
  createResumeFromLinkedinUrl: { __typename?: 'Resumes'; id: string }
}

export type InviteAdvisorDialog_InviteAdvisorMutationVariables = Exact<{
  email: Scalars['String']['input']
  role: UsersRoleEnum
}>

export type InviteAdvisorDialog_InviteAdvisorMutation = {
  __typename?: 'Mutation'
  inviteAdvisor?: { __typename?: 'Users'; id: string } | null
}

export type InviteClientDialog_InviteClientMutationVariables = Exact<{
  email: Scalars['String']['input']
}>

export type InviteClientDialog_InviteClientMutation = {
  __typename?: 'Mutation'
  inviteClient?: { __typename?: 'Users'; id: string } | null
}

export type MatchLevelDialog_CheckFitMutationVariables = Exact<{
  usersJobId?: InputMaybe<Scalars['ID']['input']>
  jobListingId?: InputMaybe<Scalars['ID']['input']>
}>

export type MatchLevelDialog_CheckFitMutation = {
  __typename?: 'Mutation'
  amIAGoodFit?: {
    __typename?: 'AmIAGoodFit'
    overallSummary?: string | null
    overallMatch?: UsersJobsMatchEnum | null
    relevantEducation?: string | null
    relevantEducationMatch?: boolean | null
    relevantExperience?: string | null
    relevantExperienceMatch?: boolean | null
    relevantSkills?: string | null
    relevantSkillsMatch?: boolean | null
  } | null
}

export type NewApplicationDialog_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type NewApplicationDialog_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string; aiGenerated: boolean }>
}

export type NewApplicationDialog_CreateUsersJobMutationVariables = Exact<{
  applicationInstructions?: InputMaybe<Scalars['String']['input']>
  contact?: InputMaybe<ContactsInputObject>
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobDetails?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  payPeriod?: InputMaybe<UsersJobsPayPeriodEnum>
  position: Scalars['String']['input']
  salaryMax?: InputMaybe<Scalars['Int']['input']>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<UsersJobsStatusEnum>
  rejectedStage?: InputMaybe<UsersJobsRejectedStageEnum>
  interviewStep?: InputMaybe<UsersJobsInterviewStepEnum>
  companyName: Scalars['String']['input']
  companyDomain?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  resumeId?: InputMaybe<Scalars['ID']['input']>
}>

export type NewApplicationDialog_CreateUsersJobMutation = {
  __typename?: 'Mutation'
  createUsersJob: { __typename?: 'UsersJobs'; id: string; status: UsersJobsStatusEnum }
}

export type NewApplicationsDialog_UsersJobsQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type NewApplicationsDialog_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    status: UsersJobsStatusEnum
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    companyName: string
    url?: string | null
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    payPeriod: UsersJobsPayPeriodEnum
    applicationInstructions?: string | null
    companyDomain?: string | null
  }>
}

export type NewApplicationsDialog_UpdateUsersJobMutationVariables = Exact<{
  id: Scalars['ID']['input']
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobDetails?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  position: Scalars['String']['input']
  salaryMax?: InputMaybe<Scalars['Int']['input']>
  salaryMin?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<UsersJobsStatusEnum>
  rejectedStage?: InputMaybe<UsersJobsRejectedStageEnum>
  interviewStep?: InputMaybe<UsersJobsInterviewStepEnum>
  companyName: Scalars['String']['input']
  url?: InputMaybe<Scalars['String']['input']>
  resumeId?: InputMaybe<Scalars['ID']['input']>
  payPeriod?: InputMaybe<UsersJobsPayPeriodEnum>
  applicationInstructions?: InputMaybe<Scalars['String']['input']>
  companyDomain?: InputMaybe<Scalars['String']['input']>
}>

export type NewApplicationsDialog_UpdateUsersJobMutation = {
  __typename?: 'Mutation'
  updateUsersJob: { __typename?: 'UsersJobs'; id: string; status: UsersJobsStatusEnum }
}

export type NewCoverLetterDialog_UsersJobsQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  archived: Scalars['Boolean']['input']
}>

export type NewCoverLetterDialog_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    position: string
    companyName: string
    coverLetter?: { __typename?: 'UsersJobsCoverLetterType'; id: string } | null
  }>
}

export type NewCoverLetterDialog_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type NewCoverLetterDialog_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string; aiGenerated: boolean }>
}

export type NewCoverLetterDialog_CreateUsersJobMutationVariables = Exact<{
  position: Scalars['String']['input']
  status?: InputMaybe<UsersJobsStatusEnum>
  companyName: Scalars['String']['input']
  jobDetails?: InputMaybe<Scalars['String']['input']>
}>

export type NewCoverLetterDialog_CreateUsersJobMutation = {
  __typename?: 'Mutation'
  createUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    applicationInstructions?: string | null
    createdAt: any
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }
}

export type NewCoverLetterDialog_CoverLetterUpsertMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
  attributes: UsersJobsCoverLetterInputObject
}>

export type NewCoverLetterDialog_CoverLetterUpsertMutation = {
  __typename?: 'Mutation'
  coverLetterUpsert: {
    __typename?: 'UsersJobsCoverLetterType'
    id: string
    updatedAt: any
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    candidateAddress?: string | null
    companyName?: string | null
    companyLocation?: string | null
    phoneNumber?: string | null
    body?: string | null
    footer?: string | null
    archived: boolean
    mostRecentUsedResumeForGenerate?: { __typename?: 'Resumes'; id: string } | null
  }
}

export type NewHeadshotDialog_CreateHeadshotRequestMutationVariables = Exact<{
  attire: HeadshotRequestsAttireEnum
  background: HeadshotRequestsBackgroundEnum
  uploadSignedId: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type NewHeadshotDialog_CreateHeadshotRequestMutation = {
  __typename?: 'Mutation'
  createHeadshotRequest: { __typename?: 'HeadshotRequest'; id: string }
}

export type NewInterviewDialog_ResumeQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
}>

export type NewInterviewDialog_ResumeQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type NewInterviewDialog_InterviewStartMockMutationVariables = Exact<{
  jobTitle: Scalars['String']['input']
  jobDescription?: InputMaybe<Scalars['String']['input']>
  interviewType: InterviewsTypeEnum
  resumeId?: InputMaybe<Scalars['ID']['input']>
}>

export type NewInterviewDialog_InterviewStartMockMutation = {
  __typename?: 'Mutation'
  interviewStartMock: { __typename?: 'Interview'; id: string }
}

export type NewResumeDialog_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type NewResumeDialog_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type NewResumeDialog_PaginatedResumeExamplesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
}>

export type NewResumeDialog_PaginatedResumeExamplesQuery = {
  __typename?: 'Query'
  paginatedResumeExamples: {
    __typename?: 'PaginatedResumeExamples'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'Resumes'
      id: string
      name: string
      nameSlug?: string | null
      category?: string | null
      exampleImageUrl?: string | null
    }>
  }
}

export type NewResumeDialog_ResumeExampleCategoriesQueryVariables = Exact<{ [key: string]: never }>

export type NewResumeDialog_ResumeExampleCategoriesQuery = {
  __typename?: 'Query'
  resumeExampleCategories?: Array<string> | null
}

export type NewResumeDialog_ResumeExampleQueryVariables = Exact<{
  nameSlug: Scalars['String']['input']
}>

export type NewResumeDialog_ResumeExampleQuery = {
  __typename?: 'Query'
  resumeExample?: {
    __typename?: 'Resumes'
    id: string
    name: string
    nameSlug?: string | null
    category?: string | null
    exampleImageUrl?: string | null
  } | null
}

export type NewResumeDialog_CreateResumeFromLinkedinUrlMutationVariables = Exact<{
  linkedinProfileUrl: Scalars['String']['input']
}>

export type NewResumeDialog_CreateResumeFromLinkedinUrlMutation = {
  __typename?: 'Mutation'
  createResumeFromLinkedinUrl: { __typename?: 'Resumes'; id: string }
}

export type NewResumeDialog_DuplicateFromResumeExampleMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type NewResumeDialog_DuplicateFromResumeExampleMutation = {
  __typename?: 'Mutation'
  duplicateResumeFromResumeExample: { __typename?: 'Resumes'; id: string }
}

export type RedeemCodeDialog_SubscriptionsRedeemLtdPromoCodeMutationVariables = Exact<{
  promoCode: Scalars['String']['input']
}>

export type RedeemCodeDialog_SubscriptionsRedeemLtdPromoCodeMutation = {
  __typename?: 'Mutation'
  subscriptionsRedeemLtdPromoCode: { __typename?: 'Users'; id: string; plan: SubscriptionPlanEnum }
}

export type RequestResumeReviewDialog_RequestResumeReviewMutationVariables = Exact<{
  id: Scalars['ID']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}>

export type RequestResumeReviewDialog_RequestResumeReviewMutation = {
  __typename?: 'Mutation'
  requestResumeReview: string
}

export type ShareJobPostingDialog_UsersJobsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type ShareJobPostingDialog_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    position: string
    companyName: string
    clientsShared: Array<{ __typename?: 'Users'; id: string }>
  }>
}

export type ShareJobPostingDialog_ClientsQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>
}>

export type ShareJobPostingDialog_ClientsQuery = {
  __typename?: 'Query'
  clients: {
    __typename?: 'PaginatedClientUsers'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'ClientUsers'
      id: string
      user: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      }
    }>
  }
}

export type ShareJobPostingDialog_ClientGroupsQueryVariables = Exact<{ [key: string]: never }>

export type ShareJobPostingDialog_ClientGroupsQuery = {
  __typename?: 'Query'
  clientGroups: Array<{ __typename?: 'ClientGroup'; id: string; name: string }>
}

export type ShareJobPostingDialog_ShareJobWithClientsMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  clientGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type ShareJobPostingDialog_ShareJobWithClientsMutation = {
  __typename?: 'Mutation'
  shareJobWithClients: { __typename?: 'UsersJobs'; id: string }
}

export type ShareResumeDialog_UpdatePublicResumeMutationVariables = Exact<{
  id: Scalars['ID']['input']
  isPublic: Scalars['Boolean']['input']
}>

export type ShareResumeDialog_UpdatePublicResumeMutation = {
  __typename?: 'Mutation'
  updatePublicResume: { __typename?: 'Resumes'; id: string; isPublic: boolean }
}

export type TailorResumeDialog_CreateUsersJobMutationVariables = Exact<{
  position: Scalars['String']['input']
  status?: InputMaybe<UsersJobsStatusEnum>
  companyName: Scalars['String']['input']
  jobDetails?: InputMaybe<Scalars['String']['input']>
}>

export type TailorResumeDialog_CreateUsersJobMutation = {
  __typename?: 'Mutation'
  createUsersJob: {
    __typename?: 'UsersJobs'
    id: string
    applicationInstructions?: string | null
    createdAt: any
    companyName: string
    isRemote?: boolean | null
    jobDetails?: string | null
    location?: string | null
    notes?: string | null
    payPeriod: UsersJobsPayPeriodEnum
    position: string
    salaryMax?: number | null
    salaryMin?: number | null
    status: UsersJobsStatusEnum
    updatedAt: any
    url?: string | null
    archived: boolean
    rejectedStage?: UsersJobsRejectedStageEnum | null
    interviewStep?: UsersJobsInterviewStepEnum | null
    numClientsApplied: number
    numClientsShared: number
    partnerArchived: boolean
    checklist: Array<{
      __typename?: 'UsersJobsChecklistItem'
      checklistEnum: UsersJobsChecklistEnum
      completed: boolean
    }>
    partnerCreatedByUser?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    contacts?: Array<{
      __typename?: 'Contacts'
      id: string
      email?: string | null
      name?: string | null
    }> | null
    resume?: { __typename?: 'Resumes'; id: string; name: string } | null
  }
}

export type TailorResumeDialog_OptimizeResumeForJobMutationVariables = Exact<{
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  resumeId: Scalars['ID']['input']
  skills?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  usersJobId?: InputMaybe<Scalars['ID']['input']>
  jobListingId?: InputMaybe<Scalars['ID']['input']>
}>

export type TailorResumeDialog_OptimizeResumeForJobMutation = {
  __typename?: 'Mutation'
  optimizeResumeForJobV2: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }
}

export type TailorResumeDialog_FetchJobKeywordsMutationVariables = Exact<{
  usersJobId?: InputMaybe<Scalars['ID']['input']>
  jobListingId?: InputMaybe<Scalars['ID']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
}>

export type TailorResumeDialog_FetchJobKeywordsMutation = {
  __typename?: 'Mutation'
  fetchJobKeywords: Array<string>
}

export type TailorResumeDialog_FetchMissingSkillsOfJobResumeMutationVariables = Exact<{
  usersJobId: Scalars['ID']['input']
  jobListingId: Scalars['ID']['input']
  resumeId: Scalars['ID']['input']
}>

export type TailorResumeDialog_FetchMissingSkillsOfJobResumeMutation = {
  __typename?: 'Mutation'
  fetchMissingSkillsOfJobResume: Array<string>
}

export type EnhanceAchievementDialog_GenerateOneJobAchievementFromStringMutationVariables = Exact<{
  achievementStrings: Array<Scalars['String']['input']> | Scalars['String']['input']
  customPrompt?: InputMaybe<Scalars['String']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
}>

export type EnhanceAchievementDialog_GenerateOneJobAchievementFromStringMutation = {
  __typename?: 'Mutation'
  generateJobAchievementFromString: Array<string>
}

export type ResumeTemplateDrawer_UpdateTemplateMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  template: ResumesTemplateEnum
  templateColorEnum?: InputMaybe<ResumesTemplateColorEnum>
}>

export type ResumeTemplateDrawer_UpdateTemplateMutation = {
  __typename?: 'Mutation'
  updateTemplateResume: {
    __typename?: 'Resumes'
    id: string
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
  }
}

export type AdvisorSheet_ClientsQueryVariables = Exact<{
  advisorIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  page: Scalars['Int']['input']
  perPage: Scalars['Int']['input']
}>

export type AdvisorSheet_ClientsQuery = {
  __typename?: 'Query'
  clients: {
    __typename?: 'PaginatedClientUsers'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'ClientUsers'
      user: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      }
    }>
  }
}

export type AdvisorSheet_AssignClientToAdvisorMutationVariables = Exact<{
  advisorId: Scalars['ID']['input']
  clientIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type AdvisorSheet_AssignClientToAdvisorMutation = {
  __typename?: 'Mutation'
  assignClientToAdvisor: string
}

export type ApplicationToolbar_UsersJobsArchivedQueryVariables = Exact<{
  usersJobIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ApplicationToolbar_UsersJobsArchivedQuery = {
  __typename?: 'Query'
  usersJobs: Array<{
    __typename?: 'UsersJobs'
    id: string
    archived: boolean
    position: string
    companyName: string
  }>
}

export type ApplicationToolbar_UpdateUsersJobArchiveMutationVariables = Exact<{
  id: Scalars['ID']['input']
  archive?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ApplicationToolbar_UpdateUsersJobArchiveMutation = {
  __typename?: 'Mutation'
  updateUsersJob: { __typename?: 'UsersJobs'; id: string; archived: boolean }
}

export type BoardToolbar_UsersJobsQueryVariables = Exact<{ [key: string]: never }>

export type BoardToolbar_UsersJobsQuery = {
  __typename?: 'Query'
  usersJobs: Array<{ __typename?: 'UsersJobs'; id: string }>
}

export type ClientBoardToolbar_ClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input']
}>

export type ClientBoardToolbar_ClientQuery = {
  __typename?: 'Query'
  client: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
    email: string
  }
}

export type ClientGroupToolbar_ClientGroupQueryVariables = Exact<{
  clientGroupId: Scalars['ID']['input']
}>

export type ClientGroupToolbar_ClientGroupQuery = {
  __typename?: 'Query'
  clientGroups: Array<{ __typename?: 'ClientGroup'; id: string; name: string }>
}

export type ClientResumeToolbar_ClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input']
}>

export type ClientResumeToolbar_ClientQuery = {
  __typename?: 'Query'
  client: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
    email: string
  }
}

export type ClientToolbar_ClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input']
}>

export type ClientToolbar_ClientQuery = {
  __typename?: 'Query'
  client: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
    email: string
  }
}

export type ClientsToolbar_AdvisorsQueryVariables = Exact<{ [key: string]: never }>

export type ClientsToolbar_AdvisorsQuery = {
  __typename?: 'Query'
  advisors: {
    __typename?: 'PaginatedAdvisorUsers'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'AdvisorUsers'
      id: string
      user: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      }
    }>
  }
}

export type CoverLetterToolbar_CoverLettersQueryVariables = Exact<{
  coverLetterId: Scalars['ID']['input']
}>

export type CoverLetterToolbar_CoverLettersQuery = {
  __typename?: 'Query'
  coverLetters: Array<{
    __typename?: 'UsersJobsCoverLetterType'
    id: string
    archived: boolean
    companyName?: string | null
    usersJob: { __typename?: 'UsersJobs'; position: string }
  }>
}

export type CoverLetterToolbar_UpdateArchivedCoverLetterMutationVariables = Exact<{
  coverLetterId: Scalars['ID']['input']
  archived: Scalars['Boolean']['input']
}>

export type CoverLetterToolbar_UpdateArchivedCoverLetterMutation = {
  __typename?: 'Mutation'
  updateArchivedCoverLetter: {
    __typename?: 'UsersJobsCoverLetterType'
    id: string
    archived: boolean
  }
}

export type CoverLettersToolbar_CoverLettersQueryVariables = Exact<{ [key: string]: never }>

export type CoverLettersToolbar_CoverLettersQuery = {
  __typename?: 'Query'
  coverLetters: Array<{ __typename?: 'UsersJobsCoverLetterType'; id: string }>
}

export type HeadshotsToolbar_HeadshotsQueryVariables = Exact<{ [key: string]: never }>

export type HeadshotsToolbar_HeadshotsQuery = {
  __typename?: 'Query'
  headshotRequests: Array<{ __typename?: 'HeadshotRequest'; id: string; createdAt: any }>
}

export type InterviewsToolbar_InterviewsQueryVariables = Exact<{ [key: string]: never }>

export type InterviewsToolbar_InterviewsQuery = {
  __typename?: 'Query'
  interviews: Array<{ __typename?: 'Interview'; id: string }>
}

export type JobPostingsToolbar_ExportCsvMutationVariables = Exact<{ [key: string]: never }>

export type JobPostingsToolbar_ExportCsvMutation = {
  __typename?: 'Mutation'
  exportUsersJobToCsv: string
}

export type ResumeBuilderToolbar_ArchiveResumeMutationVariables = Exact<{
  id: Scalars['ID']['input']
  archived: Scalars['Boolean']['input']
}>

export type ResumeBuilderToolbar_ArchiveResumeMutation = {
  __typename?: 'Mutation'
  updateArchivedResume: { __typename?: 'Resumes'; id: string; archived: boolean }
}

export type ResumeBuilderToolbar_GetResumeQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ResumeBuilderToolbar_GetResumeQuery = {
  __typename?: 'Query'
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    archived: boolean
    isPublic: boolean
    publicId: string
    name: string
  }>
}

export type ResumesToolbar_ResumesQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ResumesToolbar_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type UserNotificationsForm_JobSearchPreferenceFragment = {
  __typename?: 'JobSearchPreference'
  positions?: Array<string> | null
  locations?: Array<string> | null
  keywords?: Array<string> | null
  employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
  experienceLevels?: Array<JobListingExperienceLevelEnum> | null
  workArrangements?: Array<JobListingWorkArrangementEnum> | null
  datePosted?: JobListingDatePostedEnum | null
  educationRequirement?: JobListingEducationLevelEnum | null
  salaryMin?: number | null
  payPeriod?: JobListingPayPeriodEnum | null
  companyNumEmployeesMin?: number | null
  companyNumEmployeesMax?: number | null
  visaSponsorship?: boolean | null
}

export type UserNotificationsForm_JobSearchPreferenceQueryVariables = Exact<{
  [key: string]: never
}>

export type UserNotificationsForm_JobSearchPreferenceQuery = {
  __typename?: 'Query'
  jobSearchPreference: {
    __typename?: 'JobSearchPreference'
    positions?: Array<string> | null
    locations?: Array<string> | null
    keywords?: Array<string> | null
    employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
    experienceLevels?: Array<JobListingExperienceLevelEnum> | null
    workArrangements?: Array<JobListingWorkArrangementEnum> | null
    datePosted?: JobListingDatePostedEnum | null
    educationRequirement?: JobListingEducationLevelEnum | null
    salaryMin?: number | null
    payPeriod?: JobListingPayPeriodEnum | null
    companyNumEmployeesMin?: number | null
    companyNumEmployeesMax?: number | null
    visaSponsorship?: boolean | null
  }
}

export type UserNotificationsForm_UpsertJobSearchPreferenceMutationVariables = Exact<{
  attributes: JobSearchPreferenceInputObject
}>

export type UserNotificationsForm_UpsertJobSearchPreferenceMutation = {
  __typename?: 'Mutation'
  userUpsertJobSearchPreference: {
    __typename?: 'JobSearchPreference'
    positions?: Array<string> | null
    locations?: Array<string> | null
    keywords?: Array<string> | null
    employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
    experienceLevels?: Array<JobListingExperienceLevelEnum> | null
    workArrangements?: Array<JobListingWorkArrangementEnum> | null
    datePosted?: JobListingDatePostedEnum | null
    educationRequirement?: JobListingEducationLevelEnum | null
    salaryMin?: number | null
    payPeriod?: JobListingPayPeriodEnum | null
    companyNumEmployeesMin?: number | null
    companyNumEmployeesMax?: number | null
    visaSponsorship?: boolean | null
  }
}

export type CreateResumeMutationVariables = Exact<{
  name: Scalars['String']['input']
}>

export type CreateResumeMutation = {
  __typename?: 'Mutation'
  createResume: { __typename?: 'Resumes'; id: string; name: string }
}

export type AuthResponseFragment = {
  __typename?: 'AuthResponse'
  token?: string | null
  isNewUser?: boolean | null
  user?: {
    __typename?: 'Users'
    id: string
    role: UsersRoleEnum
    hasCompletedOnboarding: boolean
  } | null
}

export type ProviderAuthenticationMutationVariables = Exact<{
  data: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  provider: AuthProviderTypeEnum
  resumeUniqueId?: InputMaybe<Scalars['ID']['input']>
  referredByUserUniqueId?: InputMaybe<Scalars['ID']['input']>
  utmSource?: InputMaybe<Scalars['String']['input']>
  resumeNameSlug?: InputMaybe<Scalars['String']['input']>
}>

export type ProviderAuthenticationMutation = {
  __typename?: 'Mutation'
  authProviderAuthenticate: {
    __typename?: 'AuthResponse'
    token?: string | null
    isNewUser?: boolean | null
    user?: {
      __typename?: 'Users'
      id: string
      role: UsersRoleEnum
      hasCompletedOnboarding: boolean
    } | null
  }
}

export type CredentialsAuthenticationSignInMutationVariables = Exact<{
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}>

export type CredentialsAuthenticationSignInMutation = {
  __typename?: 'Mutation'
  authSignIn: {
    __typename?: 'AuthResponse'
    token?: string | null
    isNewUser?: boolean | null
    user?: {
      __typename?: 'Users'
      id: string
      role: UsersRoleEnum
      hasCompletedOnboarding: boolean
    } | null
  }
}

export type CredentialsAuthenticationSignUpMutationVariables = Exact<{
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  referredByUserUniqueId?: InputMaybe<Scalars['ID']['input']>
  resumeUniqueId?: InputMaybe<Scalars['ID']['input']>
  utmSource?: InputMaybe<Scalars['String']['input']>
  resumeNameSlug?: InputMaybe<Scalars['String']['input']>
}>

export type CredentialsAuthenticationSignUpMutation = {
  __typename?: 'Mutation'
  authSignUp: {
    __typename?: 'AuthResponse'
    token?: string | null
    isNewUser?: boolean | null
    user?: {
      __typename?: 'Users'
      id: string
      role: UsersRoleEnum
      hasCompletedOnboarding: boolean
    } | null
  }
}

export type CredentialsAuthenticationEmailVerifyMutationVariables = Exact<{
  emailVerificationCode: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  password: Scalars['String']['input']
}>

export type CredentialsAuthenticationEmailVerifyMutation = {
  __typename?: 'Mutation'
  userEmailVerify: {
    __typename?: 'AuthResponse'
    token?: string | null
    isNewUser?: boolean | null
    user?: {
      __typename?: 'Users'
      id: string
      role: UsersRoleEnum
      hasCompletedOnboarding: boolean
    } | null
  }
}

export type ResumesQueryVariables = Exact<{ [key: string]: never }>

export type ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string }>
}

export type RootQueryVariables = Exact<{ [key: string]: never }>

export type RootQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    completedAllChecklistItems: boolean
    role: UsersRoleEnum
  }
  resumes: Array<{ __typename?: 'Resumes'; id: string }>
}

export type UploadResumeMutationVariables = Exact<{
  uploadSignedId: Scalars['ID']['input']
  name: Scalars['String']['input']
}>

export type UploadResumeMutation = {
  __typename?: 'Mutation'
  uploadResume: { __typename?: 'Resumes'; id: string; name: string }
}

export type JobListingsFragment = {
  __typename?: 'JobListings'
  id: string
  position: string
  companyName: string
  url?: string | null
  companyLogoUrl?: string | null
  companyIndustry?: string | null
  datePosted: any
  isRemote?: boolean | null
  location?: string | null
  salaryMax?: number | null
  salaryMin?: number | null
  salaryCurrency?: string | null
  employmentType?: JobListingEmploymentTypeEnum | null
  payPeriod?: JobListingPayPeriodEnum | null
}

export type JobListingsDetailsFragment = {
  __typename?: 'JobListings'
  id: string
  aiCoreResponsibilities?: string | null
  aiWorkArrangement?: JobListingWorkArrangementEnum | null
  aiEducationRequirements?: Array<JobListingEducationLevelEnum> | null
  aiRequirementsSummary?: string | null
  benefits: Array<string>
  companyDescription?: string | null
  companyDomain?: string | null
  companyIndustry?: string | null
  companyNumEmployees?: number | null
  companySpecialties: Array<string>
  companyLinkedinUrl?: string | null
  companyLogoUrl?: string | null
  employmentType?: JobListingEmploymentTypeEnum | null
  jobDetails?: string | null
  keySkills: Array<string>
  visaSponsorship: boolean
  workingHours?: number | null
  experienceLevelString?: string | null
  hiringManagerEmail?: string | null
  hiringManagerName?: string | null
  position: string
  companyName: string
  url?: string | null
  datePosted: any
  isRemote?: boolean | null
  location?: string | null
  salaryMax?: number | null
  salaryMin?: number | null
  salaryCurrency?: string | null
  payPeriod?: JobListingPayPeriodEnum | null
}

export type ResumesPreferencesFragment = {
  __typename?: 'ResumesPreferences'
  dateFormat: ResumesDateFormatEnum
  fontFamily: ResumesFontFamilyEnum
  fontSize: ResumesFontSizeEnum
  horizontalMargin: ResumesHorizontalMarginEnum
  verticalMargin: ResumesVerticalMarginEnum
  lineHeight: ResumesLineHeightEnum
  pageSize: ResumesPageSizeEnum
  sectionTitleCasing: ResumesSectionTitleCasingEnum
  sectionsOrder: Array<ResumeSortableSections>
  sectionsOrderWithCustomSections: Array<string>
  template: ResumesTemplateEnum
  templateColorEnum?: ResumesTemplateColorEnum | null
  hideCertifications: boolean
  hideCourseworks: boolean
  hideEducations: boolean
  hideInvolvements: boolean
  hideProjects: boolean
  hideSkills: boolean
  hideSummary: boolean
  hideWorkExperiences: boolean
  hideTargetTitle: boolean
  avatar: {
    __typename?: 'ResumesAvatarPreferences'
    profilePictureEnabled: boolean
    profilePictureShape?: ResumesProfilePictureShapeEnum | null
  }
}

export type ResumesFragment = {
  __typename?: 'Resumes'
  id: string
  uniqueId?: string | null
  createdAt: any
  updatedAt: any
  name: string
  archived: boolean
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  linkedinUrl?: string | null
  phoneNumber?: string | null
  professionalSummary?: string | null
  website?: string | null
  location?: string | null
  suggestedSkills: Array<string>
  documentUrl?: string | null
  documentType?: ResumeDocumentType | null
  showOriginalDocument: boolean
  hideEducations: boolean
  hideProjects: boolean
  hideSkills: boolean
  hideSummary: boolean
  hideCertifications: boolean
  hideWorkExperiences: boolean
  hideCourseworks: boolean
  hideInvolvements: boolean
  hideTargetTitle: boolean
  sectionsOrder: Array<ResumeSortableSections>
  targetTitle?: string | null
  template: ResumesTemplateEnum
  templateColorEnum?: ResumesTemplateColorEnum | null
  aiGenerated: boolean
  isPublic: boolean
  publicId: string
  tokenResumeAnalysis: number
  preferences: {
    __typename?: 'ResumesPreferences'
    dateFormat: ResumesDateFormatEnum
    fontFamily: ResumesFontFamilyEnum
    fontSize: ResumesFontSizeEnum
    horizontalMargin: ResumesHorizontalMarginEnum
    verticalMargin: ResumesVerticalMarginEnum
    lineHeight: ResumesLineHeightEnum
    pageSize: ResumesPageSizeEnum
    sectionTitleCasing: ResumesSectionTitleCasingEnum
    sectionsOrder: Array<ResumeSortableSections>
    sectionsOrderWithCustomSections: Array<string>
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    hideCertifications: boolean
    hideCourseworks: boolean
    hideEducations: boolean
    hideInvolvements: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideWorkExperiences: boolean
    hideTargetTitle: boolean
    avatar: {
      __typename?: 'ResumesAvatarPreferences'
      profilePictureEnabled: boolean
      profilePictureShape?: ResumesProfilePictureShapeEnum | null
    }
  }
  courseworks: Array<{
    __typename?: 'ResumesCoursework'
    id: string
    name?: string | null
    institutionName?: string | null
    endDate?: any | null
    achievements: Array<string>
    currentlyWorkingOnCourse: boolean
    showYearOnlyEndDate: boolean
  }>
  educations: Array<{
    __typename?: 'ResumesEducation'
    id: string
    additionalInformation?: string | null
    degree?: string | null
    endDate?: any | null
    startDate?: any | null
    gpa?: string | null
    institutionName: string
    location?: string | null
    currentlyInEducation: boolean
    achievements: Array<string>
    showYearOnlyEndDate: boolean
    showYearOnlyStartDate: boolean
  }>
  involvements: Array<{
    __typename?: 'ResumesInvolvement'
    id: string
    name?: string | null
    organizationName?: string | null
    startDate?: any | null
    endDate?: any | null
    achievements: Array<string>
    currentlyWorkingOnInvolvement: boolean
    showYearOnlyEndDate: boolean
    showYearOnlyStartDate: boolean
  }>
  projects: Array<{
    __typename?: 'ResumesProject'
    id: string
    achievements: Array<string>
    name: string
    endDate?: any | null
    startDate?: any | null
    currentlyWorkingOnProject: boolean
    showYearOnlyEndDate: boolean
    showYearOnlyStartDate: boolean
    linkUrl?: string | null
  }>
  workExperiences: Array<{
    __typename?: 'ResumesWorkExperience'
    id: string
    companyDescription?: string | null
    companyName: string
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    workPositions: Array<{
      __typename?: 'ResumesWorkPosition'
      id: string
      achievements: Array<string>
      location?: string | null
      name: string
      startDate?: any | null
      endDate?: any | null
      currentlyInPosition: boolean
      showYearOnlyStartDate: boolean
      showYearOnlyEndDate: boolean
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
    }>
  }>
  groupedSkills: Array<{
    __typename?: 'ResumesGroupedSkill'
    id: string
    category?: string | null
    skills: Array<string>
  }>
  simpleAnalysis: Array<{
    __typename?: 'FieldMessageType'
    field: string
    errorMessage?: string | null
  }>
  certifications: Array<{
    __typename?: 'ResumesCertification'
    id: string
    name: string
    completionDate?: any | null
    provider?: string | null
    showYearOnlyCompletionDate: boolean
  }>
  customSections: Array<{
    __typename?: 'ResumesCustomSection'
    id: string
    name: string
    customSectionExperiences: Array<{
      __typename?: 'ResumesCustomSectionExperience'
      id: string
      companyName?: string | null
      achievements: string
      currentlyInExperience: boolean
      endDate?: any | null
      location?: string | null
      name?: string | null
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      startDate?: any | null
    }>
  }>
}

export type UsersJobsFragment = {
  __typename?: 'UsersJobs'
  id: string
  applicationInstructions?: string | null
  createdAt: any
  companyName: string
  isRemote?: boolean | null
  jobDetails?: string | null
  location?: string | null
  notes?: string | null
  payPeriod: UsersJobsPayPeriodEnum
  position: string
  salaryMax?: number | null
  salaryMin?: number | null
  status: UsersJobsStatusEnum
  updatedAt: any
  url?: string | null
  archived: boolean
  rejectedStage?: UsersJobsRejectedStageEnum | null
  interviewStep?: UsersJobsInterviewStepEnum | null
  numClientsApplied: number
  numClientsShared: number
  partnerArchived: boolean
  checklist: Array<{
    __typename?: 'UsersJobsChecklistItem'
    checklistEnum: UsersJobsChecklistEnum
    completed: boolean
  }>
  partnerCreatedByUser?: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
  } | null
  contacts?: Array<{
    __typename?: 'Contacts'
    id: string
    email?: string | null
    name?: string | null
  }> | null
  resume?: { __typename?: 'Resumes'; id: string; name: string } | null
}

export type UseBillingPlan_SubscriptionSessionCreateMutationVariables = Exact<{
  plan: SubscriptionPlanEnum
  coupon?: InputMaybe<Scalars['String']['input']>
  isCreatedFromOnboarding?: InputMaybe<Scalars['Boolean']['input']>
}>

export type UseBillingPlan_SubscriptionSessionCreateMutation = {
  __typename?: 'Mutation'
  subscriptionsSessionCreate: string
}

export type UseBillingPlan_BillingPortalUrlMutationVariables = Exact<{ [key: string]: never }>

export type UseBillingPlan_BillingPortalUrlMutation = {
  __typename?: 'Mutation'
  billingPortalUrl: string
}

export type UseBrowserExtensionToast_UserQueryVariables = Exact<{ [key: string]: never }>

export type UseBrowserExtensionToast_UserQuery = {
  __typename?: 'Query'
  user: { __typename?: 'Users'; id: string; usedChromeExtension: boolean }
}

export type UseCreateResume_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type UseCreateResume_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type UsersFragment = {
  __typename?: 'Users'
  id: string
  uniqueId: string
  role: UsersRoleEnum
  email: string
  firstName?: string | null
  lastName?: string | null
  plan: SubscriptionPlanEnum
  activeResumesCount: number
  coverLetterCustomPrompt?: string | null
  hasCompletedResumeTour: boolean
  resumeSummaryCustomPrompt?: string | null
  resumeJobAchievementCustomPrompt?: string | null
  tokenCoverLetter: number
  tokenDownloadPdfs: number
  tokenInterviewQuestions: number
  tokenJobMatch: number
  tokenProfessionalSummary: number
  tokenSalaryInsights: number
  tokenLearnSkills: number
  tokenAchievements: number
  tokenInterview: number
  tokenWriter: number
  tokenOptimizeResume: number
  usedChromeExtension: boolean
  numUploadedResumes: number
  numStartedInterviews: number
  referralTokens: number
  hasSubscription: boolean
  isAdvisoryClient: boolean
  isAdvisoryOrgAccount: boolean
  profilePictureUrl?: string | null
  writingStyleEnum?: UsersWritingStyleEnum | null
  hasSeenGoldOnboarding: boolean
  hasCompletedOnboarding: boolean
  jobExperienceLevel?: JobListingExperienceLevelEnum | null
  targetJobTitle?: string | null
  createdAt: any
  location?: string | null
}

export type UseCurrentUser_UsersQueryVariables = Exact<{ [key: string]: never }>

export type UseCurrentUser_UsersQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    uniqueId: string
    role: UsersRoleEnum
    email: string
    firstName?: string | null
    lastName?: string | null
    plan: SubscriptionPlanEnum
    activeResumesCount: number
    coverLetterCustomPrompt?: string | null
    hasCompletedResumeTour: boolean
    resumeSummaryCustomPrompt?: string | null
    resumeJobAchievementCustomPrompt?: string | null
    tokenCoverLetter: number
    tokenDownloadPdfs: number
    tokenInterviewQuestions: number
    tokenJobMatch: number
    tokenProfessionalSummary: number
    tokenSalaryInsights: number
    tokenLearnSkills: number
    tokenAchievements: number
    tokenInterview: number
    tokenWriter: number
    tokenOptimizeResume: number
    usedChromeExtension: boolean
    numUploadedResumes: number
    numStartedInterviews: number
    referralTokens: number
    hasSubscription: boolean
    isAdvisoryClient: boolean
    isAdvisoryOrgAccount: boolean
    profilePictureUrl?: string | null
    writingStyleEnum?: UsersWritingStyleEnum | null
    hasSeenGoldOnboarding: boolean
    hasCompletedOnboarding: boolean
    jobExperienceLevel?: JobListingExperienceLevelEnum | null
    targetJobTitle?: string | null
    createdAt: any
    location?: string | null
  }
}

export type UseUploadResume_ResumesQueryVariables = Exact<{ [key: string]: never }>

export type UseUploadResume_ResumesQuery = {
  __typename?: 'Query'
  resumes: Array<{ __typename?: 'Resumes'; id: string; name: string }>
}

export type UseUploadResume_RecentResumeUploadedMutationVariables = Exact<{ [key: string]: never }>

export type UseUploadResume_RecentResumeUploadedMutation = {
  __typename?: 'Mutation'
  resumeRecentUploaded?: { __typename?: 'Resumes'; id: string; name: string } | null
}

export type JobDetailsCard_CheckMatchLevelMutationVariables = Exact<{
  jobListingId: Scalars['ID']['input']
}>

export type JobDetailsCard_CheckMatchLevelMutation = {
  __typename?: 'Mutation'
  amIAGoodFit?: { __typename?: 'AmIAGoodFit'; overallMatch?: UsersJobsMatchEnum | null } | null
}

export type JobDetailsContainer_GetJobListingQueryVariables = Exact<{
  jobListingId: Scalars['ID']['input']
}>

export type JobDetailsContainer_GetJobListingQuery = {
  __typename?: 'Query'
  jobListing: {
    __typename?: 'JobListings'
    id: string
    aiCoreResponsibilities?: string | null
    aiWorkArrangement?: JobListingWorkArrangementEnum | null
    aiEducationRequirements?: Array<JobListingEducationLevelEnum> | null
    aiRequirementsSummary?: string | null
    benefits: Array<string>
    companyDescription?: string | null
    companyDomain?: string | null
    companyIndustry?: string | null
    companyNumEmployees?: number | null
    companySpecialties: Array<string>
    companyLinkedinUrl?: string | null
    companyLogoUrl?: string | null
    employmentType?: JobListingEmploymentTypeEnum | null
    jobDetails?: string | null
    keySkills: Array<string>
    visaSponsorship: boolean
    workingHours?: number | null
    experienceLevelString?: string | null
    hiringManagerEmail?: string | null
    hiringManagerName?: string | null
    position: string
    companyName: string
    url?: string | null
    datePosted: any
    isRemote?: boolean | null
    location?: string | null
    salaryMax?: number | null
    salaryMin?: number | null
    salaryCurrency?: string | null
    payPeriod?: JobListingPayPeriodEnum | null
  }
  hasAddedJobListing?: { __typename?: 'UsersJobs'; id: string; status: UsersJobsStatusEnum } | null
}

export type JobDetailsContainer_AddJobListingToBookmarksMutationVariables = Exact<{
  jobListingId: Scalars['ID']['input']
  status: UsersJobsStatusEnum
}>

export type JobDetailsContainer_AddJobListingToBookmarksMutation = {
  __typename?: 'Mutation'
  bookmarkJob: {
    __typename?: 'UsersJobs'
    id: string
    status: UsersJobsStatusEnum
    url?: string | null
  }
}

export type JobSearchBar_CreateSearchFilterMutationVariables = Exact<{
  name: Scalars['String']['input']
  searchFilters: JobListingsFilterInputObject
}>

export type JobSearchBar_CreateSearchFilterMutation = {
  __typename?: 'Mutation'
  createSearchFilter: {
    __typename?: 'JobListingSavedSearch'
    id: string
    name: string
    searchFilters: {
      __typename?: 'JobListingsFilter'
      positions?: Array<string> | null
      companyName?: string | null
      companyNumEmployeesMin?: number | null
      companyNumEmployeesMax?: number | null
      employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
      workArrangements?: Array<JobListingWorkArrangementEnum> | null
      experienceLevels?: Array<JobListingExperienceLevelEnum> | null
      educationRequirements?: Array<JobListingEducationLevelEnum> | null
      keywords?: Array<string> | null
      keywordOr?: boolean | null
      taxonomies?: Array<string> | null
      experienceLevelMin?: number | null
      experienceLevelMax?: number | null
      datePosted?: JobListingDatePostedEnum | null
      datePostedMin?: any | null
      datePostedMax?: any | null
      foundedDate?: JobListingFoundedDateEnum | null
      salaryMin?: number | null
      payPeriod?: JobListingPayPeriodEnum | null
      visaSponsorship?: boolean | null
      skills?: Array<string> | null
      locations?: Array<{
        __typename?: 'JobListingsLocation'
        location: string
        useCityStateForLocation?: boolean | null
        radius?: number | null
      }> | null
    }
  }
}

export type JobSearchBar_UpdateSearchFilterMutationVariables = Exact<{
  id: Scalars['ID']['input']
  searchFilters: JobListingsFilterInputObject
}>

export type JobSearchBar_UpdateSearchFilterMutation = {
  __typename?: 'Mutation'
  updateSearchFilter: {
    __typename?: 'JobListingSavedSearch'
    id: string
    name: string
    searchFilters: {
      __typename?: 'JobListingsFilter'
      positions?: Array<string> | null
      companyName?: string | null
      companyNumEmployeesMin?: number | null
      companyNumEmployeesMax?: number | null
      employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
      workArrangements?: Array<JobListingWorkArrangementEnum> | null
      experienceLevels?: Array<JobListingExperienceLevelEnum> | null
      educationRequirements?: Array<JobListingEducationLevelEnum> | null
      keywords?: Array<string> | null
      keywordOr?: boolean | null
      taxonomies?: Array<string> | null
      experienceLevelMin?: number | null
      experienceLevelMax?: number | null
      datePosted?: JobListingDatePostedEnum | null
      datePostedMin?: any | null
      datePostedMax?: any | null
      foundedDate?: JobListingFoundedDateEnum | null
      salaryMin?: number | null
      payPeriod?: JobListingPayPeriodEnum | null
      visaSponsorship?: boolean | null
      skills?: Array<string> | null
      locations?: Array<{
        __typename?: 'JobListingsLocation'
        location: string
        useCityStateForLocation?: boolean | null
        radius?: number | null
      }> | null
    }
  }
}

export type LocationSearchInput_LocationsTypeaheadQueryVariables = Exact<{
  location: Scalars['String']['input']
}>

export type LocationSearchInput_LocationsTypeaheadQuery = {
  __typename?: 'Query'
  locationsTypeahead: Array<string>
}

export type LocationSearchInput_UserStoreLocationMutationVariables = Exact<{
  city: Scalars['String']['input']
  state: Scalars['String']['input']
}>

export type LocationSearchInput_UserStoreLocationMutation = {
  __typename?: 'Mutation'
  userStoreLocation: { __typename?: 'Users'; id: string }
}

export type SavedFilters_SavedFiltersQueryVariables = Exact<{ [key: string]: never }>

export type SavedFilters_SavedFiltersQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    jobListingSavedSearches: Array<{
      __typename?: 'JobListingSavedSearch'
      id: string
      name: string
      searchFilters: {
        __typename?: 'JobListingsFilter'
        positions?: Array<string> | null
        companyName?: string | null
        companyNumEmployeesMin?: number | null
        companyNumEmployeesMax?: number | null
        employmentTypes?: Array<JobListingEmploymentTypeEnum> | null
        workArrangements?: Array<JobListingWorkArrangementEnum> | null
        experienceLevels?: Array<JobListingExperienceLevelEnum> | null
        educationRequirements?: Array<JobListingEducationLevelEnum> | null
        keywords?: Array<string> | null
        keywordOr?: boolean | null
        taxonomies?: Array<string> | null
        experienceLevelMin?: number | null
        experienceLevelMax?: number | null
        datePosted?: JobListingDatePostedEnum | null
        datePostedMin?: any | null
        datePostedMax?: any | null
        foundedDate?: JobListingFoundedDateEnum | null
        salaryMin?: number | null
        payPeriod?: JobListingPayPeriodEnum | null
        visaSponsorship?: boolean | null
        skills?: Array<string> | null
        locations?: Array<{
          __typename?: 'JobListingsLocation'
          location: string
          useCityStateForLocation?: boolean | null
          radius?: number | null
        }> | null
      }
    }>
  }
}

export type ResumeBuilderV2_UpdateResumeMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  attributes: ResumesInputObject
}>

export type ResumeBuilderV2_UpdateResumeMutation = {
  __typename?: 'Mutation'
  updateResume: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }
}

export type ResumeBuilderV2_UpdateResumePreferencesMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  attributes: ResumePreferencesInputObject
}>

export type ResumeBuilderV2_UpdateResumePreferencesMutation = {
  __typename?: 'Mutation'
  updateResumePreferences: { __typename?: 'Resumes'; id: string }
}

export type ResumeBuilderV2_UpdateResumeTourCompletedMutationVariables = Exact<{
  hasCompletedResumeTour: Scalars['Boolean']['input']
}>

export type ResumeBuilderV2_UpdateResumeTourCompletedMutation = {
  __typename?: 'Mutation'
  updateUser: { __typename?: 'Users'; id: string }
}

export type ResumeBuilderV2_ScoreResumeMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
}>

export type ResumeBuilderV2_ScoreResumeMutation = {
  __typename?: 'Mutation'
  scoreResume: {
    __typename?: 'ResumesScoreType'
    failed: number
    passed: number
    score: number
    total: number
    scoreFields: Array<{
      __typename?: 'ResumesScoreFieldType'
      didPass: boolean
      errorMessage?: string | null
      header: string
      sectionType: ResumeScoreSectionType
      tags?: Array<{
        __typename?: 'ResumesScoreFieldTagType'
        tagName: string
        tagLink: string
      }> | null
    }>
  }
}

export type ResumeBuilderV2_DownloadPdfMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
}>

export type ResumeBuilderV2_DownloadPdfMutation = {
  __typename?: 'Mutation'
  downloadPdfResume: { __typename?: 'Resumes'; id: string }
}

export type ViewerPanel_UpdateResumePdfBlobMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  pdfBlob: Array<Scalars['Int']['input']> | Scalars['Int']['input']
}>

export type ViewerPanel_UpdateResumePdfBlobMutation = {
  __typename?: 'Mutation'
  updatePdfBlob: { __typename?: 'Resumes'; id: string }
}

export type GenerateAchievementsMenu_GenerateOneJobAchievementFromStringMutationVariables = Exact<{
  achievementStrings: Array<Scalars['String']['input']> | Scalars['String']['input']
  customPrompt?: InputMaybe<Scalars['String']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
}>

export type GenerateAchievementsMenu_GenerateOneJobAchievementFromStringMutation = {
  __typename?: 'Mutation'
  generateJobAchievementFromString: Array<string>
}

export type GenerateProfessionalSummaryMenu_GenerateProfessionalSummaryMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  useExisting: Scalars['Boolean']['input']
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  customPrompt?: InputMaybe<Scalars['String']['input']>
}>

export type GenerateProfessionalSummaryMenu_GenerateProfessionalSummaryMutation = {
  __typename?: 'Mutation'
  generateProfessionalSummary: string
}

export type ResumeAnalyzerToolkitSection_AnalyzeResumeMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  jobTitle: Scalars['String']['input']
}>

export type ResumeAnalyzerToolkitSection_AnalyzeResumeMutation = {
  __typename?: 'Mutation'
  resumeRelevanceAnalysis: {
    __typename?: 'ResumesResumeRelevanceAnalysis'
    isSummaryRelevantForJobTitle: boolean
    relevantSummaryForJobTitle?: string | null
    suggestedSkillsForJobTitle: Array<string>
    originalSummary?: string | null
    irrelevantSkillsForJobTitle: Array<{
      __typename?: 'ResumesAnalysisSkillType'
      category?: string | null
      skill: string
    }>
    irrelevantAchievementsForJobTitle: Array<{
      __typename?: 'ResumesIrrelevantAchievementType'
      achievementIndex: number
      achievementType: ResumesResumeAchievementTypeEnum
      achievementTypeId: number
      companyName?: string | null
      irrelevantAchievementForJobTitle: string
      position?: string | null
      relevantAchievementForJobTitle: string
    }>
  }
}

export type ResumeAnalyzerToolkitSection_FixFromRelevanceAnalysisMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  achievementsToUpdate?: InputMaybe<
    Array<ResumesRelevantAchievementInputObject> | ResumesRelevantAchievementInputObject
  >
  skillsToAdd?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  skillsToRemove?: InputMaybe<
    Array<ResumesAnalysisSkillTypeInputObject> | ResumesAnalysisSkillTypeInputObject
  >
  summary?: InputMaybe<Scalars['String']['input']>
}>

export type ResumeAnalyzerToolkitSection_FixFromRelevanceAnalysisMutation = {
  __typename?: 'Mutation'
  fixFromRelevanceAnalysis: {
    __typename?: 'Resumes'
    id: string
    professionalSummary?: string | null
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
  }
}

export type ResumeAnalyzerToolkitSection_GetResumeQueryVariables = Exact<{
  resumeID: Scalars['ID']['input']
}>

export type ResumeAnalyzerToolkitSection_GetResumeQuery = {
  __typename?: 'Query'
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    tokenResumeAnalysis: number
    lastAnalyzedAt?: any | null
  }>
}

export type ResumeScorerTookitSection_ScoreResumeMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
}>

export type ResumeScorerTookitSection_ScoreResumeMutation = {
  __typename?: 'Mutation'
  scoreResume: {
    __typename?: 'ResumesScoreType'
    failed: number
    passed: number
    score: number
    total: number
    scoreFields: Array<{
      __typename?: 'ResumesScoreFieldType'
      didPass: boolean
      errorMessage?: string | null
      header: string
      sectionType: ResumeScoreSectionType
      tags?: Array<{
        __typename?: 'ResumesScoreFieldTagType'
        tagName: string
        tagLink: string
      }> | null
    }>
  }
}

export type ResumeBuilder_GetResumeQueryVariables = Exact<{
  resumeId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ResumeBuilder_GetResumeQuery = {
  __typename?: 'Query'
  resumes: Array<{
    __typename?: 'Resumes'
    id: string
    documentUrl?: string | null
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }>
}

export type ResumeBuilder_GetResumeUnauthenticatedQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ResumeBuilder_GetResumeUnauthenticatedQuery = {
  __typename?: 'Query'
  resumeUnauthenticated?: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  } | null
}

export type ResumeBuilder_GetClientResumeQueryVariables = Exact<{
  clientId: Scalars['ID']['input']
  resumeId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type ResumeBuilder_GetClientResumeQuery = {
  __typename?: 'Query'
  clientResumes: Array<{
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }>
}

export type ResumeBuilder_PublicResumeQueryVariables = Exact<{
  publicId: Scalars['ID']['input']
}>

export type ResumeBuilder_PublicResumeQuery = {
  __typename?: 'Query'
  publicResume?: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  } | null
}

export type ResumeBuilder_CreateResumeUnauthenticatedMutationVariables = Exact<{
  attributes?: InputMaybe<ResumesInputObject>
}>

export type ResumeBuilder_CreateResumeUnauthenticatedMutation = {
  __typename?: 'Mutation'
  createResumeUnauthenticated: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }
}

export type ResumeBuilder_UpdateResumeUnauthenticatedMutationVariables = Exact<{
  resumeUniqueId: Scalars['ID']['input']
  attributes: ResumesInputObject
}>

export type ResumeBuilder_UpdateResumeUnauthenticatedMutation = {
  __typename?: 'Mutation'
  updateResumeUnauthenticated: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }
}

export type ResumeBuilder_UpdateResumeMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
  attributes: ResumesInputObject
}>

export type ResumeBuilder_UpdateResumeMutation = {
  __typename?: 'Mutation'
  updateResume: {
    __typename?: 'Resumes'
    id: string
    uniqueId?: string | null
    createdAt: any
    updatedAt: any
    name: string
    archived: boolean
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    linkedinUrl?: string | null
    phoneNumber?: string | null
    professionalSummary?: string | null
    website?: string | null
    location?: string | null
    suggestedSkills: Array<string>
    documentUrl?: string | null
    documentType?: ResumeDocumentType | null
    showOriginalDocument: boolean
    hideEducations: boolean
    hideProjects: boolean
    hideSkills: boolean
    hideSummary: boolean
    hideCertifications: boolean
    hideWorkExperiences: boolean
    hideCourseworks: boolean
    hideInvolvements: boolean
    hideTargetTitle: boolean
    sectionsOrder: Array<ResumeSortableSections>
    targetTitle?: string | null
    template: ResumesTemplateEnum
    templateColorEnum?: ResumesTemplateColorEnum | null
    aiGenerated: boolean
    isPublic: boolean
    publicId: string
    tokenResumeAnalysis: number
    preferences: {
      __typename?: 'ResumesPreferences'
      dateFormat: ResumesDateFormatEnum
      fontFamily: ResumesFontFamilyEnum
      fontSize: ResumesFontSizeEnum
      horizontalMargin: ResumesHorizontalMarginEnum
      verticalMargin: ResumesVerticalMarginEnum
      lineHeight: ResumesLineHeightEnum
      pageSize: ResumesPageSizeEnum
      sectionTitleCasing: ResumesSectionTitleCasingEnum
      sectionsOrder: Array<ResumeSortableSections>
      sectionsOrderWithCustomSections: Array<string>
      template: ResumesTemplateEnum
      templateColorEnum?: ResumesTemplateColorEnum | null
      hideCertifications: boolean
      hideCourseworks: boolean
      hideEducations: boolean
      hideInvolvements: boolean
      hideProjects: boolean
      hideSkills: boolean
      hideSummary: boolean
      hideWorkExperiences: boolean
      hideTargetTitle: boolean
      avatar: {
        __typename?: 'ResumesAvatarPreferences'
        profilePictureEnabled: boolean
        profilePictureShape?: ResumesProfilePictureShapeEnum | null
      }
    }
    courseworks: Array<{
      __typename?: 'ResumesCoursework'
      id: string
      name?: string | null
      institutionName?: string | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnCourse: boolean
      showYearOnlyEndDate: boolean
    }>
    educations: Array<{
      __typename?: 'ResumesEducation'
      id: string
      additionalInformation?: string | null
      degree?: string | null
      endDate?: any | null
      startDate?: any | null
      gpa?: string | null
      institutionName: string
      location?: string | null
      currentlyInEducation: boolean
      achievements: Array<string>
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    involvements: Array<{
      __typename?: 'ResumesInvolvement'
      id: string
      name?: string | null
      organizationName?: string | null
      startDate?: any | null
      endDate?: any | null
      achievements: Array<string>
      currentlyWorkingOnInvolvement: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
    }>
    projects: Array<{
      __typename?: 'ResumesProject'
      id: string
      achievements: Array<string>
      name: string
      endDate?: any | null
      startDate?: any | null
      currentlyWorkingOnProject: boolean
      showYearOnlyEndDate: boolean
      showYearOnlyStartDate: boolean
      linkUrl?: string | null
    }>
    workExperiences: Array<{
      __typename?: 'ResumesWorkExperience'
      id: string
      companyDescription?: string | null
      companyName: string
      simpleAnalysis: Array<{
        __typename?: 'FieldMessageType'
        field: string
        errorMessage?: string | null
      }>
      workPositions: Array<{
        __typename?: 'ResumesWorkPosition'
        id: string
        achievements: Array<string>
        location?: string | null
        name: string
        startDate?: any | null
        endDate?: any | null
        currentlyInPosition: boolean
        showYearOnlyStartDate: boolean
        showYearOnlyEndDate: boolean
        simpleAnalysis: Array<{
          __typename?: 'FieldMessageType'
          field: string
          errorMessage?: string | null
        }>
      }>
    }>
    groupedSkills: Array<{
      __typename?: 'ResumesGroupedSkill'
      id: string
      category?: string | null
      skills: Array<string>
    }>
    simpleAnalysis: Array<{
      __typename?: 'FieldMessageType'
      field: string
      errorMessage?: string | null
    }>
    certifications: Array<{
      __typename?: 'ResumesCertification'
      id: string
      name: string
      completionDate?: any | null
      provider?: string | null
      showYearOnlyCompletionDate: boolean
    }>
    customSections: Array<{
      __typename?: 'ResumesCustomSection'
      id: string
      name: string
      customSectionExperiences: Array<{
        __typename?: 'ResumesCustomSectionExperience'
        id: string
        companyName?: string | null
        achievements: string
        currentlyInExperience: boolean
        endDate?: any | null
        location?: string | null
        name?: string | null
        showYearOnlyEndDate: boolean
        showYearOnlyStartDate: boolean
        startDate?: any | null
      }>
    }>
  }
}

export type ResumeBuilder_DownloadPdfMutationVariables = Exact<{
  resumeId: Scalars['ID']['input']
}>

export type ResumeBuilder_DownloadPdfMutation = {
  __typename?: 'Mutation'
  downloadPdfResume: { __typename?: 'Resumes'; id: string }
}

export type ResumeBuilder_ScoreResumeMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ResumeBuilder_ScoreResumeMutation = {
  __typename?: 'Mutation'
  scoreResume: {
    __typename?: 'ResumesScoreType'
    failed: number
    passed: number
    score: number
    total: number
    scoreFields: Array<{
      __typename?: 'ResumesScoreFieldType'
      didPass: boolean
      errorMessage?: string | null
      header: string
      sectionType: ResumeScoreSectionType
      tags?: Array<{
        __typename?: 'ResumesScoreFieldTagType'
        tagName: string
        tagLink: string
      }> | null
    }>
  }
}

export type Plan_SubscriptionSessionFetchMutationVariables = Exact<{
  sessionId: Scalars['ID']['input']
}>

export type Plan_SubscriptionSessionFetchMutation = {
  __typename?: 'Mutation'
  subscriptionsSessionFetch: string
}

export type Plan_CompleteOnboardingMutationVariables = Exact<{ [key: string]: never }>

export type Plan_CompleteOnboardingMutation = {
  __typename?: 'Mutation'
  updateUser: { __typename?: 'Users'; id: string; hasCompletedOnboarding: boolean }
}

export type Plan_RequestResumeSuccessMutationVariables = Exact<{
  id: Scalars['ID']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  sessionId: Scalars['ID']['input']
}>

export type Plan_RequestResumeSuccessMutation = {
  __typename?: 'Mutation'
  subscriptionsRequestResumeSuccess: string
}

type Properties<T> = Required<{
  [K in keyof T]: z.ZodType<T[K], any, T[K]>
}>

type definedNonNullAny = {}

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny => v !== undefined && v !== null

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v))

export const AdvisorSortEnumSchema = z.nativeEnum(AdvisorSortEnum)

export const AdvisoryOrganizationSubscriptionStatusEnumSchema = z.nativeEnum(
  AdvisoryOrganizationSubscriptionStatusEnum
)

export const AuthProviderTypeEnumSchema = z.nativeEnum(AuthProviderTypeEnum)

export const CoverLetterLengthEnumSchema = z.nativeEnum(CoverLetterLengthEnum)

export const CoverLetterToneEnumSchema = z.nativeEnum(CoverLetterToneEnum)

export const FakeJobConcernLevelEnumSchema = z.nativeEnum(FakeJobConcernLevelEnum)

export const HeadshotRequestsAttireEnumSchema = z.nativeEnum(HeadshotRequestsAttireEnum)

export const HeadshotRequestsBackgroundEnumSchema = z.nativeEnum(HeadshotRequestsBackgroundEnum)

export const HeadshotRequestsStatusEnumSchema = z.nativeEnum(HeadshotRequestsStatusEnum)

export const InterviewsStatusEnumSchema = z.nativeEnum(InterviewsStatusEnum)

export const InterviewsTypeEnumSchema = z.nativeEnum(InterviewsTypeEnum)

export const JobListingDatePostedEnumSchema = z.nativeEnum(JobListingDatePostedEnum)

export const JobListingEducationLevelEnumSchema = z.nativeEnum(JobListingEducationLevelEnum)

export const JobListingEmploymentTypeEnumSchema = z.nativeEnum(JobListingEmploymentTypeEnum)

export const JobListingExperienceLevelEnumSchema = z.nativeEnum(JobListingExperienceLevelEnum)

export const JobListingFoundedDateEnumSchema = z.nativeEnum(JobListingFoundedDateEnum)

export const JobListingPayPeriodEnumSchema = z.nativeEnum(JobListingPayPeriodEnum)

export const JobListingWorkArrangementEnumSchema = z.nativeEnum(JobListingWorkArrangementEnum)

export const JobListingsSortEnumSchema = z.nativeEnum(JobListingsSortEnum)

export const JobPostingSortEnumSchema = z.nativeEnum(JobPostingSortEnum)

export const MessagesContactTypeSchema = z.nativeEnum(MessagesContactType)

export const MessagesMessageTypeSchema = z.nativeEnum(MessagesMessageType)

export const ResumeDocumentTypeSchema = z.nativeEnum(ResumeDocumentType)

export const ResumeScoreSectionTypeSchema = z.nativeEnum(ResumeScoreSectionType)

export const ResumeSortableSectionsSchema = z.nativeEnum(ResumeSortableSections)

export const ResumesDateFormatEnumSchema = z.nativeEnum(ResumesDateFormatEnum)

export const ResumesFontFamilyEnumSchema = z.nativeEnum(ResumesFontFamilyEnum)

export const ResumesFontSizeEnumSchema = z.nativeEnum(ResumesFontSizeEnum)

export const ResumesHorizontalMarginEnumSchema = z.nativeEnum(ResumesHorizontalMarginEnum)

export const ResumesLineHeightEnumSchema = z.nativeEnum(ResumesLineHeightEnum)

export const ResumesPageSizeEnumSchema = z.nativeEnum(ResumesPageSizeEnum)

export const ResumesProfilePictureShapeEnumSchema = z.nativeEnum(ResumesProfilePictureShapeEnum)

export const ResumesResumeAchievementTypeEnumSchema = z.nativeEnum(ResumesResumeAchievementTypeEnum)

export const ResumesSectionTitleCasingEnumSchema = z.nativeEnum(ResumesSectionTitleCasingEnum)

export const ResumesTemplateColorEnumSchema = z.nativeEnum(ResumesTemplateColorEnum)

export const ResumesTemplateEnumSchema = z.nativeEnum(ResumesTemplateEnum)

export const ResumesVerticalMarginEnumSchema = z.nativeEnum(ResumesVerticalMarginEnum)

export const RoastRoleTypeEnumSchema = z.nativeEnum(RoastRoleTypeEnum)

export const RoastToneLevelEnumSchema = z.nativeEnum(RoastToneLevelEnum)

export const SimilarProfilesMatchTypeEnumSchema = z.nativeEnum(SimilarProfilesMatchTypeEnum)

export const SortByDirectionEnumSchema = z.nativeEnum(SortByDirectionEnum)

export const SubscriptionPlanEnumSchema = z.nativeEnum(SubscriptionPlanEnum)

export const UsersJobsActivityTypeEnumSchema = z.nativeEnum(UsersJobsActivityTypeEnum)

export const UsersJobsAppliedChecklistEnumSchema = z.nativeEnum(UsersJobsAppliedChecklistEnum)

export const UsersJobsChecklistEnumSchema = z.nativeEnum(UsersJobsChecklistEnum)

export const UsersJobsInterviewChecklistEnumSchema = z.nativeEnum(UsersJobsInterviewChecklistEnum)

export const UsersJobsInterviewStepEnumSchema = z.nativeEnum(UsersJobsInterviewStepEnum)

export const UsersJobsMatchEnumSchema = z.nativeEnum(UsersJobsMatchEnum)

export const UsersJobsPayPeriodEnumSchema = z.nativeEnum(UsersJobsPayPeriodEnum)

export const UsersJobsRejectedStageEnumSchema = z.nativeEnum(UsersJobsRejectedStageEnum)

export const UsersJobsStatusEnumSchema = z.nativeEnum(UsersJobsStatusEnum)

export const UsersJobsWishlistChecklistEnumSchema = z.nativeEnum(UsersJobsWishlistChecklistEnum)

export const UsersRoleEnumSchema = z.nativeEnum(UsersRoleEnum)

export const UsersWritingStyleEnumSchema = z.nativeEnum(UsersWritingStyleEnum)

export function ContactsInputObjectSchema(): z.ZodObject<Properties<ContactsInputObject>> {
  return z.object({
    email: z.string(),
    name: z.string(),
  })
}

export function JobListingsFilterInputObjectSchema(): z.ZodObject<
  Properties<JobListingsFilterInputObject>
> {
  return z.object({
    companyName: z.string().nullish(),
    companyNumEmployeesMax: z.number().nullish(),
    companyNumEmployeesMin: z.number().nullish(),
    datePosted: JobListingDatePostedEnumSchema.nullish(),
    datePostedMax: definedNonNullAnySchema.nullish(),
    datePostedMin: definedNonNullAnySchema.nullish(),
    educationRequirements: z.array(JobListingEducationLevelEnumSchema).nullish(),
    employmentTypes: z.array(JobListingEmploymentTypeEnumSchema).nullish(),
    experienceLevelMax: z.number().nullish(),
    experienceLevelMin: z.number().nullish(),
    experienceLevels: z.array(JobListingExperienceLevelEnumSchema).nullish(),
    foundedDate: JobListingFoundedDateEnumSchema.nullish(),
    keywordOr: z.boolean().nullish(),
    keywords: z.array(z.string()).nullish(),
    locations: z.array(z.lazy(() => JobListingsLocationInputObjectSchema())).nullish(),
    payPeriod: JobListingPayPeriodEnumSchema.nullish(),
    positions: z.array(z.string()).nullish(),
    salaryMin: z.number().nullish(),
    skills: z.array(z.string()).nullish(),
    taxonomies: z.array(z.string()).nullish(),
    visaSponsorship: z.boolean().nullish(),
    workArrangements: z.array(JobListingWorkArrangementEnumSchema).nullish(),
  })
}

export function JobListingsLocationInputObjectSchema(): z.ZodObject<
  Properties<JobListingsLocationInputObject>
> {
  return z.object({
    location: z.string(),
    radius: z.number().nullish(),
    useCityStateForLocation: z.boolean().nullish(),
  })
}

export function JobSearchPreferenceInputObjectSchema(): z.ZodObject<
  Properties<JobSearchPreferenceInputObject>
> {
  return z.object({
    companyNumEmployeesMax: z.number().nullish(),
    companyNumEmployeesMin: z.number().nullish(),
    datePosted: JobListingDatePostedEnumSchema.nullish(),
    educationRequirement: JobListingEducationLevelEnumSchema.nullish(),
    employmentTypes: z.array(JobListingEmploymentTypeEnumSchema).nullish(),
    experienceLevels: z.array(JobListingExperienceLevelEnumSchema).nullish(),
    keywords: z.array(z.string()).nullish(),
    locations: z.array(z.string()).nullish(),
    payPeriod: JobListingPayPeriodEnumSchema.nullish(),
    positions: z.array(z.string()).nullish(),
    salaryMin: z.number().nullish(),
    visaSponsorship: z.boolean().nullish(),
    workArrangements: z.array(JobListingWorkArrangementEnumSchema).nullish(),
  })
}

export function ResumePreferencesInputObjectSchema(): z.ZodObject<
  Properties<ResumePreferencesInputObject>
> {
  return z.object({
    dateFormat: ResumesDateFormatEnumSchema.nullish(),
    fontFamily: ResumesFontFamilyEnumSchema.nullish(),
    fontSize: ResumesFontSizeEnumSchema.nullish(),
    hideCertifications: z.boolean().nullish(),
    hideCourseworks: z.boolean().nullish(),
    hideEducations: z.boolean().nullish(),
    hideInvolvements: z.boolean().nullish(),
    hideProjects: z.boolean().nullish(),
    hideSkills: z.boolean().nullish(),
    hideSummary: z.boolean().nullish(),
    hideTargetTitle: z.boolean().nullish(),
    hideWorkExperiences: z.boolean().nullish(),
    horizontalMargin: ResumesHorizontalMarginEnumSchema.nullish(),
    lineHeight: ResumesLineHeightEnumSchema.nullish(),
    pageSize: ResumesPageSizeEnumSchema.nullish(),
    sectionTitleCasing: ResumesSectionTitleCasingEnumSchema.nullish(),
    sectionsOrder: z.array(ResumeSortableSectionsSchema).nullish(),
    sectionsOrderWithCustomSections: z.array(z.string()).nullish(),
    template: ResumesTemplateEnumSchema.nullish(),
    templateColorEnum: ResumesTemplateColorEnumSchema.nullish(),
    verticalMargin: ResumesVerticalMarginEnumSchema.nullish(),
  })
}

export function ResumesAnalysisSkillTypeInputObjectSchema(): z.ZodObject<
  Properties<ResumesAnalysisSkillTypeInputObject>
> {
  return z.object({
    category: z.string(),
    skill: z.string(),
  })
}

export function ResumesCertificationInputObjectSchema(): z.ZodObject<
  Properties<ResumesCertificationInputObject>
> {
  return z.object({
    completionDate: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    name: z.string(),
    provider: z.string().nullish(),
    showYearOnlyCompletionDate: z.boolean().nullish(),
  })
}

export function ResumesCourseworkInputObjectSchema(): z.ZodObject<
  Properties<ResumesCourseworkInputObject>
> {
  return z.object({
    achievements: z.array(z.string()),
    currentlyWorkingOnCourse: z.boolean().nullish(),
    endDate: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    institutionName: z.string().nullish(),
    name: z.string().nullish(),
    showYearOnlyEndDate: z.boolean().nullish(),
  })
}

export function ResumesCustomSectionExperienceInputObjectSchema(): z.ZodObject<
  Properties<ResumesCustomSectionExperienceInputObject>
> {
  return z.object({
    achievements: z.string(),
    companyName: z.string().nullish(),
    currentlyInExperience: z.boolean().nullish(),
    endDate: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    location: z.string().nullish(),
    name: z.string().nullish(),
    showYearOnlyEndDate: z.boolean().nullish(),
    showYearOnlyStartDate: z.boolean().nullish(),
    startDate: definedNonNullAnySchema.nullish(),
  })
}

export function ResumesCustomSectionInputObjectSchema(): z.ZodObject<
  Properties<ResumesCustomSectionInputObject>
> {
  return z.object({
    customSectionExperiencesAttributes: z.array(
      z.lazy(() => ResumesCustomSectionExperienceInputObjectSchema())
    ),
    id: z.string().nullish(),
    name: z.string(),
  })
}

export function ResumesEducationInputObjectSchema(): z.ZodObject<
  Properties<ResumesEducationInputObject>
> {
  return z.object({
    achievements: z.array(z.string()).nullish(),
    additionalInformation: z.string().nullish(),
    currentlyInEducation: z.boolean().nullish(),
    degree: z.string().nullish(),
    endDate: definedNonNullAnySchema.nullish(),
    gpa: z.string().nullish(),
    id: z.string().nullish(),
    institutionName: z.string(),
    location: z.string().nullish(),
    showYearOnlyEndDate: z.boolean().nullish(),
    showYearOnlyStartDate: z.boolean().nullish(),
    startDate: definedNonNullAnySchema.nullish(),
  })
}

export function ResumesGroupedSkillInputObjectSchema(): z.ZodObject<
  Properties<ResumesGroupedSkillInputObject>
> {
  return z.object({
    category: z.string().nullish(),
    id: z.string().nullish(),
    skills: z.array(z.string()),
  })
}

export function ResumesInputObjectSchema(): z.ZodObject<Properties<ResumesInputObject>> {
  return z.object({
    certificationsAttributes: z.array(z.lazy(() => ResumesCertificationInputObjectSchema())),
    courseworksAttributes: z.array(z.lazy(() => ResumesCourseworkInputObjectSchema())),
    customSectionsAttributes: z
      .array(z.lazy(() => ResumesCustomSectionInputObjectSchema()))
      .nullish(),
    educationsAttributes: z.array(z.lazy(() => ResumesEducationInputObjectSchema())),
    email: z.string().nullish(),
    firstName: z.string().nullish(),
    groupedSkillsAttributes: z.array(z.lazy(() => ResumesGroupedSkillInputObjectSchema())),
    hideCertifications: z.boolean().nullish(),
    hideCourseworks: z.boolean().nullish(),
    hideEducations: z.boolean().nullish(),
    hideInvolvements: z.boolean().nullish(),
    hideProjects: z.boolean().nullish(),
    hideSkills: z.boolean().nullish(),
    hideSummary: z.boolean().nullish(),
    hideTargetTitle: z.boolean().nullish(),
    hideWorkExperiences: z.boolean().nullish(),
    involvementsAttributes: z.array(z.lazy(() => ResumesInvolvementInputObjectSchema())),
    lastName: z.string().nullish(),
    linkedinUrl: z.string().nullish(),
    location: z.string().nullish(),
    name: z.string().nullish(),
    phoneNumber: z.string().nullish(),
    professionalSummary: z.string().nullish(),
    profilePictureEnabled: z.boolean().nullish(),
    profilePictureShape: ResumesProfilePictureShapeEnumSchema.nullish(),
    projectsAttributes: z.array(z.lazy(() => ResumesProjectInputObjectSchema())),
    sectionsOrder: z.array(ResumeSortableSectionsSchema).nullish(),
    targetTitle: z.string().nullish(),
    website: z.string().nullish(),
    workExperiencesAttributes: z.array(z.lazy(() => ResumesWorkExperienceInputObjectSchema())),
  })
}

export function ResumesInvolvementInputObjectSchema(): z.ZodObject<
  Properties<ResumesInvolvementInputObject>
> {
  return z.object({
    achievements: z.array(z.string()),
    currentlyWorkingOnInvolvement: z.boolean().nullish(),
    endDate: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    organizationName: z.string().nullish(),
    showYearOnlyEndDate: z.boolean().nullish(),
    showYearOnlyStartDate: z.boolean().nullish(),
    startDate: definedNonNullAnySchema.nullish(),
  })
}

export function ResumesProjectInputObjectSchema(): z.ZodObject<
  Properties<ResumesProjectInputObject>
> {
  return z.object({
    achievements: z.array(z.string()),
    currentlyWorkingOnProject: z.boolean().nullish(),
    endDate: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    linkUrl: z.string().nullish(),
    name: z.string(),
    showYearOnlyEndDate: z.boolean().nullish(),
    showYearOnlyStartDate: z.boolean().nullish(),
    startDate: definedNonNullAnySchema.nullish(),
  })
}

export function ResumesRelevantAchievementInputObjectSchema(): z.ZodObject<
  Properties<ResumesRelevantAchievementInputObject>
> {
  return z.object({
    achievementIndex: z.number(),
    achievementType: ResumesResumeAchievementTypeEnumSchema,
    achievementTypeId: z.string(),
    relevantAchievementForJobTitle: z.string(),
  })
}

export function ResumesWorkExperienceInputObjectSchema(): z.ZodObject<
  Properties<ResumesWorkExperienceInputObject>
> {
  return z.object({
    companyDescription: z.string().nullish(),
    companyName: z.string(),
    id: z.string().nullish(),
    workPositionsAttributes: z.array(z.lazy(() => ResumesWorkPositionInputObjectSchema())),
  })
}

export function ResumesWorkPositionInputObjectSchema(): z.ZodObject<
  Properties<ResumesWorkPositionInputObject>
> {
  return z.object({
    achievements: z.array(z.string()),
    currentlyInPosition: z.boolean().nullish(),
    endDate: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    location: z.string().nullish(),
    name: z.string(),
    showYearOnlyEndDate: z.boolean().nullish(),
    showYearOnlyStartDate: z.boolean().nullish(),
    startDate: definedNonNullAnySchema.nullish(),
  })
}

export function SimilarProfilesEducationInputObjectSchema(): z.ZodObject<
  Properties<SimilarProfilesEducationInputObject>
> {
  return z.object({
    degree: z.string().nullish(),
    endDate: z.string().nullish(),
    fieldOfStudy: z.string().nullish(),
    school: z.string(),
    startDate: z.string().nullish(),
  })
}

export function SimilarProfilesExperienceInputObjectSchema(): z.ZodObject<
  Properties<SimilarProfilesExperienceInputObject>
> {
  return z.object({
    company: z.string(),
    companyLinkedinProfileUrl: z.string().nullish(),
    companyLogoUrl: z.string().nullish(),
    endDate: z.string().nullish(),
    location: z.string().nullish(),
    startDate: z.string().nullish(),
    title: z.string(),
  })
}

export function SimilarProfilesInputObjectSchema(): z.ZodObject<
  Properties<SimilarProfilesInputObject>
> {
  return z.object({
    education: z.array(z.lazy(() => SimilarProfilesEducationInputObjectSchema())),
    experience: z.array(z.lazy(() => SimilarProfilesExperienceInputObjectSchema())),
    fullName: z.string(),
    linkedinProfilePictureUrl: z.string().nullish(),
    linkedinUrl: z.string(),
    occupation: z.string(),
  })
}

export function UsersInputObjectSchema(): z.ZodObject<Properties<UsersInputObject>> {
  return z.object({
    certificationsAttributes: z
      .array(z.lazy(() => ResumesCertificationInputObjectSchema()))
      .nullish(),
    courseworksAttributes: z.array(z.lazy(() => ResumesCourseworkInputObjectSchema())).nullish(),
    educationsAttributes: z.array(z.lazy(() => ResumesEducationInputObjectSchema())).nullish(),
    enableJobNotifications: z.boolean().nullish(),
    enableJobRecommendationsNotifications: z.boolean().nullish(),
    firstName: z.string().nullish(),
    groupedSkillsAttributes: z
      .array(z.lazy(() => ResumesGroupedSkillInputObjectSchema()))
      .nullish(),
    hasCompletedOnboarding: z.boolean().nullish(),
    hasCompletedResumeTour: z.boolean().nullish(),
    hasSeenGoldOnboarding: z.boolean().nullish(),
    involvementsAttributes: z.array(z.lazy(() => ResumesInvolvementInputObjectSchema())).nullish(),
    jobExperienceLevel: JobListingExperienceLevelEnumSchema.nullish(),
    lastName: z.string().nullish(),
    linkedinUrl: z.string().nullish(),
    location: z.string().nullish(),
    phoneNumber: z.string().nullish(),
    projectsAttributes: z.array(z.lazy(() => ResumesProjectInputObjectSchema())).nullish(),
    targetJobTitle: z.string().nullish(),
    website: z.string().nullish(),
    workExperiencesAttributes: z
      .array(z.lazy(() => ResumesWorkExperienceInputObjectSchema()))
      .nullish(),
  })
}

export function UsersJobsCoverLetterInputObjectSchema(): z.ZodObject<
  Properties<UsersJobsCoverLetterInputObject>
> {
  return z.object({
    body: z.string().nullish(),
    candidateAddress: z.string().nullish(),
    companyLocation: z.string().nullish(),
    companyName: z.string().nullish(),
    email: z.string().nullish(),
    firstName: z.string().nullish(),
    footer: z.string().nullish(),
    lastName: z.string().nullish(),
    phoneNumber: z.string().nullish(),
  })
}
